<div class="container-fluid mt-4 supplier-data-wrapper">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="companyExist == true">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4">
        <button class="btn btn-green btn-defBlue p-2 btn-ht mr-20 fw-400 homebutton"
          (click)="navigateToHome()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (navigateToHome())">
          <span>
            <mat-icon svgIcon="home" alt="" class="iconspace"></mat-icon>
          </span>
          <span class="float-right"> ISA Home </span>
        </button>
        <button class="btn btn-green btn-defBlue p-2 mr-20 fw-400 h-43" (click)="sendToBuyers()"
          [disabled]="isSendToBuyerInProgress"
          *ngIf="shouldShowSendToBuyerButton()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sendToBuyers())">
          <span>
            <mat-icon svgIcon="mail" alt="" class="iconspace mail-icon"> </mat-icon>
          </span>
          <span class="float-right pt-2"> Send to Buyer </span>
        </button>
      </div>
      <div class="center col-4"><img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png" class="maxw-40"
          alt="edit" /></div>
      <div class="col-4 icon-align text-right">
        <div class="row">
          <app-helpsection></app-helpsection>
          <button *ngIf="!showForSupplier" class="home home-btn-bg" (click)="navigateToHome()" title="Home"
            data-toggle="tooltip" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (navigateToHome())">
            <mat-icon svgIcon="home" width="17" height="15" alt="edit" class="vam-middle"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <button class="edit opened_all cancel" (click)="closeAllSections()" (keydown.enter)="closeAllSections()"
      (keydown.space)="closeAllSections()" tabindex="0" id="openAllSection" *ngIf="showBoxDownForAllSec">
      <mat-icon svgIcon="downarrow" class="pos-abs ml-n23 mt-10" alt=""></mat-icon>
      <mat-icon svgIcon="downarrow" class="ml-n23" alt=""></mat-icon>
    </button>
    <div class="row m-0">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 marginupdown">
        <button class="edit cancel" (click)="acc('group')" (keydown.enter)="acc('group')" (keydown.space)="acc('group')"
          tabindex="0" *ngIf="showBoxDownGroup">
          <mat-icon svgIcon="downarrow" class="collapsed down_arrow pos-abs ml-n37 mt-10 cancel" alt=""></mat-icon>
        </button>
        <button class="edit opened_group cancel" (click)="acc('group')" (keydown.enter)="acc('group')"
          (keydown.space)="acc('group')" tabindex="0" *ngIf="!showBoxDownGroup">
          <mat-icon svgIcon="downarrow" class="collapsed pos-abs ml-n37 mt-10 cancel" alt=""></mat-icon>
        </button>
        <div class="backblue">
          <h5 class="font-weight-normal col">
            GROUP&nbsp;:&nbsp;<span class="font-weight-bold">
              <a class="text-white"
                [routerLink]="['/supplier-group-details', GroupAssign ? GroupAssign.groupId : '']">{{
                GroupAssign ? GroupAssign.groupName : ""
                }}</a></span>&nbsp;
          </h5>
        </div>
        &nbsp;&nbsp;
        <section class="border-bottom-yellow opened_group maxh-310 auto-h" id="openAllBoxgroup">
          <div class="row m-0 align-center">
            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 p-0 pt-2">
              <h4 class="title ml-8">GENERAL INFORMATION</h4>
            </div>

            <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 p-0 text-right pr-15 mt-15">
              <div class="row justify-content-end align-items-center px-3 pt-3">
                <div class="d-flex flex-wrap">
                  <button class="btn btn-custom btn-darkred" *ngIf="roleVariableHide" data-toggle="modal"
                    data-target="#ChangeGrp" (click)="LoadGrpingType()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (LoadGrpingType())">
                    <span>
                      <mat-icon svgIcon="edit" class="img-btn" alt=""></mat-icon>
                      <span class="float-right">Update Group link</span>
                    </span>
                  </button>
                  <button class="btn btn-custom btn-blue ml-1" data-toggle="modal" data-target="#GroupingState"
                    (click)="showGroupingState()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (showGroupingState())">
                    <span>
                      <mat-icon svgIcon="calendercharge" class="img-btn img-btn-xl mb-1" alt=""></mat-icon>
                      <span class="float-right">Grouping State</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" *ngIf="GroupLoadin == true">
            <img src="assets/images/loading.gif" alt="loading..." />
          </div>
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 pl-32">
            <ng-container *ngIf="GroupAssign">
              <div class="mb-2 row">
                <div class="font-weight-bold">Group ID :</div>
                <div class="pl-1" id="boldGroup">{{ GroupAssign ? bolding(GroupAssign.groupAllianceIdentifier,
                  "boldGroup") : "" }}</div>
                <button class="pl-1 edit d-flex align-center cancel" id="boldGroupIcon" *ngIf="GroupAssign">
                  <mat-icon svgIcon="speechcomment" alt="copy"
                    (click)="copyToClipboard(GroupAssign.groupAllianceIdentifier)"
                    (keydown.enter)="copyToClipboard(GroupAssign.groupAllianceIdentifier)"
                    (keydown.space)="copyToClipboard(GroupAssign.groupAllianceIdentifier)" tabindex="0"
                    [matTooltip]="'Copy'" [ngStyle]="{ cursor: 'pointer' }" [matTooltipPosition]="'above'"></mat-icon>
                </button>
              </div>
              <p class="mb-2 row">
                <span class="font-weight-bold">Group Category :</span>
                <span class="pl-1">{{ GroupAssign ? GroupAssign.GroupCategory : "" }}</span>
              </p>
              <p class="mb-2 row">
                <span class="font-weight-bold">Group Status : </span>
                <span class="group-status pl-3 pr-3" *ngIf="GroupAssign.apoStatus"
                  [ngStyle]="{ background: colorsGroup[GroupAssign.apoStatus2] ? colorsGroup[GroupAssign.apoStatus2] : 'grey' }">
                  {{ statusDisplay.replace("PENDING_VALIDATION", "PENDING").replace("VALIDATED", "ACTIVE").replace("ACTIVE", "Active") }}</span>
                <span class="font-weight-bold">
                  {{ grpDate }}
                </span>
              </p>
              <p class="mb-2 row" *ngIf="groupAlias && groupAlias.length > 0">
                <ng-container *ngFor="let groupAlia of groupAlias">
                  <span class="font-weight-bold">{{ groupAlia.groupIdentifierKeyName.replace("MDM GROUP", "Group Short
                    Name") }}:</span>
                  <span class="pl-1">{{ groupAlia.value }}</span>
                </ng-container>
              </p>
              <p class="mb-2 row" *ngIf="showForSupplier == true">
                <span class="font-weight-bold">BVD ID :</span>
                <span class="pl-1">{{ groupbvdIDcpy ? groupbvdIDcpy : "--" }}</span>
                <span class="pl-1" *ngIf="bvdloading == true"><img src="assets/images/loading.gif"
                    alt="Updating..." /></span>
                <ng-container *ngIf="groupbvdIDcpy && showForConsult == true && showForSupplier == true">
                  <span class="pl-1">
                    <label class="switch m-0">
                      <input type="checkbox" id="sliderCheckBox1"
                        [disabled]="roleVariableHide == false || inPortfolioLoading1 == true"
                        (change)="toggleInPortfolioSwitch1($event)" title="In Portfolio" />
                      <span class="slider round" id="clickForSliderJ1"></span> </label>&nbsp;</span>
                  <span>({{ countValue1 }})</span>
                  <span class="pl-1" *ngIf="inPortfolioLoading1 == true"><img src="assets/images/loading.gif"
                      alt="Updating..." /></span>
                </ng-container>
              </p>
            </ng-container>
          </div>
        </section>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 marginupdown ">
        <button class="edit cancel" (click)="acc('comp')" (keydown.enter)="acc('comp')" (keydown.space)="acc('comp')"
          tabindex="0" *ngIf="showBoxDowncompany">
          <mat-icon svgIcon="downarrow" class="collapsed down_arrow pos-abs ml-n37 mt-10" alt=""></mat-icon>
        </button>
        <button class="edit opened_group cancel" (click)="acc('comp')" (keydown.enter)="acc('comp')"
          (keydown.space)="acc('comp')" tabindex="0" *ngIf="!showBoxDowncompany">
          <mat-icon svgIcon="downarrow" class="collapsed pos-abs ml-n37 mt-10" alt=""></mat-icon>
        </button>
        <div class="backdarkblue margindown">
          <h5 class="font-weight-normal col">
            COMPANY&nbsp;:&nbsp;<span class="font-weight-bold">{{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
              <button *ngIf="roleVariableHide" data-toggle="modal" data-target="#companynameModalPopup"
                (click)="updateCompanyExistsName()" (keydown.enter)="updateCompanyExistsName()"
                (keydown.space)="updateCompanyExistsName()" tabindex="0" class="edit cancel whitecolor">
                <mat-icon svgIcon="edit" alt="edit"></mat-icon>
              </button>
          </h5>
        </div>
        <div class="opened_group" id="openAllBoxcompany">
          <section class="border-bottom-yellow maxh-350 auto-h">
            <div>
              <div class="row m-0 align-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 p-0 px-2 pt-2">
                  <h4 class="title ml-8">GENERAL INFORMATION</h4>
                </div>
                <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 p-2 px-2 text-right pr-15 mt-15">
                  <button type="button" *ngIf="roleVariableHide && sitebvidid != ''"
                    class="btn btn-custom btn-darkred left-6" data-target="#ChangeGuo" data-toggle="modal"
                    (click)="LoadGuo()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (LoadGuo())">
                    Check GUO
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-32" *ngIf="companyBasicInfo">
              <div class="mb-2 row">
                <div class="font-weight-bold">Company ID :</div>
                <div class="pl-1" id="bold1-0">
                  {{ companyBasicInfo ? bolding(companyBasicInfo["allianceIdentifier"], "bold1-0") : "" }}
                </div>
                <button class="pl-1 edit d-flex align-center cancel" id="boldCompanyIcon" *ngIf="companyBasicInfo">
                  <mat-icon svgIcon="speechcomment" alt="copy"
                    (click)="copyToClipboard(companyBasicInfo['allianceIdentifier'])"
                    (keydown.enter)="copyToClipboard(companyBasicInfo['allianceIdentifier'])"
                    (keydown.space)="copyToClipboard(companyBasicInfo['allianceIdentifier'])" tabindex="0"
                    [matTooltip]="'Copy'" [matTooltipPosition]="'above'"></mat-icon>
                </button>
              </div>
              <div class="mb-2 row">
                <div class="status-container">
                  <div class="font-weight-bold">Company Status :</div>
                  <div class="grouppill-status"
                    *ngIf="companyBasicInfo && companyBasicInfo.companyStatusCode != '' && companyBasicInfo.companyStatusCode != undefined"
                    [ngStyle]="{
                      background: colors[companyBasicInfo.companyStatusCode.toLowerCase()]
                        ? colors[companyBasicInfo.companyStatusCode.toLowerCase()]
                        : 'grey'
                    }">
                    {{ companyBasicInfo.companyStatusCode }}
                  </div>
                  <button *ngIf="roleVariableHide" data-toggle="modal" data-target="#companyStatusPopup"
                    (click)="FetchExistStatus(companyBasicInfo.companyStatusCode)"
                    (keydown.enter)="FetchExistStatus(companyBasicInfo.companyStatusCode)"
                    (keydown.space)="FetchExistStatus(companyBasicInfo.companyStatusCode)" tabindex="0"
                    class="edit cancel">
                    <mat-icon svgIcon="edit" alt="edit"></mat-icon>
                  </button>
                  <mat-icon *ngIf="roleVariableHide" svgIcon="file-reload" class="img-btn pl-1 edit cancel"
                    data-target="#openblankStatusUpdate" data-toggle="modal"></mat-icon>
                  <div *ngIf="(roleVariableHide || superUserShow) && companyBasicInfo.companyStatusCode == 'Registered'"
                    class="font-weight-bold px-2">
                    {{ MDMSynchroModeValue }}
                  </div>
                  <div class="font-weight-bold pl-4">
                    {{ dateDisplay }}
                  </div>
                </div>
              </div>
              <div class="mb-2 row" *ngIf="
                  roleVariableHide ||
                  (companyBasicInfo && companyBasicInfo['workflowStatus'] && companyBasicInfo['workflowStatus'] !== 'NotStarted')
                ">
                <div class="status-container">
                  <div class="font-weight-bold">Workflow Status :</div>
                  <div class="grouppill-status" *ngIf="companyBasicInfo && companyBasicInfo['workflowStatus']"
                    [ngStyle]="{ background: workflowStatusColors[companyBasicInfo['workflowStatus']] || '#D8C4A0' }">
                    {{ companyBasicInfo["workflowStatus"] }}
                  </div>
                  <button *ngIf="roleVariableHide" data-toggle="modal" data-target="#editCompanyWorkflowStatusModal"
                    (click)="openCompanyWorkflowStatusModal()" (keydown.enter)="openCompanyWorkflowStatusModal()"
                    (keydown.space)="openCompanyWorkflowStatusModal()" tabindex="0" class="edit cancel">
                    <mat-icon svgIcon="edit" alt="edit"></mat-icon>
                  </button>
                </div>
              </div>
              <div class="mb-0 row">
                <div class="font-weight-bold">Company Short Name :</div>
                <div class="pl-1">{{ companyShortName ? companyShortName : "" }}</div>
                <button class="edit pl-2 cancel" *ngIf="roleVariableHide" (click)="loadShortName()"
                  (keydown.enter)="loadShortName()" (keydown.space)="loadShortName()" tabindex="0"
                  data-target="#openShortNameEdit" data-toggle="modal">
                  <mat-icon svgIcon="edit" alt="edit"></mat-icon>
                </button>
              </div>
              <div class="mb-2 row" *ngIf="showForSupplier && showBuyerProfile == true">
                <div class="status-container">
                  <div class="font-weight-bold">BvD ID :</div>
                  <div class="pl-1">{{ sitebvidid ? sitebvidid : "--" }}</div>
                  <div *ngIf="showArchivedBvdId == true && sitebvidid != ''">
                    <div class="grouppill-status px-3 py-1" [ngStyle]="{ background: '#CB4B32' }">Archived</div>
                  </div>
                  <button class="edit pl-2 cancel" (click)="resetId('modal', 'BVD')"
                    (keydown.enter)="resetId('modal', 'BVD')" (keydown.space)="resetId('modal', 'BVD')" tabindex="0"
                    data-target="#openEditModal" data-toggle="modal">
                    <mat-icon *ngIf="noSiteAssn == false && roleVariableHide" svgIcon="edit"
                      class="img-btn pl-1 edit h-24 w-25 cancel"></mat-icon>
                  </button>
                  <ng-container *ngIf="
                      showForSupplier == true &&
                      companyID != '' &&
                      companyID != undefined &&
                      sitebvidid != '' &&
                      showBuyerProfile == true &&
                      showForConsult == true
                    ">
                    <div class="pl-1">
                      <label class="switch m-0">
                        <input type="checkbox" id="sliderCheckBox"
                          [disabled]="roleVariableHide == false || inPortfolioLoading == true"
                          (change)="toggleInPortfolioSwitch($event)" title="In Portfolio" />
                        <span class="slider round" id="clickForSliderJ2"></span>
                      </label>
                    </div>
                    <div class="pl-1">({{ countValue }})</div>
                    <div class="pl-1" *ngIf="inPortfolioLoading == true"><img src="assets/images/loading.gif"
                        alt="Updating..." /></div>
                  </ng-container>
                </div>
              </div>
              <div class="mb-2 row mb-10" *ngIf="latestOrbisStatus && latestOrbisStatus != ''">
                <div class="font-weight-bold">Orbis Status:&nbsp;</div>

                <div class="group-status pl-3 pr-3 py-1"
                  [ngStyle]="{ 'background-color': latestOrbisStatus.color, 'border-radius': '12px', 'min-width': '82px' }">
                  {{ latestOrbisStatus.value }}
                </div>

                <div class="font-weight-bold pl-4 pb-4">
                  {{ latestOrbisStatus.startDate }}
                </div>
              </div>

              <div class="mb-2 row">
                <div class="font-weight-bold">DUNS :</div>
                <div class="pl-1">{{ DUNSValue ? DUNSValue : "--" }}</div>
                <div *ngIf="showArchivedDUNSId == true && DUNSValue != ''">
                  <div class="grouppill-status" [ngStyle]="{ background: '#CB4B32' }">Archived</div>
                </div>
                <button type="button" class="cancel" (click)="resetId('modal', 'DUNS')" (keydown.enter)="resetId('modal', 'DUNS')"
                  (keydown.space)="resetId('modal', 'DUNS')" tabindex="0" data-target="#openEditModal"
                  data-toggle="modal">
                  <mat-icon *ngIf="noSiteAssn == false && roleVariableHide" svgIcon="edit"
                    class="img-btn pl-1 edit h-24 w-25"></mat-icon>
                </button>
              </div>
              <div class="mb-2 row">
                <div class="font-weight-bold">BPN :</div>
                <div *ngIf="BPNLValue" class="pl-1">{{ BPNLValue }}</div>
                <div *ngIf="!BPNLValue" class="pl-1">--</div>
                <div *ngIf="showArchivedBPNId == true && BPNLValue != ''">
                  <div class="grouppill-status" [ngStyle]="{ background: '#CB4B32' }">Archived</div>
                </div>
                <button type="button" class="cancel" (click)="resetId('modal', 'BPN')" (keydown.enter)="resetId('modal', 'BPN')"
                  (keydown.space)="resetId('modal', 'BPN')" tabindex="0" data-target="#openEditModal"
                  data-toggle="modal">
                  <mat-icon *ngIf="noSiteAssn == false && roleVariableHide" svgIcon="edit"
                    class="img-btn pl-1 edit h-24 w-25"></mat-icon>
                </button>

                <div *ngIf="requested == 'yes' && !retriveButton && !requestButton" class="font-weight-bold pl-4">
                  Requested on {{ BpnDate }}
                </div>
                <div *ngIf="BPNLValue == '' && retriveButton" class="pl-5">
                  <button type="button" class="btn btn-custom btn-red mt-n7 bg-cb4b32" data-toggle="modal">Retrive
                    BPN-L</button>
                </div>
              </div>

              <br /><br />
            </div>
            <div class="text-center" *ngIf="companyBasicInfo == ''">
              <img src="assets/images/loading.gif" alt="loading..." />
            </div>
          </section>
          <section class="border-bottom-yellow auto-h minh-75">
            <div class="row m-0 align-center pt-1 section-scroll">
              <div class="col col-12 col-sm-4 col-md-5 col-lg-5 col-xl-5 p-0 px-2">
                <a (click)="togglePayingCompany()" class="title mt-2 mb-3 underline-pointer ml-8" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (togglePayingCompany())">PAYING COMPANY <span
                    *ngIf="PayingInfo?.length">({{ PayingInfo.length }})</span></a>
              </div>
              <div class="col col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 text-right mt-15">
                <button *ngIf="superUserShow || roleVariableHide == true" type="button"
                  class="btn btn-custom btn-darkred " data-toggle="modal" data-target="#PCModalPopup"
                  (click)="openPayingCompanyPopup()">
                  <mat-icon svgIcon="edit" class="img-btn" alt=""></mat-icon><span class="float-right"> Edit Paying Company</span>
                </button>
                <button class="btn btn-custom btn-blue d-flex align-center float-right ml-1" data-toggle="modal"
                  data-target="#payingCompanyState" (click)="getPayingDetails('No')">
                  <span><mat-icon svgIcon="calendercharge" class="img-btn img-btn-xl mb-1" alt=""></mat-icon><span
                      class="float-right"> Company State</span></span>
                </button>
                <button *ngIf="
                    (superUserShow || roleVariableHide == true) &&
                    companyAliasAll &&
                    companyAliasAll['ALCOR'] &&
                    companyAliasAll['ALCOR'].length > 0
                  " type="button" class="btn btn-custom btn-blue d-flex align-center float-right ml-1"
                  data-toggle="modal" data-target="#alcorStatusModal" (click)="checkAlcorStatus()">
                  <span><mat-icon svgIcon="calendercharge" class="img-btn img-btn-xl mb-1" alt=""></mat-icon><span
                      class="float-right"> Check ALCOR</span></span>
                </button>
              </div>
            </div>
            <div *ngIf="showPayingCompanyBlock">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ml-1">
                <div class="section-scroll">
                  <ng-container *ngIf="PayingInfo && PayingInfo.length >= 0">
                    <div class="row mb-2 w-100" *ngFor="let payinfo of PayingInfo; let i = index">
                      <ng-container *ngIf="payinfo">
                        <div class="status-container">
                          <div class="mr-4 col-1">{{ payinfo.clientCompanyCode }}</div>
                          <div class="space-name font-weight-bold">{{ payinfo.clientCompanyLegalName }}</div>
                          <div class="grouppill-status"
                            [ngStyle]="{ background: colorStatus[payinfo.approvalModificationStatus.toLowerCase()], 'min-width': '82px' }">
                            {{
                            payinfo.approvalModificationStatus
                            ? payinfo.approvalModificationStatus == "VALIDATED"
                            ? payinfo.approvalModificationStatus.replace("VALIDATED", "ACTIVE")
                            : payinfo.approvalModificationStatus.replace("PENDING_VALIDATION", "PENDING")
                            : ""
                            }}
                          </div>
                           <button *ngIf="
                              roleVariableHide == true &&
                              payinfo.approvalModificationStatus == 'ARCHIVED'
                            "
                            class="edit cancel pl-2 ml-3"
                            data-toggle="modal"
                            data-target="#confirmDeletepayingCompany"
                            (click)="payingCmpInfo(payinfo)"
                            (keydown.enter)="payingCmpInfo(payinfo)"
                            (keydown.space)="payingCmpInfo(payinfo)"
                            tabindex="0"
                            aria-label="Delete archived paying company link"

                            [matTooltipPosition]="'above'">
                            <mat-icon svgIcon="delete" class="h-20 w-20" alt="delete"></mat-icon>
                          </button>
                        </div>
                      </ng-container>
                      <div class="text-center" *ngIf="PayingLoading == true">
                        <img src="assets/images/loading.gif" alt="loading..." />
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>
          <section class="border-bottom-yellow auto-h minh-75"
            *ngIf="roleVariableHide || (showForSupplier == true && showBuyerProfile == true && roleIsManager == false)">
            <div class="row m-0 align-center pt-1">
              <div class="col col-12 col-sm-4 col-md-5 col-lg-5 col-xl-5 p-0 px-2">
                <a (click)="toggleActivityCollapsed()" class="title ml-8 mt-2 mb-3 underline-pointer" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleActivityCollapsed())">ACTIVITY ({{
                  activityLength }})</a>
              </div>
              <div class="col col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 text-right mt-15">
                <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 consultCss pr-2 mr-20">
                  <button type="button" *ngIf="roleVariableHide == true"
                    class="btn btn-custom btn-darkred d-flex align-center float-right ml-1" data-target="#activityEdit"
                    data-toggle="modal" (click)="editActivity()">
                    <mat-icon svgIcon="edit" class="img-btn"></mat-icon><span class="float-right"> Edit Activity </span>
                  </button>
                </div>
              </div>
              <div *ngIf="activityLoad && showActivityBlock"
                class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-40">
                <div *ngIf="activityLength != 0" class="row m-0 pt-0">
                  <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
                    <div class="pl-10">
                      <ng-container *ngIf="activityA">
                        <div class="pl-2" *ngFor="let valueA of activityA">
                          {{ valueA }}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="borders col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
                    <div class="pl-20">
                      <ng-container>
                        <div *ngFor="let valueB of activityB">
                          {{ valueB }}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="borders col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
                    <div class="pl-20">
                      <ng-container *ngIf="activityC">
                        <div *ngFor="let valueC of activityC">
                          {{ valueC }}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="borders col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
                    <div class="pl-20">
                      <ng-container *ngIf="activityD">
                        <div *ngFor="let valueD of activityD">
                          {{ valueD }}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!activityLoad" class="text-center">
              <img src="assets/images/loading.gif" alt="loading..." />
            </div>
          </section>

          <div [ngClass]="{ nonAdminCss: roleVariableHide == false }">
            <section class="border-bottom-yellow auto-h minh-75">
              <div class="row m-0 align-center pt-1 section-scroll">
                <div class="col col-12 col-sm-4 col-md-5 col-lg-5 col-xl-5 p-0 px-2">
                  <a (click)="toggleCompanyIdentifierCollapsed()" class="title mt-2 mb-3 underline-pointer ml-8" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleCompanyIdentifierCollapsed())">COMPANY
                    IDENTIFIERS ({{ getCompanyIdentifierCount() }})</a>
                </div>
                <div class="col col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 text-right mt-15">
                  <button class="btn btn-custom btn-blue d-flex align-center float-right ml-1" data-toggle="modal"
                    data-target="#dispCmpyAliasState" (click)="loadCmpyAliasState()">
                    <span><mat-icon svgIcon="calendercharge" class="img-btn img-btn-xl mb-1" alt=""></mat-icon><span
                        class="float-right btn-padding">Company idenitifiers State</span></span>
                  </button>

                  <button type="button" class="btn btn-custom btn-darkred" *ngIf="roleVariableHide"
                    (click)="LoadCmpAlias()" data-toggle="modal" data-target="#AddCmpAlias">
                    <span><mat-icon svgIcon="add" class="img-btn" alt=""></mat-icon><span class="float-right">Add
                        Company Identifiers</span></span>
                  </button>
                  <button type="button" class="btn btn-custom btn-darkred ml-1" *ngIf="roleVariableHide"
                    (click)="openAddAlcorCodePopup()" data-toggle="modal" data-target="#addAlcorCodePopup">
                    <span><mat-icon svgIcon="add" class="img-btn" alt=""></mat-icon><span class="float-right">Send
                        Request to ALCOR</span></span>
                  </button>
                </div>
              </div>

              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="showACompanyIdentifier">
                <ng-container *ngIf="CompanyIdentiTypes">
                  <div *ngFor="let cTypes of CompanyIdentiTypes; let i = index">
                    <div *ngIf="companyAliasAll && companyAliasAll[cTypes]">
                      <div class="row m-0 p-0 pb-2 mb-2 d-flex align-center"
                        *ngFor="let Cvalues of companyAliasAll[cTypes]; let j = index">
                        <div *ngIf="roleVariableHide == false" class="font-weight-bold">{{ cTypes ? cTypes : "" }}
                          :&nbsp;</div>
                        <div *ngIf="roleVariableHide == true" class="font-weight-bold">{{ cTypes ? cTypes : "" }}
                          :&nbsp;</div>
                        <div class="font-weight-bold label-darkblue pr-1" id="{{ Cvalues.key }}"
                          *ngIf="(Cvalues.archived == true && roleVariableHide == true) || Cvalues.archived == false">
                          {{ Cvalues.val }}
                        </div>
                        <div class="pr-1" *ngIf="
                            (Cvalues.archived == true || Cvalues.archived == false) &&
                            cTypes == 'ALCOR' &&
                            alcorNameValsOnAlcorVal[Cvalues.val]
                          ">
                          {{
                          alcorNameValsOnAlcorVal[Cvalues.val] ?
                          alcorNameValsOnAlcorVal[Cvalues.val][0]["businessIdentifierName"] : ""
                          }}
                        </div>
                        <div class="group-status px-3 py-1" [ngStyle]="{ background: '#cb4b32' }"
                          *ngIf="Cvalues.archived == true">
                          Archived
                        </div>

                        <div class="edit pl-2" *ngIf="roleVariableHide && cTypes == 'ALCOR-REQUEST'">
                          <mat-icon svgIcon="edit" class="h-20 w-20" data-toggle="modal"
                            data-target="#alcorRequestPopup" (click)="openAlcorRequestPopup(Cvalues)"
                            (keydown.enter)="openAlcorRequestPopup(Cvalues)"
                            (keydown.space)="openAlcorRequestPopup(Cvalues)" tabindex="0" alt="edit"></mat-icon>
                        </div>

                        <div class="edit float-right" *ngIf="roleVariableHide && cTypes != 'ALCOR-REQUEST'">
                          <mat-icon svgIcon="edit" class="h-20 w-20" data-toggle="modal" data-target="#EditCmpAlias"
                            (click)="
                              EditAlias(cTypes, Cvalues.val, Cvalues.key, Cvalues.disableInput, Cvalues.showSwitch, Cvalues.archived)
                            " (keydown.enter)="
                              EditAlias(cTypes, Cvalues.val, Cvalues.key, Cvalues.disableInput, Cvalues.showSwitch, Cvalues.archived)
                            " (keydown.space)="
                              EditAlias(cTypes, Cvalues.val, Cvalues.key, Cvalues.disableInput, Cvalues.showSwitch, Cvalues.archived)
                            " tabindex="0" alt="delete"></mat-icon>
                        </div>

                        <div class="pl-2" *ngIf="cTypes == 'ALCOR-REQUEST'">
                          <span *ngIf="Cvalues.endDate">{{ Cvalues.endDate }}</span>
                          <span *ngIf="!Cvalues.endDate">{{ Cvalues.startDate }}</span>
                        </div>

                        <ng-container *ngIf="cTypes == 'ALCOR-REQUEST' && alcorRequestStatusReports[Cvalues.val]">
                          <div class="pl-2 d-flex align-center">
                            <span class="font-weight-bold">{{
                              getAlcorRequestStatusLabel(alcorRequestStatusReports[Cvalues.val].REQUESTSTATUS)
                              }}&nbsp;</span>

                            <span *ngIf="alcorRequestStatusReports[Cvalues.val].MESSAGECFCREJECT" class="pl-1">
                              ({{ alcorRequestStatusReports[Cvalues.val].MESSAGECFCREJECT }})
                            </span>

                            <span class="d-flex align-center" *ngIf="
                                alcorRequestStatusReports[Cvalues.val].REQUESTSTATUS === 'DF' &&
                                alcorRequestStatusReports[Cvalues.val].SUPPLIER
                              ">
                              {{ stripLeadingZeros(alcorRequestStatusReports[Cvalues.val].SUPPLIER) }}&nbsp;
                              <mat-icon class="pointer" svgIcon="speechcomment"
                                (click)="copyToClipboard(stripLeadingZeros(alcorRequestStatusReports[Cvalues.val].SUPPLIER))"
                                (keydown.enter)="copyToClipboard(stripLeadingZeros(alcorRequestStatusReports[Cvalues.val].SUPPLIER))"
                                (keydown.space)="copyToClipboard(stripLeadingZeros(alcorRequestStatusReports[Cvalues.val].SUPPLIER))"
                                tabindex="0" alt="copy" [matTooltip]="'Copy'" [matTooltipPosition]="'above'"></mat-icon>
                            </span>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="text-center" *ngIf="CompanyIdentiLoading == true">
                <img src="assets/images/loading.gif" alt="loading..." />
              </div>
            </section>
          </div>
          <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow">
            <div class="row m-0 pt-3 align-center">
              <div class="col col-12 col-sm-6 col-md-6 col-lg-8 col-xl-9 p-0 px-2">
                <a (click)="toggleCompanyContactsCollapsed()" class="title ml-8 underline-pointer" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleCompanyContactsCollapsed())">COMPANY CONTACTS ({{
                  CompanyContacts?.length || 0 }})</a>
                <a [href]="pdfLink" target="_blank" class="pdf-link-info ml-8"> Personal Data Protection </a>
              </div>

              <div class="col col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 text-right">
                <span *ngIf="showForConsult">
                  <button type="button" data-toggle="modal" data-target="#AddnewCmpContacts"
                    (click)="AddEditCmpContact('', 'load')"
                    class="btn btn-custom btn-green btn-custom-md btn-blue h-37 mt-12 mb-25">
                    <span><mat-icon svgIcon="add" class="img-btn" alt=""></mat-icon> <span class="float-right">Add
                        Company Contact</span></span>
                  </button>
                </span>
              </div>
            </div>

            <div class="row m-0" *ngIf="showCompanyContacts">
              <div class="table-responsive mt-3 auto-h">
                <table class="table table-sm tbl-custom m-0">
                  <thead>
                    <tr>
                      <th class="cdwidth15 text-left no-underline">First Name</th>
                      <th class="cdwidth15 text-left no-underline">Last Name</th>
                      <th class="cdwidth20 text-left no-underline">E-mail</th>
                      <th class="text-left no-underline">IPN</th>
                      <th class="cdwidth17 text-left no-underline w-130">Role</th>
                      <th class="cdwidth13 text-left no-underline w-0">Cellphone</th>
                      <th class="cdwidth15 text-left no-underline w-0">Phone</th>
                      <th class="cdwidth2 text-left no-underline"></th>
                    </tr>
                  </thead>

                  <tbody *ngIf="CompanyContacts.length > 0">
                    <tr *ngFor="let comCont of CompanyContacts">
                      <td>{{ comCont.personFirstName ? comCont.personFirstName : "" }}</td>
                      <td class="font-weight-bold label-darkblue pointer" data-toggle="modal"
                        data-target="#openContactDetails" *ngIf="superusershow == true"
                        (click)="AddEditCmpContact('', 'edit', comCont.row_id)"
                        (keydown.enter)="AddEditCmpContact('', 'edit', comCont.row_id)"
                        (keydown.space)="AddEditCmpContact('', 'edit', comCont.row_id)" tabindex="0">
                        {{ comCont.personLastName ? comCont.personLastName : "" }}
                      </td>
                      <td
                        *ngIf="roleVariableHide || showBuyerProfile || roleIsManager == true || showForConsult == true">
                        {{ comCont.personLastName ? comCont.personLastName : "" }}
                      </td>
                      <td>{{ PersonDetails[comCont.personRowId + "_email"] ? PersonDetails[comCont.personRowId +
                        "_email"] : "" }}</td>
                      <td>
                        <ng-container *ngIf="
                            personIpn[comCont.personRowId] &&
                              !personIpn[comCont.personRowId].archived &&
                              (!personIpn[comCont.personRowId].endDate || personIpn[comCont.personRowId].endDate >= today);
                            else emptyIpn
                          ">
                          {{ personIpn[comCont.personRowId].loginId }}
                        </ng-container>
                        <ng-template #emptyIpn></ng-template>
                      </td>
                      <td>
                        {{ comCont.roleTypeLabel ? comCont.roleTypeLabel : "" }}
                        <span *ngIf="superusershow == true">
                          <mat-icon svgIcon="edit" alt="edit" width="14" height="15" data-toggle="modal"
                            data-target="#EditCmpConRole" (click)="AddEditCmpContact('', 'edit', comCont.row_id)"
                            (keydown.enter)="AddEditCmpContact('', 'edit', comCont.row_id)"
                            (keydown.space)="AddEditCmpContact('', 'edit', comCont.row_id)"
                            tabindex="0"></mat-icon></span>
                      </td>
                      <td>{{ PersonDetails[comCont.personRowId + "_p"] ? PersonDetails[comCont.personRowId + "_p"] : ""
                        }}</td>
                      <td>{{ PersonDetails[comCont.personRowId + "_f"] ? PersonDetails[comCont.personRowId + "_f"] : ""
                        }}</td>
                      <td *ngIf="showForConsult == true">
                        <mat-icon svgIcon="edit" alt="edit" width="14" height="15" data-toggle="modal"
                          data-target="#openContactAndRole" (click)="AddEditCmpContact('', 'edit', comCont.rowId)"
                          (keydown.enter)="AddEditCmpContact('', 'edit', comCont.rowId)"
                          (keydown.space)="AddEditCmpContact('', 'edit', comCont.rowId)" tabindex="0"></mat-icon>
                      </td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="ContactsFlag == true && CompanyContacts.length == 0">
                    <tr>
                      <td colspan="8" class="font-weight-bold label-darkblue text-center"
                        *ngIf="CompanyIdentiLoading == false && ContactsFlag == true">
                        No Results
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center" *ngIf="CompanyIdentiLoading == true || ContactsFlag == false">
                  <img src="assets/images/loading.gif" alt="loading..." />
                </div>
              </div>
            </div>
          </section>
          <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow" *ngIf="
              (showForConsult == true &&
                (companyBasicInfo.workflowStatus == 'WaitingForSupplier')) ||
              roleVariableHide == true
            ">
            <div class="row m-0 pt-3 align-center">
              <div class="col col-12 col-sm-9 col-md-6 col-lg-6 col-xl-7 p-0 px-2 d-flex align-start">
                <a (click)="toggleDocumentsForAccounting()" class="title ml-8 mb-50 underline-pointer" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleDocumentsForAccounting())">DOCUMENTS FOR
                  ACCOUNTING ({{ CompanyDoc?.length || 0 }})</a>
              </div>

              <div class="col col-12 col-sm-3 col-md-6 col-lg-6 col-xl-5">
                <div class="row">
                  <div class="col-1 col-xl-7 col-lg-6 col-md-4 col-sm-1"></div>
                  <div class="col-9 col-xl-5 col-lg-6 col-md-8 text-right flex-end min-h-56 mb-18">
                    <span class="p-7">
                      <a [href]="guideCompanyUrl" target="_blank"><mat-icon svgIcon="info" class="info-btn wh-28-25"
                          alt="edit"></mat-icon></a>
                    </span>
                    <button type="button" class="btn btn-green btn-custom btn-blue mt-8 mb-8"
                      (click)="openFnAddDocumentModal()" data-target="#openAddDocumentModal" data-toggle="modal" *ngIf="
                        roleVariableHide || superUserShow || (companyBasicInfo.workflowStatus == 'WaitingForSupplier' && showForSupplier == false)
                      ">
                      <mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add Document </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row m-0" *ngIf="showDocumentsForAccounting">
              <div class="table-responsive mt-3">
                <table class="table table-sm tbl-custom m-0 border-0 table-fixed">
                  <thead>
                    <tr>
                      <th class="text-left no-underline">Document Type</th>
                      <th class="text-left no-underline">File Name</th>
                      <th class="text-left no-underline">Paying Company</th>
                      <th class="text-left no-underline">Date</th>
                      <th class="text-left no-underline">Status</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="CompanyDoc.length > 0">
                    <tr *ngFor="let docs of CompanyDoc; let i = index" class="forColor">
                      <td class="font-weight-bold label-darkblue">
                        {{ docs["fields"]["Document_x0020_Type"] ? docs["fields"]["Document_x0020_Type"] : "-" }}
                      </td>
                      <td class="word-wrap">
                        <a href="javascript:void(0);" (click)="downloadFile(docs['fields']['id'])"
                          class="label-darkblue">{{
                          docs["fields"]["LinkFilename"]
                          }}</a>
                      </td>
                      <td>{{ docs["fields"]["Paying_x0020_Company"] ? docs["fields"]["Paying_x0020_Company"] : "-" }}
                      </td>
                      <td>{{ docs["fields"]["Created"] ? "GMT " + (docs["fields"]["Created"] | date: "yyyy-MM-dd HH:mm")
                        : "-" }}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <span class="group-status px-3"
                            *ngIf="docs['fields']['Status'] != '' && docs['fields']['Status'] != undefined"
                            [ngStyle]="{ background: colorStatus[docs['fields']['Status'].toLowerCase()], 'min-width': '82px' }">
                            {{ docs["fields"]["Status"] }}
                          </span>
                          <span class="pointer">
                            <mat-icon svgIcon="edit" *ngIf="roleVariableHide" alt="edit" class="ml-2" data-toggle="modal"
                              data-target="#EditDocStatus" (click)="
                                openEditDocStatus(
                                  docs['fields']['Status'],
                                  docs['id'],
                                  docs['fields']['LinkFilename'],
                                  false,
                                  docs['fields']['Document_x0020_Type']
                                )
                              " (keydown.enter)="
                                openEditDocStatus(
                                  docs['fields']['Status'],
                                  docs['id'],
                                  docs['fields']['LinkFilename'],
                                  false,
                                  docs['fields']['Document_x0020_Type']
                                )
                              " (keydown.space)="
                                openEditDocStatus(
                                  docs['fields']['Status'],
                                  docs['id'],
                                  docs['fields']['LinkFilename'],
                                  false,
                                  docs['fields']['Document_x0020_Type']
                                )
                              " tabindex="0"></mat-icon>
                          </span>

                          <span class="pointer"
                            *ngIf="docs['fields']['Status'] != 'Active' && showDocsDelete == true">
                            <mat-icon svgIcon="delete" alt="delete" class="ml-2" data-toggle="modal"
                              data-target="#confirmDeleteDocumentModal" (click)="
                              openEditDocStatus(
                                docs['fields']['Status'],
                                docs['id'],
                                docs['fields']['LinkFilename'],
                                false,
                                docs['fields']['Document_x0020_Type']
                              )
                            " (keydown.enter)="
                              openEditDocStatus(
                                docs['fields']['Status'],
                                docs['id'],
                                docs['fields']['LinkFilename'],
                                false,
                                docs['fields']['Document_x0020_Type']
                              )
                            " (keydown.space)="
                              openEditDocStatus(
                                docs['fields']['Status'],
                                docs['id'],
                                docs['fields']['LinkFilename'],
                                false,
                                docs['fields']['Document_x0020_Type']
                              )
                            " tabindex="0"></mat-icon>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="CompanyDoc.length == 0 && loadingForCompanyDocuments == false">
                    <tr>
                      <td class="label-darkblue text-center font-weight-bold" colspan="4">No Results</td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center" *ngIf="loadingForCompanyDocuments == true">
                  <img src="assets/images/loading.gif" alt="loading..." />
                </div>
              </div>
            </div>
          </section>
          <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow" *ngIf="
              showForConsult == true &&
              (roleVariableHide == true || showForSupplier == false || roleIsManager == true || superUserShow || showBuyerProfile == false)
            ">
            <div class="row m-0 pt-3 align-center">
              <div class="col col-12 col-sm-9 col-md-6 col-lg-6 col-xl-7 p-0 px-2">
                <a (click)="toggleGenericDocuments()" class="title ml-8 underline-pointer" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleGenericDocuments())">GENERIC DOCUMENTS FOR RFQ ({{
                  GenericCompanyDoc?.length || 0 }})</a>
                <a [href]="pdfLink" target="_blank" class="pdf-link-info ml-8"> Personal Data Protection </a>
              </div>

              <div class="col col-12 col-sm-3 col-md-6 col-lg-6 col-xl-5">
                <div class="row">
                  <div class="col-1 col-xl-7 col-lg-6 col-md-4 col-sm-1"></div>
                  <div class="col-9 col-xl-5 col-lg-6 col-md-8 text-right flex-end mb-20 min-h-56">
                    <a [href]="guide" target="_blank" class="d-flex align-center mr-2">
                      <mat-icon svgIcon="info" class="info-btn wh-28-25" alt="edit"></mat-icon>
                    </a>
                    <button type="button" class="btn btn-green btn-custom btn-blue mt-8 mb-8"
                      (click)="openFnAddGenDocumentModal()" data-toggle="modal" data-target="#openAddGenDocumentModal"
                      *ngIf="
                        showForConsult == true &&
                        (roleVariableHide == true || showForSupplier == false || roleIsManager == true || superUserShow)
                      ">
                      <mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add Document </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row m-0" *ngIf="showGenericDocuments">
              <div class="table-responsive mt-3">
                <table class="table table-sm tbl-custom m-0 border-0 table-fixed">
                  <thead>
                    <tr>
                      <th class="text-left no-underline">Document Type</th>
                      <th class="text-left no-underline">File Name</th>
                      <th class="text-left no-underline">Date</th>
                      <th class="text-left no-underline">Status</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="GenericCompanyDoc.length > 0">
                    <tr *ngFor="let docs of GenericCompanyDoc; let i = index" class="forColor">
                      <td class="font-weight-bold label-darkblue">
                        {{ docs["fields"]["DocumentType"] ? docs["fields"]["DocumentType"] : "-" }}
                      </td>
                      <td class="word-wrap">
                        <a href="javascript:void(0);" (click)="downloadGenericFile(docs['fields']['id'])"
                          class="label-darkblue">{{
                          docs["fields"]["LinkFilename"]
                          }}</a>
                      </td>
                      <td>{{ docs["fields"]["Created"] ? "GMT " + (docs["fields"]["Created"] | date: "yyyy-MM-dd HH:mm")
                        : "-" }}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <span class="group-status px-3"
                            *ngIf="docs['fields']['Status'] != '' && docs['fields']['Status'] != undefined"
                            [ngStyle]="{ background: colorStatus[docs['fields']['Status'].toLowerCase()], 'min-width': '82px' }">
                            {{ docs["fields"]["Status"] }}
                          </span>
                          <span class="pointer">
                            <mat-icon svgIcon="edit" *ngIf="roleVariableHide || roleIsManager || !showBuyerProfile"
                              alt="edit" class="ml-2" data-toggle="modal" data-target="#EditDocStatus" (click)="
                                openEditDocStatus(
                                  docs['fields']['Status'],
                                  docs['id'],
                                  docs['fields']['LinkFilename'],
                                  true,
                                  docs['fields']['DocumentType']
                                )
                              " (keydown.enter)="
                                openEditDocStatus(
                                  docs['fields']['Status'],
                                  docs['id'],
                                  docs['fields']['LinkFilename'],
                                  true,
                                  docs['fields']['DocumentType']
                                )
                              " (keydown.space)="
                                openEditDocStatus(
                                  docs['fields']['Status'],
                                  docs['id'],
                                  docs['fields']['LinkFilename'],
                                  true,
                                  docs['fields']['DocumentType']
                                )
                              " tabindex="0"></mat-icon>
                          </span>

                          <span class="pointer"
                            *ngIf="docs['fields']['Status'] != 'Active' && showDocsDelete == true">
                            <mat-icon svgIcon="delete" alt="delete" class="ml-2" data-toggle="modal"
                              data-target="#confirmDeleteDocumentModal" (click)="
                              openEditDocStatus(
                                docs['fields']['Status'],
                                docs['id'],
                                docs['fields']['LinkFilename'],
                                true,
                                docs['fields']['DocumentType']
                              )
                            " (keydown.enter)="
                              openEditDocStatus(
                                docs['fields']['Status'],
                                docs['id'],
                                docs['fields']['LinkFilename'],
                                true,
                                docs['fields']['DocumentType']
                              )
                            " (keydown.space)="
                              openEditDocStatus(
                                docs['fields']['Status'],
                                docs['id'],
                                docs['fields']['LinkFilename'],
                                true,
                                docs['fields']['DocumentType']
                              )
                            " tabindex="0"></mat-icon>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="GenericCompanyDoc.length == 0 && loadingForGenericDocuments == false">
                    <tr>
                      <td class="label-darkblue text-center font-weight-bold" colspan="4">No Results</td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center" *ngIf="loadingForGenericDocuments == true">
                  <img src="assets/images/loading.gif" alt="loading..." />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 marginupdown">
      <button class="edit cancel" (click)="acc('site')" (keydown.enter)="acc('site')" (keydown.space)="acc('site')"
        tabindex="0" *ngIf="showBoxDownSite">
        <mat-icon svgIcon="downarrow" class="collapsed down_arrow pos-abs ml-n37 mt-10" alt=""></mat-icon>
      </button>
      <button class="edit opened_comp cancel" (click)="acc('site')" (keydown.enter)="acc('site')"
        (keydown.space)="acc('site')" tabindex="0" *ngIf="!showBoxDownSite">
        <mat-icon svgIcon="downarrow" class="collapsed pos-abs ml-n37 mt-10" alt=""></mat-icon>
      </button>
      <div class="backblue">
        <h5 class="font-weight-normal col">
          SITES&nbsp;:&nbsp;<span class="font-weight-bold" *ngIf="!statusFiltered">({{ getVisibleSitesCount()
            }})</span><span class="font-weight-bold" *ngIf="statusFiltered">({{ getVisibleSitesCount() }} out of {{
            getTotalSitesCount() }})</span>
        </h5>
      </div>
      &nbsp;&nbsp;
      <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow" id="openAllBoxcsite">
        <div class="row m-0 pt-3 align-center">
          <div class="col col-12 col-sm-2 col-md-1 col-lg-3 col-xl-4 p-0 px-2">
            <h4 class="title ml-8">SITES</h4>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-9 col-xl-8 text-right">
            <span class="span pr-1" *ngIf="superUserShow">
              <button type="button" class="btn btn-custom btn-custom-md btn-purple" [disabled]="disableCheckHQ == true"
                (click)="checkHQ()">
                Check Headquarters
              </button>
            </span>

            <span class="span pr-1" *ngIf="superUserShow == true">
              <button type="button" class="btn btn-custom btn-custom-md btn-purple" (click)="clearSiteHQ()">Clear
                Headquarters</button>
            </span>
            <span class="span pr-1" *ngIf="roleVariableHide">
              <button type="button" class="btn btn-custom btn-custom-md btn-darkred" (click)="lookForSites()"
                data-target="#lookForSites" data-toggle="modal">
                Look For Sites
              </button>
            </span>
            <span class="span pr-1" *ngIf="showBuyerProfile && roleVariableHide">
              <button type="button" class="btn btn-custom btn-custom-md btn-darkred" [disabled]="disableSetAsHQ == true"
                (click)="setSiteHQ()">
                Set as Headquarters
              </button>
            </span>

            <span class="span pr-1" *ngIf="
                (showAddSiteBtn == true &&
                  (roleVariableHide == true ||
                    superUserShow == true ||
                    (companyBasicInfo.companyStatusCode == 'Pending' && showForSupplier == true)) &&
                  (showForSupplier == true || roleIsManager == false || showBuyerProfile == true)) ||
                (companyBasicInfo.companyStatusCode == 'Waiting for Approval' && roleVariableHide == true) ||
                (showBuyerProfile == false && roleIsManager == false)
              ">
              <button type="button" data-toggle="modal" data-target="#showAddSiteHq" (click)="addSiteChkHQBvd()"
                class="btn btn-green btn-custom btn-custom-md">
                <mat-icon svgIcon="add" class="img-btn"></mat-icon> <span class="float-right">Add Site</span>
              </button>
            </span>
          </div>
        </div>

        <div class="row m-0">
          <div class="table-responsive mt-3 fixTableFoot overflow-visible">
            <table class="table table-sm tbl-custom m-0">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-left no-underline w-10">Site Name</th>
                  <th class="text-left no-underline w-10">
                    Site Status
                    <span>
                      <div class="dropdown d-inline">
                        <button class="edit cancel" type="button" id="dropdownMenuButton" (click)="showDropdownStatus()"
                          tabindex="0" (keydown.enter)="showDropdownStatus()" (keydown.space)="showDropdownStatus()">
                          <mat-icon *ngIf="statusFilteredSiteStatus" svgIcon="filter-1" class="img-btn img-btn-sm"></mat-icon>
                          <mat-icon *ngIf="!statusFilteredSiteStatus" svgIcon="filter-2" class="img-btn img-btn-sm"></mat-icon>
                        </button>
                      </div>
                    </span>
                    <div *ngIf="showFilterStatus" data-toggle="modal" class="dropdown-modal z-10 site-status-popup-spacing">
                      <ng-container class="bg-white">
                        <ul class="row m-0 nav list-view p-0 pt-1 h-120 w-165">
                          <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0 h-22"
                            *ngFor="let status of statusOrder">
                            <span>
                              <input type="checkbox" id="{{ status }}" (click)="setCheckboxVal(status)"
                                (keydown.enter)="setCheckboxVal(status)" (keydown.space)="setCheckboxVal(status)"
                                tabindex="0" value="{{ status }}" class="edit checkboxAt" />&nbsp;&nbsp;
                              <label [attr.for]="status" class="group-status-1 status-pill-fit" [ngStyle]="{ background: status === 'Pending' ? '#FFBD69' : (status === 'Created' ? '#D8C4A0' : getColor2(status)) }">
                                {{ status.replace("Created", "Identified").replace("Pending","Inactive").replace("ACTIVE","Active") }}
                              </label>
                            </span>
                          </li>
                        </ul>
                        <div class="modal-footer py-0 pr-0 border-0 mt-2">
                          <button type="button" class="btn btn-custom btn-link bg-none"
                            (click)="showDropdownStatus('close')">Clear</button>
                          <button type="button" class="btn btn-custom btn-custom-sm btn-blue mrg"
                            (click)="filterStatus()">OK</button>
                        </div>
                      </ng-container>
                    </div>
                    <div class="pt-2">
                      Workflow Status
                      <span>
                        <div class="dropdown d-inline">
                          <button class="edit cancel" type="button" id="dropdownMenuButtonSiteWorkflow"
                            (click)="showDropdownSiteWorkflowStatus()" tabindex="0"
                            (keydown.enter)="showDropdownSiteWorkflowStatus()"
                            (keydown.space)="showDropdownSiteWorkflowStatus()">
                            <mat-icon *ngIf="statusFilteredSiteWorkflow" svgIcon="filter-1"
                              class="img-btn img-btn-sm"></mat-icon>
                            <mat-icon *ngIf="!statusFilteredSiteWorkflow" svgIcon="filter-2"
                              class="img-btn img-btn-sm"></mat-icon>
                          </button>
                        </div>
                      </span>
                      <div *ngIf="showFilterSiteWorkflowStatus" data-toggle="modal" class="dropdown-modal z-10">
                        <ng-container class="bg-white">
                          <ul class="row m-0 nav list-view p-0 pt-1 h-120 w-165">
                            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0 h-22"
                              *ngFor="let status of siteWorkflowStatusOrder">
                              <span>
                                <input type="checkbox" id="site-workflow-{{ status }}"
                                  (click)="setCheckboxValSiteWorkflow(status)"
                                  (keydown.enter)="setCheckboxValSiteWorkflow(status)"
                                  (keydown.space)="setCheckboxValSiteWorkflow(status)" tabindex="0"
                                  value="{{ status }}" class="edit checkboxAt" />&nbsp;&nbsp;
                                <label [attr.for]="'site-workflow-' + status" class="group-status-1 status-pill-fit"
                                  [ngStyle]="{ background: workflowStatusColors[status] || '#D8C4A0' }">
                                  {{ status }}
                                </label>
                              </span>
                            </li>
                          </ul>
                          <div class="modal-footer py-0 pr-0 border-0 mt-2">
                            <button type="button" class="btn btn-custom btn-link bg-none"
                              (click)="showDropdownSiteWorkflowStatus('close')">Clear</button>
                            <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
                              (click)="filterSiteWorkflowStatus()">OK</button>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </th>
                  <th class="text-left no-underline w-10">Site ID</th>
                  <th *ngIf="roleVariableHide" class="text-left no-underline w-10">Bvd ID</th>
                  <th class="text-left no-underline w-8">C2B</th>
                  <th class="text-left no-underline w-8">Legacy Codes</th>

                  <th class="text-left no-underline w-15">Address</th>

                  <th class="text-left no-underline w-10 z-1">Qualifiers</th>
                </tr>
              </thead>

              <tbody *ngIf="SitesInfo.length > 0 && SiteDispLoading == false && sitesData == true">
                <tr class="auto-h"
                  *ngIf="noHqExists == 'no' || noHqExists == 'multiple' || siteBusinessEntityExist == false">
                  <td *ngIf="noHqExists == 'no'">
                    <mat-icon class="pr-0 py-0 w-30p h-30" svgIcon="{{ sortedQualifiers['P18'] }}" alt=""></mat-icon>
                  </td>
                  <td *ngIf="noHqExists == 'multiple'" colspan="7" class="font-weight-bold label-darkblue text-center">
                    More than one headquarters
                  </td>
                </tr>
                <tr *ngFor="let siteinf of SitesInfo">
                  <ng-container *ngIf="
                      siteinf.showRow == true && siteinf.filterTrue == true && Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                    ">
                    <td>
                      <span *ngIf="siteinf.businessEntityId">
                        <span
                          *ngIf="siteinf.showAsHQ == false && siteinf.businessEntityId != '' && roleVariableHide == true">
                          <input class="ml-2 edit" type="radio" name="siteSelectName"
                            (click)="(siteinf.businessEntityId)" (keydown.enter)="(siteinf.businessEntityId)"
                            (keydown.space)="(siteinf.businessEntityId)" tabindex="0" [(ngModel)]="selectedSiteAsHQ"
                            value="{{ siteinf.businessEntityId }}" />
                        </span>
                        <span *ngIf="siteinf.showAsHQ == true">
                          <mat-icon class="pr-0 py-0 w-30p h-30" *ngIf="siteinf.showAsHQ == true"
                            svgIcon="{{ sortedQualifiers['P18'] }}" alt=""></mat-icon>
                        </span>
                      </span>
                    </td>
                    <td class="font-weight-bold label-darkblue w-16">
                      <a *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]" class="label-darkblue"
                        [routerLink]="
                          ['/site-details/' + Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']] + '/' + companyID
                        ">{{
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["name"]
                        : "No Site"
                        }}</a>
                    </td>
                    <td>
                      <div class="d-flex flex-column align-items-center">
                        <span class="group-status" *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]"
                          [ngStyle]="{
                            background: Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['activeStatus'].toLowerCase() === 'pending'
                              ? '#FFBD69'
                              : Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['activeStatus'].toLowerCase() === 'created'
                              ? '#D8C4A0'
                              : colorStatus[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['activeStatus'].toLowerCase()],
                            'min-width': '82px'
                          }">
                          {{
                          Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                          ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["activeStatus"].replace("CREATED","Identified").replace("PENDING","Inactive").replace("ACTIVE","Active")
                          : ""
                          }}
                        </span>
                        <span class="group-status d-inline-block mt-1"
                          *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] &&
                            (
                              roleVariableHide ||
                              (
                                Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['workflowStatus'] &&
                                Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['workflowStatus'] != 'NotStarted'
                              )
                            )"
                          [ngStyle]="{
                            background: workflowStatusColors[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['workflowStatus']] || '#D8C4A0',
                            'min-width': '82px'
                          }">
                          {{ Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['workflowStatus'] || 'NotStarted' }}
                        </span>
                      </div>
                    </td>
                    <td>
                      {{
                      Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                      ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]].identifier
                      : ""
                      }}
                    </td>
                    <td *ngIf="roleVariableHide">
                      {{ SiteDe_BvdID_Stat[siteinf.businessEntityId] ?
                      SiteDe_BvdID_Stat[siteinf.businessEntityId]["value"] : "" }}
                    </td>
                    <td class="maxw-200">
                      <span *ngIf="
                          Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                            ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']
                            : false
                        ">
                        <ul class="row m-0 navs p-0" *ngFor="
                            let c2b of siteC2bCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]
                          ">
                          <li class="list-view-item">{{ c2b }}</li>
                        </ul>
                      </span>
                    </td>
                    <td class="maxw-200">
                      <span *ngIf="
                          Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                            ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']
                            : false
                        ">
                        <ul class="row m-0 nav p-0" *ngFor="
                            let rafts of siteRaftCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]
                          ">
                          <li class="list-view-item">R: {{ rafts }}</li>
                        </ul>
                      </span>

                      <span *ngIf="
                          Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                            ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']
                            : false
                        ">
                        <ul class="row m-0 nav p-0" *ngFor="
                            let saer of siteSaerCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]
                          ">
                          <li class="list-view-item">S: {{ saer }}</li>
                        </ul>
                      </span>

                      <span *ngIf="
                          Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                            ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']
                            : false
                        ">
                        <ul class="row m-0 nav p-0" *ngFor="
                            let latam of siteLatamCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]
                          ">
                          <li class="list-view-item">L: {{ latam }}</li>
                        </ul>
                      </span>
                      <span *ngIf="
                          Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                            ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']
                            : false
                        ">
                        <ul class="row m-0 nav p-0" *ngFor="
                            let rnaiplCode of siteRnaiplCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]
                          ">
                          <li class="list-view-item">I: {{ rnaiplCode }}</li>
                        </ul>
                      </span>
                    </td>

                    <td>
                      <span class="font-italic small-text">
                        {{
                        acpAddressDetOnRows[accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]]
                        ? acpAddressDetOnRows[
                        accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                        ].wayNumber
                        ? acpAddressDetOnRows[
                        accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                        ].wayNumber + ","
                        : ""
                        : ""
                        }}
                        {{
                        acpAddressDetOnRows[accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]]
                        ? acpAddressDetOnRows[
                        accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                        ].streetName
                        ? acpAddressDetOnRows[
                        accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                        ].streetName +
                        (acpAddressDetOnRows[
                        accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                        ].additionalInformation
                        ? ","
                        : "")
                        : ""
                        : ""
                        }}
                        <div>
                          {{
                          acpAddressDetOnRows[
                          accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                          ]
                          ? acpAddressDetOnRows[
                          accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["rowId"]]
                          ].additionalInformation
                          : ""
                          }}
                        </div>
                      </span>
                      <div class="font-weight-bold">
                        {{
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["cityName"]
                        : ""
                        }}
                      </div>
                      <div class="font-weight-bold">
                        {{
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]["countryName"]
                        : ""
                        }}
                      </div>
                    </td>

                    <td class="w-30">
                      <ng-container *ngIf="site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]]">
                        <div class="row">
                          <span class="p-0" *ngFor="let some of sortedQualifiers | keyvalue: returnZero">
                            <div *ngIf="site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key]">
                              <div class="icon-container p-0 m-0">
                                <span class="main-icon">
                                  <mat-icon title="{{
                                      site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key]
                                        ? qualifierTypesText[some.key]
                                        : ''
                                    }}" data-toggle="tooltip" svgIcon="{{
                                      site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key]
                                        ? some.value
                                        : sortedQualifiers['P100']
                                    }}" class="qualifer-icons pr-1 pl-1 pt-3 pb-0 customicon"></mat-icon>
                                </span>
                                <span class="superscript-icon right-n7" *ngIf="
                                    site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key] &&
                                    site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key] != 1
                                  " [style.background-color]="qualifierColors[some.key]">{{
                                  site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key] }}
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </ng-container>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="siteinf.showRow == false && SitesInfo.length == 1">
                    <td colspan="2" class="font-weight-bold label-darkblue text-center">No Sites</td>
                  </ng-container>
                </tr>
              </tbody>

              <tbody *ngIf="SitesFlag == true && SitesInfo.length == 0">
                <tr>
                  <td colspan="12" class="font-weight-bold label-darkblue text-center">No Results</td>
                </tr>
              </tbody>
              <tfoot
                *ngIf="SitesInfo && SitesInfo.length > 15 && site_qualifiers.length > 0 && SiteDispLoading == false && SitesFlag == true">
                <tr>
                  <td colspan="12">
                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                      <li [ngClass]="{ disabled: pager.currentPage === 1 }">
                        <a (click)="setPageForSitesSec(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(1))">First</a>
                      </li>
                      <li [ngClass]="{ disabled: pager.currentPage === 1 }">
                        <a (click)="setPageForSitesSec(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(pager.currentPage - 1))">Previous</a>
                      </li>
                      <li *ngFor="let page of pager.pages" [ngClass]="{ active: pager.currentPage === page }">
                        <a (click)="setPageForSitesSec(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(page))">{{ page }}</a>
                      </li>
                      <li [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
                        <a (click)="setPageForSitesSec(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(pager.currentPage + 1))">Next</a>
                      </li>
                      <li [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
                        <a (click)="setPageForSitesSec(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(pager.totalPages))">Last</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>

            <div class="text-center" *ngIf="SiteDispLoading == true || SitesFlag == false">
              <img src="assets/images/loading.gif" alt="loading..." />
            </div>
          </div>
        </div>
      </section>
    </div>
    <div *ngIf="!commonService.noIpnSupplier" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <button class="edit cancel" (click)="acc('workflow')" (keydown.enter)="acc('workflow')"
        (keydown.space)="acc('workflow')" tabindex="0" *ngIf="showBoxDownworkflow">
        <mat-icon svgIcon="downarrow" class="collapsed down_arrow pos-abs ml-n37 mt-10" alt=""></mat-icon>
      </button>
      <button class="edit opened_comp cancel" (click)="acc('workflow')" (keydown.enter)="acc('workflow')"
        (keydown.space)="acc('workflow')" tabindex="0" *ngIf="!showBoxDownworkflow">
        <mat-icon svgIcon="downarrow" class="collapsed pos-abs ml-n37 mt-10" alt=""></mat-icon>
      </button>
      <div class="backblue" id="workflows">
        <h5 class="font-weight-normal col">WORKFLOWS&nbsp;</h5>
      </div>
      &nbsp;&nbsp;
      <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow" id="openworkflow">
        <div class="row m-0 pt-3 align-center">
          <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-9 p-0 px-2">
            <h4 class="title ml-8">
              WORKFLOWS&nbsp;<span><mat-icon svgIcon="refresh" (click)="workflowDetailsfn()"
                  (keydown.enter)="workflowDetailsfn()" (keydown.space)="workflowDetailsfn()" tabindex="0"
                  class="refresh h-30 w-30p"></mat-icon></span>
            </h4>
          </div>

          <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-3 text-right">
            <button *ngIf="
                (superUserShow || showBuyerProfile == false || roleIsManager == true || roleVariableHide == true) &&
                companyBasicInfo &&
                companyBasicInfo['workflowStatus'] != 'WaitingForSupplier' &&
                companyBasicInfo['workflowStatus'] != 'WaitingForRenault'
              " (click)="CheckSendReqSupplier()" (keydown.enter)="CheckSendReqSupplier()"
              (keydown.space)="CheckSendReqSupplier()" tabindex="0" class="cancel">
              <button class="btn btn-green btn-custom float-right mr-2 mb-4 br-025">
                <mat-icon svgIcon="mail" class="img-btn img-btn-lg" alt=""></mat-icon><span class="btn-workflow">
                  Launch a workflow</span>
              </button>
            </button>
            <button title="Workflow in progress" *ngIf="
                (superUserShow || showBuyerProfile == false || roleIsManager == true || roleVariableHide == true) &&
                companyBasicInfo &&
                  (companyBasicInfo['workflowStatus'] == 'WaitingForSupplier' ||
                companyBasicInfo['workflowStatus'] == 'WaitingForRenault')"
              (click)="CheckSendReqSupplier()" (keydown.enter)="CheckSendReqSupplier()"
              (keydown.space)="CheckSendReqSupplier()" tabindex="0" data-toggle="tooltip" class="cancel">
              <button class="btn btn-green btn-custom float-right mr-2 mb-4 br-025"
                [disabled]="companyBasicInfo['workflowStatus'] == 'WaitingForSupplier' ||
                companyBasicInfo['workflowStatus'] == 'WaitingForRenault'">
                <mat-icon svgIcon="mail" class="img-btn img-btn-lg" alt=""></mat-icon><span class="btn-workflow">
                  Launch a workflow</span>
              </button>
              <!-- <button class="btn btn-green btn-custom float-right pr-0 br-025-0-0-025"
                [disabled]="companyBasicInfo &&
                  (companyBasicInfo['workflowStatus'] == 'WaitingForSupplier' ||
                    companyBasicInfo['workflowStatus'] == 'WaitingForRenault')">
                <mat-icon svgIcon="mail" class="img-btn img-btn-lg" alt=""></mat-icon>
              </button> -->
            </button>
          </div>
        </div>
        <div class="row m-0">
          <div class="table-responsive mt-3 overflow-visible">
            <div class="fixTableHead">
              <table class="table table-sm tbl-custom m-0 border-0">
                <thead>
                  <tr>
                    <th class="text-left no-underline w-1">Request ID</th>
                    <th class="sortDecorationunderline text-left w-9" (click)="sort('supplierName')"
                      (keydown.enter)="sort('supplierName')" (keydown.space)="sort('supplierName')" tabindex="0">
                      Supplier
                    </th>
                    <th class="text-left no-underline">Requestor</th>
                    <th class="text-left no-underline">Approver</th>
                    <th class="text-left no-underline">Request Type</th>
                    <th class="text-left no-underline">Notes</th>
                    <th class="text-left no-underline w-5">Date</th>
                    <th class="text-left no-underline">
                      Status
                      <span>
                        <div class="dropdown d-inline">
                          <button class="edit cancel" type="button" id="dropdownMenuButtonWorkFlow"
                            (click)="showDropdownStatusWorkFlow()" (keydown.enter)="showDropdownStatusWorkFlow()"
                            (keydown.space)="showDropdownStatusWorkFlow()" tabindex="0">
                            <mat-icon *ngIf="statusFilteredWorkFlow" svgIcon="filter-1"
                              class="img-btn img-btn-sm"></mat-icon>
                            <mat-icon *ngIf="!statusFilteredWorkFlow" svgIcon="filter-2"
                              class="img-btn img-btn-sm"></mat-icon>
                          </button>
                        </div>
                      </span>
                      <div *ngIf="showFilterStatusWorkFlow" data-toggle="modal"
                        class="status-filter-dropdown dropdown-modal z-10">
                        <ng-container class="bg-white">
                          <ul class="row m-0 nav list-view p-0 pt-1 h-120 w-165">
                            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0 h-22"
                              *ngFor="let status of statusOrderWorkFlow; let i = index">
                              <span>
                                <input type="checkbox"
                                  id="{{ status.replace('In progress', 'Inprogress').replace('Need more info', 'Needmoreinfo') }}"
                                  (click)="
                                    setCheckboxValWorkFlow(
                                      status.replace('In progress', 'Inprogress').replace('Need more info', 'Needmoreinfo')
                                    )
                                  " (keydown.enter)="
                                    setCheckboxValWorkFlow(
                                      status.replace('In progress', 'Inprogress').replace('Need more info', 'Needmoreinfo')
                                    )
                                  " (keydown.space)="
                                    setCheckboxValWorkFlow(
                                      status.replace('In progress', 'Inprogress').replace('Need more info', 'Needmoreinfo')
                                    )
                                  " tabindex="0" value="{{ status }}" class="edit checkboxAt" />&nbsp;&nbsp;
                                <label class="group-status-1"
                                  [attr.for]="status.replace('In progress', 'Inprogress').replace('Need more info', 'Needmoreinfo')"
                                  [ngStyle]="{ background: getColor2(status) }">
                                  {{ status }}
                                </label>
                              </span>
                            </li>
                          </ul>
                          <div class="modal-footer py-0 pr-0 border-0 mt-2">
                            <button type="button" class="btn btn-custom btn-link bg-none"
                              (click)="showDropdownStatusWorkFlow('close')">
                              Clear
                            </button>
                            <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
                              (click)="filterStatusWorkFlow()">OK</button>
                          </div>
                        </ng-container>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="workFlowDetails.length > 0" #customLoadingTemplate>
                  <tr *ngFor="let detail of workFlowDetails; let i = index" class="forColor">
                    <td>
                      <span><a href="javascript:void(0);" (click)="notesHistoryOpen(detail)"
                          class="font-weight-bold label-darkblue" data-toggle="modal" data-target="#notesHistory">{{
                          detail["requestId"] }}</a>&nbsp;<button class="btn btn-custom btn-purple p-5"
                          *ngIf="superUserShow == true" (click)="openWorkflow(detail['requestId'])">
                          K2
                        </button></span>
                    </td>
                    <td>
                      <a class="label-darkblue" [routerLink]="['/company-details', detail.companyId]">{{
                        detail["supplierName"] }}</a>
                    </td>
                    <td>
                      <span><a href="mailto:{{ detail['RequestorMailId'] }}?subject=ISA - {{ detail['requestId'] }} / {{
                            detail['supplierName']
                          }}" class="underline-pointer color-47525E">{{ detail["requestor"]["displayName"]
                          }}</a></span>
                    </td>
                    <td>
                      <span *ngIf="detail['workflowOwnerWithRole']"><span
                          *ngFor="let owners of detail['workflowOwnerWithRole']" class="d-block">
                          <span *ngIf="owners && owners.length != 7">{{ owners }} ({{ detail["currentValidtor"]
                            }})</span>
                          <span *ngIf="owners && owners.length == 7" class="text-cb4b32">{{ owners }}</span>
                        </span></span>
                      <span *ngIf="!detail['workflowOwnerWithRole']">-</span>
                    </td>
                    <td>{{ detail["strRequestType"] }}</td>
                    <td class="line-break-anywhere">
                      <span *ngIf="detail['historys'].length == 0">{{ detail["lastComment"] ? detail["lastComment"] :
                        "-" }}</span>
                      <span *ngIf="detail['historys'].length > 0"> </span>
                      <span *ngIf="detail['historys'].length == 1">{{
                        detail["historys"][detail["historys"].length - 1]
                        ? detail["historys"][detail["historys"].length - 1]["comment"]
                        : "-"
                        }}</span>

                      <span *ngIf="detail['historys'].length > 1">{{
                        detail["historys"][detail["historys"].length - 1]["route"].trim() != "Submitted"
                        ? detail["historys"][detail["historys"].length - 1]["comment"]
                        : detail["historys"][detail["historys"].length - 2]["comment"]
                        }}</span>
                    </td>
                    <td>{{ detail["creationDate"] ? (detail["creationDate"] | date: "yyyy-MM-dd") : "-" }}</td>
                    <td>
                      <div class="d-flex flex-column w-100">
                        <div class="d-flex align-items-center flex-wrap mb-1">
                          <div class="group-status flex-shrink-0 me-2 nowrap px-4"
                            [ngStyle]="{ background: colorForWorkflow[detail['status']], 'min-width': '82px', height: '27px' }">
                            {{ detail["status"] }}
                          </div>

                          <div class="d-flex align-items-center"
                            *ngIf="detail['workflowOwner'] && detail['workflowOwner'].indexOf(Uid) != -1">
                            <mat-icon svgIcon="confirm" alt="greentick"
                              class="rounded-circle svg-icon green me-1 pointer fs-18 w-18 h-18" (click)="
                                loadWorkflowValidation(
                                  'valid',
                                  detail['folio'],
                                  detail['requestId'],
                                  detail['strRequestType'],
                                  detail['historys'],
                                  detail['currentValidtor']
                                )
                              " (keydown.enter)="
                                loadWorkflowValidation(
                                  'valid',
                                  detail['folio'],
                                  detail['requestId'],
                                  detail['strRequestType'],
                                  detail['historys'],
                                  detail['currentValidtor']
                                )
                              " (keydown.space)="
                                loadWorkflowValidation(
                                  'valid',
                                  detail['folio'],
                                  detail['requestId'],
                                  detail['strRequestType'],
                                  detail['historys'],
                                  detail['currentValidtor']
                                )
                              " tabindex="0" data-toggle="modal" data-target="#showWorkflowValidation"></mat-icon>
                            <mat-icon svgIcon="less" alt="redClose"
                              class="rounded-circle red me-1 pointer fs-18 w-18 h-18"
                              (click)="loadWorkflowValidation('reject', detail['folio'], detail['requestId'])"
                              (keydown.enter)="loadWorkflowValidation('reject', detail['folio'], detail['requestId'])"
                              (keydown.space)="loadWorkflowValidation('reject', detail['folio'], detail['requestId'])"
                              tabindex="0" data-toggle="modal" data-target="#showWorkflowRejection"></mat-icon>
                            <mat-icon *ngIf="commonService.infobtndsp(detail['folio'])" svgIcon="information"
                              class="info-color me-1 pointer fs-18 w-18 h-18"
                              (click)="loadWorkflowValidation('info', detail['folio'], detail['requestId'])"
                              (keydown.enter)="loadWorkflowValidation('info', detail['folio'], detail['requestId'])"
                              (keydown.space)="loadWorkflowValidation('info', detail['folio'], detail['requestId'])"
                              tabindex="0" data-toggle="modal" data-target="#showWorkflowInfoRequest"></mat-icon>
                          </div>
                        </div>

                        <div class="d-flex align-items-center flex-wrap" *ngIf="detail['workflowOwner']">
                          <mat-icon svgIcon="mail" class="icon me-1 blue pointer fs-18 w-18 h-18" *ngIf="
                              detail['workflowOwnerWithRole'] &&
                              roleVariableHide == true &&
                              superUserShow == true &&
                              (detail['status'] == 'In progress' || detail['status'] == 'Need more info') &&
                              detail['date'] == true &&
                              detail['supportipn'] == false
                            " data-toggle="modal" data-target="#createMailModalPopup" (click)="
                              updatemailModelName(detail['historys'], detail['folio'], detail['requestId'], detail['difference'], detail)
                            " (keydown.enter)="
                              updatemailModelName(detail['historys'], detail['folio'], detail['requestId'], detail['difference'], detail)
                            " (keydown.space)="
                              updatemailModelName(detail['historys'], detail['folio'], detail['requestId'], detail['difference'], detail)
                            " tabindex="0"></mat-icon>
                          <span class="text-primary fs-14" *ngIf="detail['difference']">({{ detail["difference"]
                            }}&nbsp;d)</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="workFlowDetails.length == 0" #customLoadingTemplate>
                  <tr>
                    <td class="label-darkblue text-center font-weight-bold" colspan="6">No Results</td>
                  </tr>
                </tbody>

                <ng-container *ngIf="loading">
                  <div class="local-loading-overlay">
                    <div class="custom-spinner-template">
                      <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                    </div>
                  </div>
                </ng-container>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 p-0 pr-4">
      <section></section>
    </div>
  </div>
  <div *ngIf="companyExist == false">No Company Found Or Something error!!!</div>
</div>

<div class="modal fade" id="companynameModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelChangeCompanyName">
          Change company name by <span class="label-darkblue">Admin</span>
          <button type="button" class="close" id="closeCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="CompanyNameFieldInput">Company Name</label>
            <input type="text" [attr.maxLength]="maxCpyNameLength" class="form-control form-control-sm"
              id="CompanyNameFieldInput" [(ngModel)]="companyNameModelval" (keyup)="
                checkvalidateCompanyNameField(
                  companyNameModelval,
                  'companyNameModelval',
                  'companyNameModelvalerror',
                  'companyNameModelvalRegExError'
                )
              " (ngModelChange)="companyNameModelval = $event.toUpperCase()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
                (click)="resetSelectedFields()" (keydown.enter)="resetSelectedFields()"
                (keydown.space)="resetSelectedFields()" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="companyNameModelvalerror == true">Please enter company name!!!</span>
            <span class="text-cb4b32" *ngIf="companyNameModelvalRegExError == true">A-Z 0-9 space () . , - /</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateCompanyName()"
            [disabled]="disableUpdateCpyNameBtn == true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="d-none">
  <table id="excelTableLog">
    <thead>
      <tr>
        <th>Identifiers</th>
        <th>Updated</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Data of TableData">
        <td>
          {{ Data["identifier"] ? Data["identifier"] : "-" }}
        </td>
        <td>
          {{ Data["updated"] ? Data["updated"] : "-" }}
        </td>
        <td>
          {{ Data["reverted"] ? Data["reverted"] : "-" }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal fade" id="AddTaxIdentfiers" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddTaxIdentifiers">
          Add Tax Identifier
          <button type="button" class="close" id="closeAddTax" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="taxIdentifierTypeSelect">Tax Identifier Type </label>
            <mat-select id="taxIdentifierTypeSelect" class="form-control form-control-sm dropdown-select"
              [(ngModel)]="TaxTypeIdnetifierModel"
              (selectionChange)="changeTaxType($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option *ngFor="let TaxiType of TaxIdentifierType" [value]="TaxiType['row_id']">{{ TaxiType["name"]
                }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="IdnetifierTypeError == true">Please select the Tax Identifier Type.</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="addTaxIdenInput">Value </label>
            <input type="text" id="addTaxIdenInput" class="form-control form-control-sm"
              [(ngModel)]="NewIdnetifierValue" (keyup)="emptyCheck()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetTaxidentif()" (keydown.enter)="resetTaxidentif()" tabindex="0">×</button></span>
            <span class="text-cb4b32" *ngIf="IdnetifierValueError == true">Please enter the value.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" [disabled]="disableSaveBtnAlias" class="btn btn-custom btn-custom-sm btn-blue"
            data-target="#showAliasAddModal" data-toggle="modal" (click)="checkForValidation('addtaxidentifier')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openblankStatusUpdate" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelOpenBlankStatusUpdate">
          Blank Status Update
          <button type="button" class="close" id="closeblankStatusUpdate" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <h6>
          Do you really want to make a blank Status update on Company {{ companyBasicInfo ?
          companyBasicInfo["allianceIdentifier"] : "" }}
          {{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }} and its belongings ?
        </h6>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="blankStatusUpdate()">
            <span class="float-right"> Update </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showBlankUpdateProcess" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelShowBlankUpdateProcess">
          Blank status Update Process
          <button type="button" class="close" id="closeImportIpnProcess" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">
              <span class="label-darkblue">{{ TextForCompleteUpload }}</span>
            </div>
            <div class="py-2" *ngIf="blankUpdateCompleted">
              <span class="label-darkblue">Loading</span><small><img src="assets/images/loading.gif"
                  class="loadingheight" alt="Updating..." /></small>
            </div>
            <div class="py-2" *ngIf="!blankUpdateCompleted">
              <button class="btn btn-custom btn-blue btn-tax" (click)="downloadUploadLogFile()">Download Log
                File</button>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="companyStatusPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelCompanyStatusPopup">
          Change Company Status by ADMIN
          <button type="button" class="close" id="closeCmpStatus" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="companyStatusSelect">New Status</label>
            <mat-select id="companyStatusSelect" class="form-control form-control-sm dropdown-select" [(ngModel)]="cmpStausModel"
              (selectionChange)="changecmpStaus($event.value)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <ng-container *ngFor="let CmpStatus of CompanyStatusAll">
                <mat-option *ngIf="CmpStatus['code'] !== 'Registered' && CmpStatus['code'] !== 'Pending' && CmpStatus['code'] !== 'Waiting for Approval'"
                  [value]="CmpStatus['row_id'] + '===' + CmpStatus['code']">{{
                  CmpStatus["code"]
                  }}</mat-option>
              </ng-container>
            </mat-select>
            <span class="text-cb4b32" *ngIf="CmpStaError == true">Please select the New Staus.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="MDMSynchroMode">
            <label class="label label-default d-inline-flex align-items-center m-0 pr-2">MDM Synchro Mode :
              <label for="toBeTransmitted"
                class="label label-default d-inline-flex align-items-center m-0 px-1"><input type="radio"
                  name="mdmSynchroMode" id="toBeTransmitted" class="mr-1" checked />To Be Transmitted</label>
              <label for="technicallyRejected"
                class="label label-default d-inline-flex align-items-center m-0 px-1"><input type="radio"
                  name="mdmSynchroMode" id="technicallyRejected" class="mr-1" />Technically Rejected</label>
            </label>
            <label for="synchronized"
              class="label label-default d-flex align-items-center justify-content-center m-0 px-1"><input type="radio"
                name="mdmSynchroMode" id="synchronized" class="mr-1" />Synchronized</label>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="SaveNewCmpStatus()"
            [disabled]="disableChangeCpyStatus == true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="createMailModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelCreateMailModalPopup">
          Reminder
          <button type="button" class="close" id="closeCCBtnReminder" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="mb-3">
              <p class="mb-1">
                <strong>{{ currentModalDetail?.allianceId }} {{ currentModalDetail?.supplierName }}</strong>
              </p>
              <p class="mb-1">
                <strong>Approver : </strong>
                <span *ngIf="currentModalDetail?.workflowOwnerWithRole"><span
                    *ngFor="let owners of currentModalDetail.workflowOwnerWithRole">
                    <span *ngIf="owners && owners.length != 7">{{ owners }} ({{ currentModalDetail.currentValidtor
                      }})</span>
                    <span *ngIf="owners && owners.length == 7" class="text-cb4b32">{{ owners }}</span>
                  </span></span>
                <span *ngIf="!currentModalDetail?.workflowOwnerWithRole">-</span>
              </p>
              <p class="mb-1"><strong>Send to : </strong> {{ approverEmail }}</p>
            </div>
            <label class="label-control" for="reminderNotesModel">
              <h4 class="title ml-8 px-2">Reminder Notes</h4>
            </label>
            <div class="textAreaClear">
              <textarea id="reminderNotesModel" rows="3" cols="60" [(ngModel)]="MailNameModel"> </textarea>
              <span class="ng-clear-wrapper" title="Clear all"><button class="ng-clear textClear cancel"
                  (click)="resetCompanyNameFields()" (keydown.enter)="resetCompanyNameFields()" tabindex="0">
                  ×
                </button></span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button class="btn btn-custom btn-blue float-right mb-4 br-025" (click)="sendblueRequestForMailToApp()">
            <img src="assets/images/mail-wt-md.png" class="img-btn img-btn-lg mr-8" alt="" />
            Send to Approver
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="AddCmpAlias" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddCmpAlias">
          Add Company Identifiers
          <button type="button" class="close" id="closeAddCmpAlias" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="cmpAliasTypeSelect">Type </label>
            <mat-select id="cmpAliasTypeSelect" class="form-control form-control-sm" [(ngModel)]="CmpAlliasTypeModel"
              (selectionChange)="changeCmpAllias($event, CmpAlliasTypeModel)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option value="dup" [hidden]="true" [disabled]="true"></mat-option>
              <mat-option *ngFor="let CmpAliaType of compAliasType" [value]="CmpAliaType['row_id']">{{
                CmpAliaType["name"] }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="CmpAlliasTypeError == true">Please select the Type.</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="newCpyAliasValId">Value </label>
            <input type="text" id="newCpyAliasValId" class="form-control form-control-sm"
              [(ngModel)]="NewCmpAlliasValue" (keyup)="CmpEmptyCheck($event)" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCompanyValue()" (keydown.enter)="resetCompanyValue()" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpAlliasValueError == true">Please enter the value.</span>
            <span class="text-cb4b32" *ngIf="newCpyAliasRegExError == true">Please enter a Alphanumeric value.</span>
            <span class="text-cb4b32" *ngIf="newCpyAlcorRegExError == true">Please enter a Numeric value[0-9].</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue ml-n52p" *ngIf="CmpAlliasTypeModel == '5'"
            (click)="addnewMdm()">
            <span><mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right">New MDM
                value</span></span>
          </button>
          <button type="button" class="btn btn-custom btn-link ml-49p" *ngIf="CmpAlliasTypeModel == '5'"
            data-dismiss="modal">
            Cancel
          </button>
          <button type="button" [disabled]="disableSaveBtnAliaCpy" class="btn btn-custom btn-custom-sm btn-blue"
            data-toggle="modal" data-target="#showAliasAddModal" *ngIf="CmpAlliasTypeModel == '5'"
            (click)="checkForValidation('addcpyalias')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
          <button type="button" class="btn btn-custom btn-link" *ngIf="CmpAlliasTypeModel != '5'"
            data-dismiss="modal">Cancel</button>
          <button type="button" [disabled]="disableSaveBtnAliaCpy" *ngIf="CmpAlliasTypeModel != '5'"
            class="btn btn-custom btn-custom-sm btn-blue" data-toggle="modal" data-target="#showAliasAddModal"
            (click)="checkForValidation('addcpyalias')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditCmpAlias" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditCmpAlias">
          Edit Company Identifiers by ADMIN
          <button type="button" class="close" id="closeEditCmpAlias" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="editAliasModelId">
              {{ EditAliasObj.AliasType }}
              <span *ngIf="EditAliasObj.AliasType == 'ALCOR'">Code</span>
            </label>
            <input type="text" id="editAliasModelId" class="form-control form-control-sm"
              [disabled]="disableInputForMDM == true || EditAliasObj.AliasType == 'ALCOR'" [(ngModel)]="EditAliasModel"
              (keyup)="EditAliasEmptyCheck($event)" />
            <span *ngIf="disableInputForMDM == false || EditAliasObj.AliasType != 'ALCOR'"
              class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCompanyAlias()" (keydown.enter)="resetCompanyAlias()" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="EditCmpAlliasValueError == true">Please enter the value.</span>
            <span class="text-cb4b32" *ngIf="EditCmpAlliasRegExError == true">Please enter a Alphanumeric value.</span>
            <span class="text-cb4b32" *ngIf="EditCmpAlliasRegExNumError == true">Please enter a Numeric value
              [0-9].</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="EditAliasObj.AliasType == 'ALCOR'">
            <label class="label-control" for="editRaftNameForAlcorId"> ALCOR Name </label>
            <input id="editRaftNameForAlcorId" type="text" maxlength="10" class="form-control form-control-sm"
              [(ngModel)]="editRaftNameForAlcor"
              (keyup)="checkRegexAlcorName(editRaftNameForAlcor, 'editRaftNameForAlcor')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCompanyAlias('name')" (keydown.enter)="resetCompanyAlias('name')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="alcorNameRegExError == true">Please Enter Numerical or Uppercase
              only</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow col">
          <button type="button" *ngIf="valArchived == false" class="btn btn-custom btn-custom-sm bg-cb4b32"
            (click)="getCompanyIdentifiersForArchive()">
            <mat-icon svgIcon="delete" class="img-btn mr-1 pb-1" alt="DEL"></mat-icon><span class="float-right"> Archive
            </span>
          </button>
          <button type="button" *ngIf="valArchived == true" class="btn btn-custom btn-custom-sm bg-cb4b32"
            (click)="getCompanyIdentifiersForUnArchive()">
            <mat-icon svgIcon="delete" class="img-btn mr-1 pb-1" alt="DEL"></mat-icon><span class="float-right">
              Unarchive </span>
          </button>
          <button class="btn btn-custom btn-blue ml-70" *ngIf="showSwitch == true && EditAliasObj.AliasType != 'ALCOR'"
            (click)="SwitchToGtop(EditAliasObj.AliasType)">
            {{ switchBtnText }}
          </button>
          <button type="button" class="btn btn-custom btn-link"
            [ngStyle]="{ 'margin-left': showSwitch == true ? '20px' : '210px' }" data-dismiss="modal"
            id="closeArchiveAlias">
            Cancel
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue fixed mt-3px"
            [disabled]="disableInputForMDM == true || disableEditCpyAlias == true"
            (click)="EditSaveCmpAllias(EditAliasObj.AliasType)">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="alcorRequestPopup" tabindex="-1" aria-modal="true" aria-labelledby="alcorRequestModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="alcorRequestModalLabel">
          Manage ALCOR-REQUEST
          <button type="button" class="close" id="closeAlcorRequestPopup" data-dismiss="modal" aria-label="Close"
            (click)="closeAlcorRequestPopup()">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0" *ngIf="selectedAlcorRequest">
        <section class="row m-0 bg-white no-shadow">
          <div class="col-12">
            <label for="selectedAlcorRequestValue">ALCOR-REQUEST</label>
            <input id="selectedAlcorRequestValue" type="text" class="form-control form-control-sm mb-20"
              [(ngModel)]="selectedAlcorRequest.value" />
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow col">
          <button type="button" *ngIf="!selectedAlcorRequest?.endDate" class="btn btn-custom btn-custom-sm bg-cb4b32"
            (click)="archiveAlcorRequest()" data-dismiss="modal">
            <mat-icon svgIcon="delete" class="img-btn mr-1 pb-1" alt="Archive"></mat-icon>
            <span class="float-right">Archive</span>
          </button>
          <button type="button" *ngIf="selectedAlcorRequest?.endDate" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="unarchiveAlcorRequest()" data-dismiss="modal">
            <mat-icon svgIcon="delete" class="img-btn mr-1 pb-1" alt="Unarchive"></mat-icon>
            <span class="float-right">Unarchive</span>
          </button>
          <button type="button" *ngIf="selectedAlcorRequest?.endDate"
            class="btn btn-custom btn-custom-sm ml-2 bg-cb4b32" (click)="deleteAlcorRequest()" data-dismiss="modal">
            <mat-icon svgIcon="delete" class="img-btn mr-1 pb-1" alt="Delete"></mat-icon>
            <span class="float-right">Delete</span>
          </button>
          <button type="save" class="btn btn-custom btn-blue d-flex align-center float-right ml-1"
            (click)="saveAlcorRequest()" data-toggle="modal">
            <span class="float-right">Save</span>
          </button>
          <button type="button" class="btn btn-custom btn-link float-right ml-auto" data-dismiss="modal"
            (click)="closeAlcorRequestPopup()">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="addAlcorCodePopup" tabindex="-1" aria-modal="true" aria-labelledby="addAlcorCodeModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="addAlcorCodeModalLabel">
          <span *ngIf="!isStep2">Send Request to ALCOR</span>
          <span *ngIf="isStep2 && alcorRequestType === 'new'">Request for new ALCOR code</span>
          <span *ngIf="isStep2 && alcorRequestType === 'update'">Request for ALCOR update</span>
          <span *ngIf="isStep2 && alcorRequestType === 'addPaying'">Request for adding new Paying Companies</span>

          <button type="button" class="close" id="closeAddAlcorCodePopup" data-dismiss="modal" aria-label="Close"
            (click)="closeAddAlcorCodePopup()">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0">
        <section class="row m-0 bg-white no-shadow" *ngIf="!isStep2">
          <div class="col-12">
            <h6 class="font-weight-bold mb-3">{{ companyBasicInfo.allianceIdentifier }} {{ companyBasicInfo.legalName }}
            </h6>

            <div class="form-check mb-3">
              <input class="form-check-input" type="radio" name="alcorRequestType" id="newAlcorCode" value="new"
                [(ngModel)]="alcorRequestType" [disabled]="!canRequestNewAlcorCode()"
                (change)="onAlcorRequestTypeChange()" />
              <label class="form-check-label" for="newAlcorCode" [class.text-muted]="!canRequestNewAlcorCode()">
                Request for new ALCOR code on Paying Company:
              </label>

              <div class="ml-4 mt-2" *ngIf="alcorRequestType === 'new'">
                <mat-select class="form-control form-control-sm dropdown-select"
                  [(ngModel)]="selectedPayingCompanyForAlcor" panelClass="dropdown-panel"
                  [disableOptionCentering]="true" placeholder="-- Select Paying Company --">
                  <mat-option *ngIf="!pendingPayingCompanies || pendingPayingCompanies?.length === 0" disabled>No
                    results</mat-option>
                  <mat-option *ngFor="let pc of pendingPayingCompanies" [value]="pc.clientCompanyCode">
                    {{ pc.clientCompanyCode }} - {{ pc.clientCompanyLegalName }}
                  </mat-option>
                </mat-select>
              </div>
            </div>

            <div class="form-check mb-3">
              <input class="form-check-input" type="radio" name="alcorRequestType" id="updateAlcorCode" value="update"
                [(ngModel)]="alcorRequestType" (change)="onAlcorRequestTypeChange()"
                [disabled]="alcorValueCpy?.length !== 1" />
              <label class="form-check-label" for="updateAlcorCode"
                [ngClass]="{ 'text-muted': alcorValueCpy?.length !== 1 }">
                Request for ALCOR update
              </label>
            </div>

            <div class="form-check mb-3">
              <input class="form-check-input" type="radio" name="alcorRequestType" id="addPayingCompanies"
                value="addPaying" [(ngModel)]="alcorRequestType" (change)="onAlcorRequestTypeChange()"
                [disabled]="alcorValueCpy?.length !== 1 || pendingPayingCompanies?.length === 0" />
              <label class="form-check-label" for="addPayingCompanies"
                [ngClass]="{ 'text-muted': alcorValueCpy?.length !== 1 || pendingPayingCompanies?.length === 0 }">
                Request for adding new Paying Companies:
              </label>

              <div *ngIf="alcorRequestType === 'addPaying'" class="ml-4 mt-2">
                <mat-select class="form-control form-control-sm dropdown-select" multiple
                  [(ngModel)]="selectedPayingCompaniesForAlcor" panelClass="dropdown-panel"
                  [disableOptionCentering]="true" placeholder="Select Paying Companies">
                  <mat-option *ngIf="!pendingPayingCompanies || pendingPayingCompanies?.length === 0" disabled>No
                    results</mat-option>
                  <mat-option class="matOption" *ngFor="let pc of pendingPayingCompanies" [value]="pc.clientCompanyCode">
                    {{ pc.clientCompanyCode }} - {{ pc.clientCompanyLegalName }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </section>

        <section class="row m-0 bg-white no-shadow" *ngIf="isStep2">
          <div class="col-12">
            <h6 class="font-weight-bold mb-3">{{ companyBasicInfo.allianceIdentifier }} {{ companyBasicInfo.legalName }}
            </h6>

            <div *ngIf="!isAlcorRequestLoading">
              <div *ngIf="alcorRequestType !== 'addPaying'" class="mb-4">
                <div *ngIf="selectedPayingCompanyDetails && alcorRequestType === 'new'" class="mb-2">
                  Paying Company:
                  <span class="font-weight-bold">{{ selectedPayingCompanyDetails.clientCompanyCode }} {{
                    selectedPayingCompanyDetails.clientCompanyLegalName }}</span>
                </div>

                <div class="mb-4">
                  <div class="font-weight-bold mb-2">Select documents to be sent:</div>

                  <div *ngIf="activeDocumentsForAlcor?.length === 0" class="text-muted">No active accounting documents
                    available.</div>

                  <div *ngIf="activeDocumentsForAlcor?.length > 0">
                    <mat-select class="form-control form-control-sm dropdown-select" multiple
                      [(ngModel)]="selectedDocumentsIds" (selectionChange)="onDocumentMultiSelectChange($event)"
                      panelClass="dropdown-panel" [disableOptionCentering]="true" placeholder="Select documents">
                      <ng-container *ngFor="let docs of activeDocumentsForAlcor; let i = index">
                        <mat-option class="matOption" *ngIf="
                            alcorRequestType === 'update' ||
                            (alcorRequestType === 'new' && !selectedPayingCompanyDetails) ||
                            selectedPayingCompanyDetails
                          " [value]="docs">
                          <span>{{ docs["fields"]["Document_x0020_Type"] ? docs["fields"]["Document_x0020_Type"] : "-"
                            }}</span>
                          {{ docs["fields"]["LinkFilename"] }}
                          {{ docs["fields"]["Paying_x0020_Company"] ? docs["fields"]["Paying_x0020_Company"] : "-" }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </div>
                  <div class="form-group mt-3">
                    <label class="font-weight-bold mb-2" for="alcorRequestComments">Comments:</label>
                    <textarea id="alcorRequestComments" class="form-control comments-input no-resize-overflow"
                      [(ngModel)]="alcorRequestComments"
                      cdkTextareaAutosize cdkAutosizeMinRows="1" maxlength="100"
                      placeholder="Enter comments (max 100 characters)">
                    </textarea>
                  </div>
                </div>
              </div>

              <div *ngIf="alcorRequestType === 'addPaying'" class="mb-4">
                <div *ngFor="let payingCompanyCode of selectedPayingCompaniesForAlcor; let i = index" class="mb-4">
                  <div class="mb-2">
                    Paying Company:
                    <span class="font-weight-bold">{{ getPayingCompanyDetails(payingCompanyCode)?.clientCompanyCode }}
                      {{ getPayingCompanyDetails(payingCompanyCode)?.clientCompanyLegalName }}</span>
                  </div>

                  <div class="mb-3">
                    <div class="font-weight-bold mb-2">Select documents to be sent:</div>

                    <div *ngIf="getDocumentsForPayingCompany(payingCompanyCode)?.length === 0" class="text-muted">
                      No active accounting documents available for this paying company.
                    </div>

                    <div *ngIf="getDocumentsForPayingCompany(payingCompanyCode)?.length > 0">
                      <mat-select class="form-control form-control-sm dropdown-select" multiple
                        [(ngModel)]="selectedDocumentsByCompany[payingCompanyCode]"
                        (selectionChange)="onDocumentMultiSelectChangeByCompany($event, payingCompanyCode)"
                        panelClass="dropdown-panel" [disableOptionCentering]="true" placeholder="Select documents">
                        <mat-option class="matOption" *ngFor="let docs of getDocumentsForPayingCompany(payingCompanyCode); let i = index"
                          [value]="docs">
                          <span>{{ docs["fields"]["Document_x0020_Type"] ? docs["fields"]["Document_x0020_Type"] : "-"
                            }}</span>
                          {{ docs["fields"]["LinkFilename"] }}
                          {{ docs["fields"]["Paying_x0020_Company"] ? docs["fields"]["Paying_x0020_Company"] : "-" }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                  <div class="form-group mt-3">
                    <label class="font-weight-bold mb-2" for="alcorRequestCommentsByCompany-{{ i }}">Comments:</label>
                    <textarea id="alcorRequestCommentsByCompany-{{ i }}" class="form-control comments-input no-resize-overflow"
                      [(ngModel)]="alcorRequestCommentsByCompany[payingCompanyCode]" cdkTextareaAutosize
                      cdkAutosizeMinRows="1" maxlength="100" placeholder="Enter comments (max 100 characters)">
                    </textarea>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="isAlcorRequestLoading" class="text-left">
              <div *ngFor="let task of alcorBlindTasksResponse" class="mb-4">
                <div class="mb-2">
                  <strong>{{ getPayingCompanyDetails(task.payingCompanyCode)?.clientCompanyCode }}
                    {{ getPayingCompanyDetails(task.payingCompanyCode)?.clientCompanyLegalName }}</strong>
                </div>
                <div class="mb-2">
                  <strong>Request:</strong> <span class="ml-2">{{ task.requestId }}</span>
                </div>
                <div class="mb-2">
                  <strong>Status:</strong> <span class="ml-2">{{ task.status }}</span>
                </div>
                <div class="mb-2">
                  <strong>Reason:</strong> <span class="ml-2">{{ task.reason || "" }}</span>
                </div>
                <div class="mb-2">
                  <strong>Files:</strong> <span class="ml-2 word-break">{{ task.filename }}</span>
                </div>
              </div>
              <div class="mt-3">
                <span *ngIf="!isAlcorRequestComplete" class="text-muted float-right fs-14">Please wait...</span>
                <button *ngIf="isAlcorRequestComplete" type="button" class="btn btn-custom btn-blue float-right"
                  (click)="closeAddAlcorCodePopup()">
                  Close
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow col">
          <div *ngIf="!isStep2">
            <button type="button" class="btn btn-custom btn-link float-left" data-dismiss="modal"
              (click)="closeAlcorRequestPopup()">
              Cancel
            </button>
            <button type="button" class="btn btn-custom btn-blue float-right" [disabled]="!isNextButtonEnabled()"
              (click)="goToStep2()">
              Next &gt;
            </button>
          </div>

          <div *ngIf="isStep2 && !isAlcorRequestLoading">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
              (click)="closeAddAlcorCodePopup()">Cancel</button>
            <button type="button" class="btn btn-custom btn-blue float-right" (click)="sendAlcorRequest()">Send
              Request</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="ChangeGrp" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddSiteAdmin">
          Update Group link
          <button type="button" class="close" id="closeChangeGrp" #closeBtn (click)="resetAutocomplete()"
            data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow" *ngIf="changeGroupModal == 'default'">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="changeGroupNameInput">Group </label>
            <p class="pr-4 m-0"></p>
            <div class="form-control form-control-sm matformheight">
              <form class="w-325">
                <mat-form-field class="w-325">
                  <input id="changeGroupNameInput" class="w-325" matInput aria-label="State" [matAutocomplete]="auto"
                    [formControl]="userQuestionUpdate2" />
                  <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete d-block">
                    <ng-container *ngIf="GroupCatptins.length > 0; else noResults">
                      <mat-option class="w-325 border-bottom-gray" *ngFor="let value of GroupCatptins"
                        (click)="onGrpSelect(value)" (keydown.enter)="onGrpSelect(value)" tabindex="0" [value]="value">
                        <span>{{ value }}</span>
                      </mat-option>
                    </ng-container>
                    <ng-template #noResults>
                      <mat-option class="noResults" disabled
                        *ngIf="(GrpNameModel ? GrpNameModel.length >= 2 : false) && !autoLoadGrpName">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
                <small class="float-right search-close-btn" title="Clear"><button type="button" class="cancel"
                    (click)="clearFields('GrpNameModel')" (keydown.enter)="clearFields('GrpNameModel')"
                    (keydown.space)="clearFields('GrpNameModel')" tabindex="0">
                    X
                  </button></small>
                <small class="float-right search-close-btn" *ngIf="autoLoadGrpName"><img src="assets/images/loading.gif"
                    class="loadingheight" alt="Updating..." /></small>
              </form>
            </div>
            <span class="text-cb4b32" *ngIf="GrpNameError == true">Please select the Group.</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="changeGroupIdInput">Group ID </label>
            <p class="pr-4 m-0"></p>
            <div class="form-control form-control-sm matformheight">
              <form class="w-325">
                <mat-form-field class="w-325">
                  <input id="changeGroupIdInput" class="w-325" matInput aria-label="State" [matAutocomplete]="auto1"
                    [formControl]="delayGrpAllianceId" />
                  <mat-autocomplete #auto1="matAutocomplete" class="custom-autocomplete d-block">
                    <ng-container *ngIf="changeGroupAllianceId.length > 0; else noResults1">
                      <mat-option class="w-325 border-bottom-gray" *ngFor="let value of changeGroupAllianceId"
                        (click)="onIdentivalueSelectUpdateAlliance(value)"
                        (keydown.enter)="onIdentivalueSelectUpdateAlliance(value)"
                        (keydown.space)="onIdentivalueSelectUpdateAlliance(value)" tabindex="0" [value]="value">
                        <span>{{ value }}</span>
                      </mat-option>
                    </ng-container>
                    <ng-template #noResults1>
                      <mat-option class="noResults" disabled *ngIf="groupAllianceIdModel.length >= 5 && !autoLoadGrpId">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
                <small class="float-right search-close-btn" title="Clear"><button type="button" class="cancel"
                    (click)="clearFields('groupAllianceIdModel')" (keydown.enter)="clearFields('groupAllianceIdModel')"
                    (keydown.space)="clearFields('groupAllianceIdModel')" tabindex="0">
                    X
                  </button></small>
                <small class="float-right search-close-btn" *ngIf="autoLoadGrpId"><img src="assets/images/loading.gif"
                    class="loadingheight" alt="Updating..." /></small>
              </form>
            </div>

            <span class="text-cb4b32" *ngIf="GrpAllianceError == true">Please select the Group Alliance ID.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="changeGroupShortNameInput">Group Short Name </label>
            <p class="pr-4 m-0"></p>
            <div class="form-control form-control-sm matformheight">
              <form class="w-325">
                <mat-form-field class="w-325">
                  <input id="changeGroupShortNameInput" class="w-325" matInput aria-label="State" [matAutocomplete]="auto2"
                    [formControl]="delayGrpShortName" />
                  <mat-autocomplete #auto2="matAutocomplete" class="custom-autocomplete d-block">
                    <ng-container *ngIf="changeGroupShortName.length > 0; else noResults2">
                      <mat-option class="w-325 border-bottom-gray" (click)="onIdentivalueSelect(value)"
                        (keydown.enter)="onIdentivalueSelect(value)" (keydown.space)="onIdentivalueSelect(value)"
                        tabindex="0" *ngFor="let value of changeGroupShortName" [value]="value">
                        <span>{{ value }}</span>
                      </mat-option>
                    </ng-container>
                    <ng-template #noResults2>
                      <mat-option class="noResults" disabled
                        *ngIf="groupShortNameModel.length >= 2 && !autoLoadGrpSrtName">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
                <small class="float-right search-close-btn" title="Clear"><button type="button" class="cancel"
                    (click)="clearFields('groupShortNameModel')" (keydown.enter)="clearFields('groupShortNameModel')"
                    (keydown.space)="clearFields('groupShortNameModel')" tabindex="0">
                    X
                  </button></small>
                <small class="float-right search-close-btn" *ngIf="autoLoadGrpSrtName"><img
                    src="assets/images/loading.gif" class="loadingheight" alt="Updating..." /></small>
              </form>
            </div>

            <span class="text-cb4b32" *ngIf="GrpShortNameError == true">Please select a valid Group ShortName.</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="changeGroupingTypeSelect">Grouping Type </label>
            <mat-select id="changeGroupingTypeSelect" class="form-control form-control-sm" [(ngModel)]="GrpingTypeModel"
              (selectionChange)="changeGrpingType($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option *ngFor="let GrpTyping of GroupingTypeAll" [value]="GrpTyping['row_id']">{{
                GrpTyping["groupAssignementTypeCode"]
                }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="GrpingTypeError == true">Please select the Grouping Type.</span>
          </div>
        </section>

        <section class="row m-0 bg-white no-shadow" *ngIf="changeGroupModal == 'change'">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span class="font-weight-bold" [innerHtml]="chgGroupTextDisp"></span>
          </div>
        </section>
        <section class="row m-0 bg-white no-shadow" *ngIf="changeGroupModal == 'change1'">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span class="font-weight-bold">
              <img src="assets/images/warning.png" class="img-btn mr-2" alt="" /> This Company was the Representing of
              the Group
              {{ oldIdentifier }}-<a data-dismiss="modal"
                [routerLink]="['/supplier-group-details', oldId ? oldId : '']">{{ oldName }}</a>
              ;Please review the Group to set its new Representing Company.
            </span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0" *ngIf="changeGroupModal == 'default'">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" (click)="resetAutocomplete()"
            data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UpdateCmpGrp()"
            [disabled]="disableGroupLinkBtn == true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
      <div class="modal-footer border-0" *ngIf="changeGroupModal == 'change'">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">
            {{ changeGroupButtonText }}
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="computeNewGTOPModalPopup" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelComputeNewGTOP">
          Compute new GTOP
          <button type="button" class="close" id="closeCNGBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fs-14 fw-bold mb-7">Supplier Legal Name : <span class="label-darkblue">{{
                companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
            </div>
            <div class="label-control fs-15 fw-bold">
              <img *ngIf="computeDataButtonShow == false" src="assets/images/warning.png" class="img-btn mr-2"
                alt="warning" />{{
              computeGTOPWarningText
              }}
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" *ngIf="!showCancelOrange" class="btn btn-custom btn-blue px-3"
            data-dismiss="modal">Cancel</button>
          <button type="button" *ngIf="showCancelOrange" class="btn btn-custom btn-link"
            data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" *ngIf="computeDataButtonShow == true"
            (click)="saveComputeNewGtop()">
            <mat-icon src="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{ computeDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="AddSiteAdmin" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddnewCmpContacts">
          Add Site to Company
          <button type="button" class="close" id="closeCmpSites" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0 custom-size">
            <label class="label-control" for="addSiteToCompanyInput">Site<span class="text-cb4b32">*</span></label>
            <P class="m-0"> </P>
            <div class="form-control form-control-sm matformheight">
              <form class="w-325">
                <mat-form-field class="w-325">
                  <input id="addSiteToCompanyInput" class="w-325" matInput aria-label="State" [matAutocomplete]="auto3"
                    [formControl]="userQuestionUpdate3" />
                  <mat-autocomplete #auto3="matAutocomplete" class="custom-autocomplete d-block">
                    <ng-container *ngIf="addSiteCaptains.length > 0; else noResults">
                      <mat-option class="w-325 border-bottom-gray" *ngFor="let value of addSiteCaptains"
                        [value]="value">
                        <span>{{ value }}</span>
                      </mat-option>
                    </ng-container>
                    <ng-template #noResults>
                      <mat-option class="noResults" disabled *ngIf="addSiteNameModel.length >= 2 && !autoLoadSiteName">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
                <small class="float-right search-close-btn" title="Clear"><button type="button" class="cancel"
                    (click)="resetaddSite2cmp('addSiteNameModel')"
                    (keydown.enter)="resetaddSite2cmp('addSiteNameModel')"
                    (keydown.space)="resetaddSite2cmp('addSiteNameModel')" tabindex="0">
                    X
                  </button></small>
                <small class="float-right search-close-btn" *ngIf="autoLoadSiteName"><img
                    src="assets/images/loading.gif" class="loadingheight" alt="Updating..." /></small>
              </form>
            </div>

            <span class="text-cb4b32" *ngIf="addSiteNameError == true">Please Enter the Site.</span>
          </div>
          <br />
          <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="addSiteToCompanyBvdInput">BvD ID<span class="text-cb4b32">*</span></label>
            <input id="addSiteToCompanyBvdInput" type="text" autocomplete="off" class="form-control form-control-sm"
              [(ngModel)]="addSiteBvdIdModel"
              (keyup)="BvdIdEmptyCheck('BvdId')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetaddSite2cmp('BvdId')" (keydown.enter)="resetaddSite2cmp('BvdId')"
                (keydown.space)="resetaddSite2cmp('BvdId')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="addSiteBvdIdError == true">Please enter the BvD Id.</span>
          </div>
          <br />
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="SaveAddSite2Cmp()"
            [disabled]="disableAddSiteAdmin == true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal-above" id="AddnewCmpContacts" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddCmpContacts">
          Add Company Contact
          <button type="button" class="close" id="closeCmpContacts1" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <div class="mb-2 pl-3"><span class="fw-bold">Company : </span> {{ companyBasicInfo ?
          companyBasicInfo["legalName"] : "" }}</div>
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="addCmpContactEmailInput">Email<span class="text-cb4b32">*</span></label>
            <input id="addCmpContactEmailInput" type="email" class="form-control form-control-sm" [(ngModel)]="CmpConEmail"
              (change)="checkEmailChanged()" (keyup)="CmpCntemptyCheck('Email')" (focusout)="focusOutFunctionEmail()"
              [disabled]="disableEmail == true" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Email')" (keydown.enter)="resetCmpContact('Email')"
                (keydown.space)="resetCmpContact('Email')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConEmailError == true">Please Enter the Email.</span>
            <span class="text-cb4b32" *ngIf="CmpConEmailFormatError == true">Please Enter a Valid Email.</span>
          </div>

          <div class="mb-2 pl-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="comp_modelLabelName">
            <span class="fw-bold">Name : </span> {{ compModelName }}
          </div>
          <div class="mb-2 pl-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="comp_modelIpn">
            <span class="fw-bold">IPN : </span> {{ compModelIpn }}
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="comp_modelFname">
            <label class="label-control" for="addCmpContactFirstNameInput">First Name<span class="text-cb4b32">*</span></label>
            <input id="addCmpContactFirstNameInput" type="text" autocomplete="off"
              class="form-control form-control-sm" [(ngModel)]="CmpConFname"
              (keyup)="CmpCntemptyCheck('Fname')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Fname')" (keydown.enter)="resetCmpContact('Fname')"
                (keydown.space)="resetCmpContact('Fname')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConFnameError == true">Please Enter the First Name.</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="comp_modelLname">
            <label class="label-control" for="addCmpContactLastNameInput">Last Name<span class="text-cb4b32">*</span></label>
            <input id="addCmpContactLastNameInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConLname"
              (keyup)="CmpCntemptyCheck('Lname')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Lname')" (keydown.enter)="resetCmpContact('Lname')"
                (keydown.space)="resetCmpContact('Lname')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConLnameError == true">Please Enter the Last Name.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="comp_modelCellphone">
            <label class="label-control" for="addCmpContactCellphoneInput">Cellphone </label>
            <input id="addCmpContactCellphoneInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConCellphone"
              (keyup)="CmpCntemptyCheck('Cellphone')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Cellphone')" (keydown.enter)="resetCmpContact('Cellphone')"
                (keydown.space)="resetCmpContact('Cellphone')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConCellphoneError == true">Please Enter the Cellphone value.</span>
            <span class="text-cb4b32" *ngIf="CmpConCellphoneError2 == true">Cellphone value is not valid.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="comp_modelPhone">
            <label class="label-control" for="addCmpContactPhoneInput">Phone </label>
            <input id="addCmpContactPhoneInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConPhone"
              (keyup)="CmpCntemptyCheck('Phone')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Phone')" (keydown.enter)="resetCmpContact('Phone')"
                (keydown.space)="resetCmpContact('Phone')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConPhoneError == true">Please Enter the Phone value.</span>
            <span class="text-cb4b32" *ngIf="CmpConPhoneError2 == true">Phone value is not valid.</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12" *ngIf="comp_modelRole">
            <label class="label-control" for="addCmpContactRoleSelect">Role<span class="text-cb4b32">*</span></label>
            <mat-select id="addCmpContactRoleSelect" class="form-control form-control-sm" [(ngModel)]="CmpConRole"
              (selectionChange)="CmpCntRoleSelected($event)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <ng-container *ngIf="PersonRoleSelectOp.length > 0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp" [value]="pRole.row_id">{{ pRole.label }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="CmpConRoleError == true">Please Select the Role.</span>
            <span class="text-cb4b32" *ngIf="cmpConRoleexists == true">The Role already for this user</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveCmpCnt('add')"
            *ngIf="comp_ShowSave">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>

          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveCmpCnt('next')"
            *ngIf="comp_ShowNext">
            Next
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="AddCmpContacts" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditCmpConRole">
          Add Company Contact
          <button type="button" class="close" id="closeCmpContacts2" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <div class="mb-2 pl-3"><span class="fw-bold">Company : </span> {{ companyBasicInfo ?
          companyBasicInfo["legalName"] : "" }}</div>
        <section class="row m-0 bg-white no-shadow">
          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <label class="label-control" for="addCmpContactsFirstNameInput">First Name<span class="text-cb4b32">*</span></label>
            <input id="addCmpContactsFirstNameInput" type="text" autocomplete="off"
              class="form-control form-control-sm" [(ngModel)]="CmpConFname"
              (keyup)="CmpCntemptyCheck('Fname')" (focusout)="focusOutFunction()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Fname')" (keydown.enter)="resetCmpContact('Fname')"
                (keydown.space)="resetCmpContact('Fname')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConFnameError == true">Please Enter the First Name.</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <label class="label-control" for="addCmpContactsLastNameInput">Last Name<span class="text-cb4b32">*</span></label>
            <input id="addCmpContactsLastNameInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConLname"
              (keyup)="CmpCntemptyCheck('Lname')" (focusout)="focusOutFunction()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Lname')" (keydown.enter)="resetCmpContact('Lname')"
                (keydown.space)="resetCmpContact('Lname')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConLnameError == true">Please Enter the Last Name.</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <label class="label-control" for="addCmpContactsRoleSelect">Role<span class="text-cb4b32">*</span></label>
            <mat-select id="addCmpContactsRoleSelect" class="form-control form-control-sm" [(ngModel)]="CmpConRole"
              (selectionChange)="CmpCntRoleSelected($event)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <ng-container *ngIf="PersonRoleSelectOp.length > 0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp" [value]="pRole.row_id">{{ pRole.code }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="CmpConRoleError == true">Please Select the Role.</span>
            <span class="text-cb4b32" *ngIf="cmpConRoleexists == true">The Role already for this user</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <label class="label-control" for="addCmpContactsIpnInput">IPN</label>
            <input id="addCmpContactsIpnInput" type="text" class="form-control form-control-sm"
              [readonly]="isReadOnly" [(ngModel)]="CmpConIpn"
              (keyup)="CmpCntemptyCheck('Ipn')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Ipn')" (keydown.enter)="resetCmpContact('Ipn')"
                (keydown.space)="resetCmpContact('Ipn')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConIpnError == true">Please Enter the IPN.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="addCmpContactsEmailInput">Email<span class="text-cb4b32">*</span></label>
            <input id="addCmpContactsEmailInput" type="email" class="form-control form-control-sm" [(ngModel)]="CmpConEmail"
              (change)="checkEmailChanged()" (keyup)="CmpCntemptyCheck('Email')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Email')" (keydown.enter)="resetCmpContact('Email')"
                (keydown.space)="resetCmpContact('Email')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConEmailError == true">Please Enter the Email.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="addCmpContactsCellphoneInput">Cellphone </label>
            <input id="addCmpContactsCellphoneInput" type="text" class="form-control form-control-sm" [readonly]="isReadOnly"
              [(ngModel)]="CmpConCellphone" (keyup)="CmpCntemptyCheck('Cellphone')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Cellphone')" (keydown.enter)="resetCmpContact('Cellphone')"
                (keydown.space)="resetCmpContact('Cellphone')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConCellphoneError == true">Please Enter the Cellphone value.</span>
            <span class="text-cb4b32" *ngIf="CmpConCellphoneError2 == true">Cellphone value is not valid.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="addCmpContactsPhoneInput">Phone </label>
            <input id="addCmpContactsPhoneInput" type="text" class="form-control form-control-sm"
              [readonly]="isReadOnly" [(ngModel)]="CmpConPhone"
              (keyup)="CmpCntemptyCheck('Phone')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpContact('Phone')" (keydown.enter)="resetCmpContact('Phone')"
                (keydown.space)="resetCmpContact('Phone')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConPhoneError == true">Please Enter the Phone value.</span>
            <span class="text-cb4b32" *ngIf="CmpConPhoneError2 == true">Phone value is not valid.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveCmpCnt('add')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditCmpConRole" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelOpenContactDetails">
          Edit Company Role
          <button type="button" class="close" id="closeEditCmpConRole" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-3 pl-3"><span class="fw-bold">Company : </span> {{ companyBasicInfo ?
          companyBasicInfo["legalName"] : "" }}</div>

        <div class="mb-3 pl-3">
          <span class="fw-bold">Name : </span> {{ CmpConFname ? CmpConFname : "" }} {{ CmpConLname ? CmpConLname : "" }}
        </div>

        <div class="mb-3 pl-3"><span class="fw-bold">Email : </span> {{ CmpConEmail ? CmpConEmail : "" }}</div>

        <div class="mb-3 pl-3" *ngIf="CmpConIpn != ''"><span class="fw-bold">IPN : </span> {{ CmpConIpn ? CmpConIpn : ""
          }}</div>

        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12">
            <label class="label-control fw-bold" for="editCmpConRoleSelect">Role </label>
            <mat-select id="editCmpConRoleSelect" class="form-control form-control-sm" [disabled]="disableContactRoleEdit == true"
              [(ngModel)]="CmpConRole" (selectionChange)="CmpCntRoleSelected($event)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <ng-container *ngIf="PersonRoleSelectOp.length > 0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp" [value]="pRole.row_id">{{ pRole.label }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="CmpConRoleError == true">Please Select the Role.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red bg-cb4b32 mr-160" data-toggle="modal"
            data-target="#ccompanyContactRemoveModalPopup"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile == false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete Role </span>
          </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveCmpCnt('edit')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openContactDetails" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelOpenContactAndRole">
          Contact
          <button type="button" class="close" id="closeContactDetails" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-3 pl-3">
          <span class="fw-bold">Name : </span> {{ CmpConFname ? CmpConFname : "" }} {{ CmpConLname ? CmpConLname : "" }}
          <span class="edit ml-2"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile == false">
            <mat-icon svgIcon="edit" alt="edit" data-toggle="modal" data-target="#editCmpConNameDetails"
              (click)="setEditConDetails('name')" (keydown.enter)="setEditConDetails('name')"
              (keydown.space)="setEditConDetails('name')" tabindex="0"></mat-icon>
          </span>
        </div>

        <div class="mb-3 pl-3"><span class="fw-bold">Email : </span> {{ CmpConEmail ? CmpConEmail : "" }}</div>

        <div class="mb-3 pl-3"><span class="fw-bold">IPN : </span> {{ CmpConIpn ? CmpConIpn : "" }}</div>

        <div class="mb-3 pl-3" *ngIf="cellPhoneEdit == false">
          <span class="fw-bold">Cellphone : </span> {{ CmpConCellphone ? CmpConCellphone : "" }}
          <span class="edit ml-2"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile == false">
            <mat-icon svgIcon="edit" alt="edit" (click)="setEditConDetails('cellPhone')"
              (keydown.enter)="setEditConDetails('cellPhone')" (keydown.space)="setEditConDetails('cellPhone')"
              tabindex="0"></mat-icon>
          </span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="cellPhoneEdit == true">
          <label class="label-control fw-bold" for="openContactDetailsCellphoneInput">Cellphone : </label>
          <input id="openContactDetailsCellphoneInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConCellphone"
            (keyup)="CmpCntemptyCheck('Cellphone')" />
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
              (click)="resetCmpContact('Cellphone')" (keydown.enter)="resetCmpContact('Cellphone')"
              (keydown.space)="resetCmpContact('Cellphone')" tabindex="0">
              ×
            </button></span>
          <span class="text-cb4b32" *ngIf="CmpConCellphoneError == true">Please Enter the Cellphone value.</span>
          <span class="text-cb4b32" *ngIf="CmpConCellphoneError2 == true">Cellphone value is not valid.</span>
          <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-custom btn-link" (click)="toggleCmpConEdit()">Cancel</button>
            <span>|</span>
            <button type="button" class="btn btn-custom btn-link" (click)="editCmpConDetails('phone')">Save</button>
          </section>
        </div>

        <div class="mb-3 pl-3" *ngIf="fixedPhoneEdit == false">
          <span class="fw-bold">Phone : </span> {{ CmpConPhone ? CmpConPhone : "" }}
          <span class="edit ml-2"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile == false">
            <mat-icon svgIcon="edit" alt="edit" (click)="setEditConDetails('fixedPhone')"
              (keydown.enter)="setEditConDetails('fixedPhone')" (keydown.space)="setEditConDetails('fixedPhone')"
              tabindex="0"></mat-icon>
          </span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="fixedPhoneEdit == true">
          <label class="label-control fw-bold" for="openContactDetailsPhoneInput">Phone : </label>
          <input id="openContactDetailsPhoneInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConPhone"
            (keyup)="CmpCntemptyCheck('Phone')" />
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
              (click)="resetCmpContact('Phone')" (keydown.enter)="resetCmpContact('Phone')"
              (keydown.space)="resetCmpContact('Phone')" tabindex="0">
              ×
            </button></span>
          <span class="text-cb4b32" *ngIf="CmpConPhoneError == true">Please Enter the Phone value.</span>
          <span class="text-cb4b32" *ngIf="CmpConPhoneError2 == true">Phone value is not valid.</span>
          <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-custom btn-link" (click)="toggleCmpConEdit()">Cancel</button>
            <span>|</span>
            <button type="button" class="btn btn-custom btn-link" (click)="editCmpConDetails('phone')">Save</button>
          </section>
        </div>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red bg-cb4b32 mr-245" data-toggle="modal"
            data-target="#DeleteContact"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile || showForSupplier == false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete Contact </span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openContactAndRole" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelPCModalPopup">
          Contact
          <button type="button" class="close" id="closeContactAndRole" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-2">
          <button type="button" class="openContactAndRole" (click)="switchVisible('btn1')"
            [ngClass]="{ btnCss: openData == true }">
            DATA
          </button>
          <button type="button" class="openContactAndRole" (click)="switchVisible('btn2')"
            [ngClass]="{ btnCss: openRole == true }">
            ROLE
          </button>
        </div>

        <div *ngIf="openData == true">
          <div class="row mb-2 pl-3">
            <span class="pr-2 fw-bold pl-15">Name : </span>
            <span class="pl-1">{{ CmpConFname ? CmpConFname : "" }} {{ CmpConLname ? CmpConLname : "" }}</span>
            <button class="col edit ml-2 cancel" *ngIf="
                (roleVariableHide || roleIsManager || showBuyerProfile == false || superUserShow == true || showForSupplier == false) &&
                endDateisPresent == false
              " (click)="setEditConDetails('name')" (keydown.enter)="setEditConDetails('name')"
              (keydown.space)="setEditConDetails('name')" tabindex="0">
              <mat-icon svgIcon="edit" alt="edit" data-toggle="modal" data-target="#editCmpConNameDetails"></mat-icon>
            </button>
          </div>
          <div class="mb-3 pl-3"><span class="fw-bold">Email : </span> {{ CmpConEmail ? CmpConEmail : "" }}</div>
          <div class="mb-3 pl-3" *ngIf="endDateisPresent == true"><span class="fw-bold">IPN : </span> {{ CmpConIpn ?
            CmpConIpn : "" }}</div>
          <div class="row mb-2 pl-3" *ngIf="cellPhoneEdit == false">
            <span class="pr-2 fw-bold pl-15">Cellphone : </span>
            <span class="pl-1">{{ CmpConCellphone ? CmpConCellphone : "" }} </span>
            <button class="col edit pl-2 cancel" *ngIf="
                (roleVariableHide || roleIsManager || showBuyerProfile == false || superUserShow == true || showForSupplier == false) &&
                endDateisPresent == false
              ">
              <mat-icon svgIcon="edit" alt="edit" (click)="setEditConDetails('cellPhone')"
                (keydown.enter)="setEditConDetails('cellPhone')" (keydown.space)="setEditConDetails('cellPhone')"
                tabindex="0"></mat-icon>
            </button>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="cellPhoneEdit == true">
            <label class="label-control fw-bold" for="openContactAndRoleCellphoneInput">Cellphone : </label>
            <input id="openContactAndRoleCellphoneInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConCellphone"
              (keyup)="CmpCntemptyCheck('Cellphone')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear"
                (click)="resetCmpContact('Cellphone')" (keydown.enter)="resetCmpContact('Cellphone')"
                (keydown.space)="resetCmpContact('Cellphone')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConCellphoneError == true">Please Enter the Cellphone value.</span>
            <span class="text-cb4b32" *ngIf="CmpConCellphoneError2 == true">Cellphone value is not valid.</span>
            <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-custom btn-link" (click)="toggleCmpConEdit()">Cancel</button>
              <span>|</span>
              <button type="button" class="btn btn-custom btn-link" (click)="editCmpConDetails('phone')">Save</button>
            </section>
          </div>

          <div class="row mb-2 pl-3" *ngIf="fixedPhoneEdit == false">
            <span class="pr-2 fw-bold pl-15">Phone : </span>
            <span class="pl-1"> {{ CmpConPhone ? CmpConPhone : "" }} </span>
            <button class="col edit pl-2 cancel" *ngIf="
                (roleVariableHide || roleIsManager || showBuyerProfile == false || superUserShow == true || showForSupplier == false) &&
                endDateisPresent == false
              ">
              <mat-icon svgIcon="edit" alt="edit" (click)="setEditConDetails('fixedPhone')"
                (keydown.enter)="setEditConDetails('fixedPhone')" (keydown.space)="setEditConDetails('fixedPhone')"
                tabindex="0"></mat-icon>
            </button>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0"
            *ngIf="fixedPhoneEdit == true">
            <label class="label-control fw-bold" for="openContactAndRolePhoneInput">Phone : </label>
            <input id="openContactAndRolePhoneInput" type="text" class="form-control form-control-sm" [(ngModel)]="CmpConPhone"
              (keyup)="CmpCntemptyCheck('Phone')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear"
                (click)="resetCmpContact('Phone')" (keydown.enter)="resetCmpContact('Phone')"
                (keydown.space)="resetCmpContact('Phone')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConPhoneError == true">Please Enter the Phone value.</span>
            <span class="text-cb4b32" *ngIf="CmpConPhoneError2 == true">Phone value is not valid.</span>
            <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-custom btn-link" (click)="toggleCmpConEdit()">Cancel</button>
              <span>|</span>
              <button type="button" class="btn btn-custom btn-link" (click)="editCmpConDetails('phone')">Save</button>
            </section>
          </div>
        </div>

        <div *ngIf="openRole == true">
          <div class="mb-3 pl-3"><span class="fw-bold">Company : </span> {{ companyBasicInfo ?
            companyBasicInfo["legalName"] : "" }}</div>
          <div class="mb-3 pl-3">
            <span class="fw-bold">Name : </span> {{ CmpConFname ? CmpConFname : "" }} {{ CmpConLname ? CmpConLname : ""
            }}
          </div>
          <div class="mb-3 pl-3"><span class="fw-bold">Email : </span> {{ CmpConEmail ? CmpConEmail : "" }}</div>
          <div class="mb-3 pl-3" *ngIf="CmpConIpn != ''"><span class="fw-bold">IPN : </span> {{ CmpConIpn ? CmpConIpn :
            "" }}</div>
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12">
              <label class="label-control fw-bold" for="openContactAndRoleRoleSelect">Role </label>
              <mat-select id="openContactAndRoleRoleSelect" class="form-control form-control-sm" [disabled]="disableContactRoleEdit == true"
                [(ngModel)]="CmpConRole" (selectionChange)="CmpCntRoleSelected($event)">
                <ng-container *ngIf="PersonRoleSelectOp.length > 0"></ng-container>
                <mat-option *ngFor="let pRole of PersonRoleSelectOp" value="{{ pRole.row_id }}">{{ pRole.label
                  }}</mat-option>
              </mat-select>
              <span class="text-cb4b32" *ngIf="CmpConRoleError == true">Please Select the Role.</span>
            </div>
          </section>
        </div>
      </div>

      <div class="modal-footer border-0 m-0" *ngIf="openData == true">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red bg-cb4b32 mr-245" data-toggle="modal"
            data-target="#DeleteContact"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile == false || showForSupplier == false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete Contact </span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>

      <div class="modal-footer border-0 m-0" *ngIf="openRole == true">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red bg-cb4b32 mr-160" data-toggle="modal"
            data-target="#ccompanyContactRemoveModalPopup"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile == false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete Role </span>
          </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveCmpCnt('edit')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="PCModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom pc-quadrant-dialog">
    <div class="modal-content pc-quadrant-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelPayingCompanyState">
          Edit Paying Company
          <button type="button" class="close" id="closePCBtn" #closeBtn data-dismiss="modal" aria-label="Close" (click)="resetAssignedPayingSelections()">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pc-quadrant-body">
        <div class="pc-editor-grid">
          <section class="pc-editor-cell pc-editor-cell-top-left">
            <h6 class="pc-editor-title">Add Paying Companies</h6>
            <label class="label-control" for="pcGrouping">Grouping</label>
            <mat-select id="pcGrouping" class="form-control form-control-sm" [(ngModel)]="selectedPayingGrouping"
              (selectionChange)="onPayingGroupingChange($event.value)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option *ngFor="let groupingVal of uniqueGroupingValues" [value]="groupingVal">{{
                groupingVal }}</mat-option>
            </mat-select>
          </section>

          <section class="pc-editor-cell pc-editor-cell-top-right">
            <h6 class="pc-editor-title">Available Paying Companies ({{ assignedPayingCmp ? assignedPayingCmp.length : 0 }})</h6>
           <!-- <h6 class="pc-editor-title">Available Paying Companies </h6> -->

            <div class="pc-editor-table-wrap" >
              <table class="table table-sm m-0" >
                <thead>
                  <tr>
                    <th class="w-1p pc-checkbox-cell">
                      <input #checkAllAvailable type="checkbox" aria-label="Select all available paying companies"
                        [checked]="isAllAvailablePayingSelected()"
                        [indeterminate]="isAvailablePayingPartiallySelected()"
                        (change)="toggleAllAvailablePaying(checkAllAvailable.checked)" />
                    </th>
                    <th class="w-2p">Code</th>
                    <th>Company name</th>
                  </tr>
                </thead>
                <tbody *ngIf="assignedPayingCmp && assignedPayingCmp.length > 0">
                  <tr *ngFor="let cpyPay of assignedPayingCmp">
                    <td class="pc-checkbox-cell">
                      <input type="checkbox" [checked]="isPayingCompanySelected(cpyPay)"
                        (change)="onPayingCompanyCheckedChange(cpyPay, $event.target.checked)"
                        [disabled]="disable(cpyPay.code)" />
                    </td>
                    <td>{{ cpyPay.code }}</td>
                    <td>{{ cpyPay.legalName }}</td>
                  </tr>
                  <tr *ngIf="!payingCpyData || payingCpyData.length == 0">
                    <td colspan="3" class="text-center">No Results</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section class="pc-editor-cell pc-editor-cell-bottom-left">
            <h6 class="pc-editor-title">Assigned Paying Companies ({{ PayingInfo ? PayingInfo.length : 0 }})</h6>
            <div class="pc-editor-table-wrap">
              <table class="table table-sm m-0">
                <thead>
                  <tr>
                    <th class="w-1p pc-checkbox-cell">
                      <input #checkAllAssigned type="checkbox" aria-label="Select all paying companies"
                        [checked]="isAllAssignedSelected()" [indeterminate]="isAssignedPartiallySelected()"
                        (change)="toggleAllAssigned(checkAllAssigned.checked)" />
                    </th>
                    <th class="w-2p">Code</th>
                    <th>Company name</th>
                    <th class="w-20p">Status</th>
                    <th class="w-20p">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let assigned of PayingInfo">
                    <td class="pc-checkbox-cell">
                      <input type="checkbox"
                        aria-label="Select paying company"
                        [checked]="isAssignedChecked(assigned)"
                        (change)="onAssignedCheckedChange(assigned, $event.target.checked)" />
                    </td>
                    <td>{{ assigned.clientCompanyCode }}</td>
                    <td>{{ assigned.clientCompanyLegalName }}</td>
                    <td>
                      <span class="group-status pr-pill"
                        [ngStyle]="{ background: colorStatus[assigned.approvalModificationStatus ? assigned.approvalModificationStatus.toLowerCase() : 'pending_validation'] }">
                        {{ assigned.approvalModificationStatus == 'VALIDATED' ? 'ACTIVE' : assigned.approvalModificationStatus == 'PENDING_VALIDATION' ? 'PENDING' : assigned.approvalModificationStatus }}
                      </span>
                    </td>
                    <td>
                      <button type="button" class="btn btn-sm pc-switch-pending-btn"
                        *ngIf="canSwitchAssignedToPending(assigned)"
                        (click)="switchAssignedToPending(assigned)">
                        <mat-icon class="pc-switch-pending-icon">autorenew</mat-icon>
                        Switch to Pending
                      </button>
                      <button type="button" class="btn btn-sm pc-switch-active-btn"
                        *ngIf="canSwitchAssignedToActive(assigned)"
                        (click)="switchAssignedToActive(assigned)">
                        <mat-icon class="pc-switch-active-icon">autorenew</mat-icon>
                        Switch to Active
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="!PayingInfo || PayingInfo.length == 0">
                    <td colspan="5" class="text-center">No assigned companies.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section class="pc-editor-cell pc-editor-cell-bottom-right">
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue pc-add-selected-btn"
              (click)="selectPayingCompany()">
              Add selected ({{ selectedPayingCpyVals.length }})
            </button>
            <h6 class="pc-editor-title">New Paying Companies ({{ selectedPayingCompanies.length }})</h6>
            <div class="pc-editor-table-wrap">
              <table class="table table-sm m-0" *ngIf="selectedPayingCompanies.length > 0">
                <thead>
                  <tr>
                    <th class="w-2p">Code</th>
                    <th>Company name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let selectedPaying of selectedPayingCompanies">
                    <td>{{ selectedPaying.code }}</td>
                    <td>{{ selectedPaying.legalName }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center pt-4" *ngIf="selectedPayingCompanies.length == 0">
                No companies added yet.
              </div>
            </div>
            <span class="text-cb4b32" *ngIf="payingCompanyCodeModelvalerror == true">Please select valid company</span>
          </section>
        </div>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" (click)="clearPayingCompanyPopupSelections()">Clear</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updatePayingCompanyToGroup()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="payingCompanyState" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditTIAlias">
          Paying Company State
          <button type="button" class="close" id="closepayingCompanyState1" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-title font-weight-bold ml-4 mt-3 mb-2">
        <h6 class="font-weight-bold">
          Company name: <span class="text-978B7F">{{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
        </h6>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive">
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline" (click)="sort('clientCompanyLegalName')"
                (keydown.enter)="sort('clientCompanyLegalName')" (keydown.space)="sort('clientCompanyLegalName')"
                tabindex="0">
                Paying Company
              </th>
              <th class="sortDecorationunderline" (click)="sort('approvalModificationStatus')"
                (keydown.enter)="sort('approvalModificationStatus')"
                (keydown.space)="sort('approvalModificationStatus')" tabindex="0">
                Grouping status
              </th>
              <th class="sortDecorationunderline" (click)="sort('validityStartDate')"
                (keydown.enter)="sort('validityStartDate')" (keydown.space)="sort('validityStartDate')" tabindex="0">
                Start Date
              </th>
              <th class="sortDecorationunderline" (click)="sort('validityEndDate')"
                (keydown.enter)="sort('validityEndDate')" (keydown.space)="sort('validityEndDate')" tabindex="0">
                End Date
              </th>
            </tr>
          </thead>

          <tbody *ngIf="dataForPayCmpState.length > 0">
            <tr *ngFor="let payCmpState of dataForPayCmpState | orderBy: key : reverse; let i = index"
              class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{ payCmpState.clientCompanyLegalName ? payCmpState.clientCompanyLegalName : "--" }}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">
                <span class="group-status pr-pill"
                  [ngStyle]="{ background: colorStatus[payCmpState.approvalModificationStatus.toLowerCase()] }">{{
                  payCmpState.approvalModificationStatus
                  ? payCmpState.approvalModificationStatus == "VALIDATED"
                  ? payCmpState.approvalModificationStatus.replace("VALIDATED", "ACTIVE")
                  : payCmpState.approvalModificationStatus.replace("PENDING_VALIDATION", "PENDING")
                  : ""
                  }}</span>
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{ payCmpState.validityStartDate ? payCmpState.validityStartDate : "-" }}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{ payCmpState.validityEndDate ? payCmpState.validityEndDate : "-" }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="dataForPayCmpState.length == 0">
            <tr>
              <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
            </tr>
          </tbody>

          <ng-container *ngIf="PayingLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <tfoot [hidden]="this.paying">
            <tr>
              <td colspan="8" class="bg-f5f5f5 p-0">
                <ul *ngIf="payPager.pages && payPager.pages.length" class="pagination">
                  <li [ngClass]="{ disabled: payPager.currentPage === 1 }">
                    <a (click)="payingCompanyTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (payingCompanyTable(1))">First</a>
                  </li>
                  <li [ngClass]="{ disabled: payPager.currentPage === 1 }">
                    <a (click)="payingCompanyTable(payPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (payingCompanyTable(payPager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of payPager.pages" [ngClass]="{ active: payPager.currentPage === page }">
                    <a (click)="payingCompanyTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (payingCompanyTable(page))">{{ page }}</a>
                  </li>
                  <li [ngClass]="{ disabled: payPager.currentPage === payPager.totalPages }">
                    <a (click)="payingCompanyTable(payPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (payingCompanyTable(payPager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{ disabled: payPager.currentPage === payPager.totalPages }">
                    <a (click)="payingCompanyTable(payPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (payingCompanyTable(payPager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closepayingCompanyState2">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="alcorStatusModal" tabindex="-1" aria-modal="true"
  aria-labelledby="alcorStatusModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-900 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="alcorStatusModalLabel">
          ALCOR status
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="bg-white no-shadow m-0">
          <div class="text-center" *ngIf="alcorStatusLoading == true">
            <img src="assets/images/loading.gif" alt="loading..." />
          </div>

          <!-- Loop through each ALCOR code -->
          <div *ngIf="!alcorStatusLoading && alcorStatusData && alcorStatusData.length > 0">
            <div *ngFor="let alcorData of alcorStatusData; let i = index" [class.mt-4]="i > 0">
              <div class="table-responsive">
                <table class="table table-bordered table-sm m-0 border-dee2e6">
                  <thead>
                    <tr>
                      <th class="text-center w-40p align-middle"></th>
                      <th class="text-center w-30 align-middle">ISA</th>
                      <th class="text-center w-30 align-middle">ALCOR</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center fw-bold align-middle">
                        {{ alcorData.alcorCode }}
                      </td>
                      <td class="text-center align-middle">
                        <mat-icon *ngIf="!alcorData.isAlcorArchived" svgIcon="confirm" alt="greentick"
                          class="rounded-circle svg-icon green me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <mat-icon *ngIf="alcorData.isAlcorArchived" svgIcon="less" alt="redClose"
                          class="rounded-circle red me-1 icon-pointer fs-18 wh-18"></mat-icon>
                      </td>
                      <td class="text-center align-middle">
                        <mat-icon *ngIf="alcorData.isAlcorGlobalClean" svgIcon="confirm" alt="greentick"
                          class="rounded-circle svg-icon green me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <mat-icon *ngIf="!alcorData.isAlcorGlobalClean" svgIcon="less" alt="redClose"
                          class="rounded-circle red me-1 icon-pointer fs-18 wh-18"></mat-icon>
                      </td>
                    </tr>

                    <tr *ngFor="let pc of alcorData.payingCompanies">
                      <td class="text-left align-middle">{{ pc.companyCode }} - {{ pc.companyName }}</td>
                      <td class="text-center align-middle">
                        <mat-icon *ngIf="pc.isaStatus === 'VALIDATED'" mat-icon svgIcon="confirm" alt="greentick"
                          class="rounded-circle svg-icon green me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <mat-icon *ngIf="pc.isaStatus === 'ARCHIVED'" svgIcon="less" alt="redClose"
                          class="rounded-circle red me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <mat-icon *ngIf="pc.isaStatus === 'PENDING_VALIDATION'" svgIcon="information"
                          class="info-color me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <span *ngIf="!pc.isaStatus"></span>
                      </td>
                      <td class="text-center align-middle">
                        <mat-icon *ngIf="pc.alcorStatus === 'clean'" svgIcon="confirm" alt="greentick"
                          class="rounded-circle svg-icon green me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <mat-icon *ngIf="pc.alcorStatus === 'blocked'" svgIcon="less" alt="redClose"
                          class="rounded-circle red me-1 icon-pointer fs-18 wh-18"></mat-icon>
                        <span *ngIf="!pc.alcorStatus"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="row m-0 mt-3" *ngIf="alcorData.warningMessage">
                <div class="col-12">
                  <div class="alert alert-warning mb-0" role="alert">
                    {{ alcorData.warningMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!alcorStatusLoading && alcorStatusError" class="alert alert-danger" role="alert">
            {{ alcorStatusError }}
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditTIAlias" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelDeleteContact">
          Edit Tax Identifier
          <button type="button" class="close" id="closeEditTI" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="inputTaxIden"> {{ EditTIObj.TIType }} </label>
            <input type="text" id="inputTaxIden" class="form-control form-control-sm" [(ngModel)]="EditTIModel"
              (keyup)="EditTIEmptyCheck()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetEditTIValue()" (keydown.enter)="resetEditTIValue()" (keydown.space)="resetEditTIValue()"
                tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="EditTIValueError == true">Please enter the value.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 w-100p">
          <button type="button" *ngIf="valTiArc == false" class="btn btn-custom btn-custom-sm bg-ff0000"
            data-target="#CnfArchiveTI" data-toggle="modal">
            <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon><span class="float-right"> Archive</span>
          </button>
          <button type="button" *ngIf="valTiArc == true" class="btn btn-custom btn-custom-sm bg-ec051d"
            data-target="#CnfUnArchiveTI" data-toggle="modal">
            <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon><span class="float-right"> Unarchive
            </span>
          </button>
          <div class="float-right">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="EditSaveTI()"
              [disabled]="disableEditTaxIdens == true">
              <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="DeleteContact" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelCcompanyContactRemoveModalPopup">
          Delete Contact
          <button type="button" class="close" id="closeDelCont" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fs-14 fw-bold mb-7"> Do you want to delete this contact?</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue bg-cb4b32" (click)="delContact()">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="ccompanyContactRemoveModalPopup" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelRemoveRole">
          Remove Role for this Company
          <button type="button" class="close" id="closeCCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fs-15 fw-bold">Do you want to remove this role for this Company?
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm bg-cb4b32" (click)="delRole()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{ removeDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editCmpConNameDetails" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditContactName">
          Edit Contact Name
          <button type="button" class="close" id="closeEditCmpConNameDetails" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-grroup col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-0">
            <label class="label-control fw-bold" for="editCmpConFirstNameInput">First Name<span class="text-cb4b32">*</span></label>
            <input id="editCmpConFirstNameInput" type="text" autocomplete="off"
              class="form-control form-control-sm" [(ngModel)]="editCmpConFname"
              (keyup)="CmpEditCntemptyCheck('Fname')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpEditContact('Fname')" (keydown.enter)="resetCmpEditContact('Fname')"
                (keydown.space)="resetCmpEditContact('Fname')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConFnameError == true">Please Enter the First Name.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-0">
            <label class="label-control fw-bold" for="editCmpConLastNameInput">Last Name<span class="text-cb4b32">*</span></label>
            <input id="editCmpConLastNameInput" type="text" class="form-control form-control-sm" [(ngModel)]="editCmpConLname"
              (keyup)="CmpEditCntemptyCheck('Lname')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetCmpEditContact('Lname')" (keydown.enter)="resetCmpEditContact('Lname')"
                (keydown.space)="resetCmpEditContact('Lname')" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="CmpConLnameError == true">Please Enter the Last Name.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="editCmpConDetails('name')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4 ml-n9px" id="CnfArchive" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelArchiveCompanyIdentifiers">
          Archive Company Identifiers by ADMIN
          <button type="button" class="close" id="closeEditCmpAlias2" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            Do you want to archive this {{ editingAlias }} idenitifiers ?
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            id="closeConfirmArchive">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue">Archive</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="GroupingState" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelGroupingState">
          Grouping State
          <button type="button" class="close" id="closeGroupingState1" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-title font-weight-bold ml-4 mt-3 mb-2">
        <h6 class="font-weight-bold">
          Company name: <span class="text-60504A">{{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
        </h6>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive">
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline" (click)="sort('groupName')" (keydown.enter)="sort('groupName')"
                (keydown.space)="sort('groupName')" tabindex="0">
                Group
              </th>
              <th class="sortDecorationunderline" (click)="sort('groupTypeCode')"
                (keydown.enter)="sort('groupTypeCode')" (keydown.space)="sort('groupTypeCode')" tabindex="0">
                Grouping type
              </th>
              <th class="sortDecorationunderline w-13p" (click)="sort('apoStatus')" (keydown.enter)="sort('apoStatus')"
                (keydown.space)="sort('apoStatus')" tabindex="0">
                Grouping status
              </th>
              <th class="sortDecorationunderline" (click)="sort('validityStartDate')"
                (keydown.enter)="sort('validityStartDate')" (keydown.space)="sort('validityStartDate')" tabindex="0">
                Start Date
              </th>
              <th class="sortDecorationunderline" (click)="sort('validityEndDate')"
                (keydown.enter)="sort('validityEndDate')" (keydown.space)="sort('validityEndDate')" tabindex="0">
                End Date
              </th>
            </tr>
          </thead>

          <tbody *ngIf="dataForGroupingState.length > 0">
            <tr *ngFor="let dam of dataForGroupingState | orderBy: key : reverse; let i = index"
              class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{ dam.groupName ? dam.groupName : "--" }}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{ dam.groupTypeCode ? dam.groupTypeCode :
                "-" }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">
                <span class="group-status pr-pill"
                  [ngStyle]="{ background: colorsGroup[dam.apoStatus.toLowerCase()] }">{{
                  dam.apoStatus
                  }}</span>
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{ dam.validityStartDate ?
                dam.validityStartDate : "-" }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{ dam.validityEndDate ?
                dam.validityEndDate : "-" }}</td>
            </tr>
          </tbody>
          <tbody *ngIf="dataForGroupingState.length == 0">
            <tr>
              <td colspan="7" class="font-weight-bold text-darkblue text-center"
                *ngIf="CompanyIdentiLoading == false && ContactsFlag == true">
                No Results
              </td>
            </tr>
          </tbody>

          <ng-container *ngIf="groupingStateLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <tfoot [hidden]="this.rows">
            <tr>
              <td colspan="8" class="bg-f5f5f5 p-0">
                <ul *ngIf="groupPager.pages && groupPager.pages.length" class="pagination">
                  <li [ngClass]="{ disabled: groupPager.currentPage === 1 }">
                    <a (click)="groupingTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (groupingTable(1))">First</a>
                  </li>
                  <li [ngClass]="{ disabled: groupPager.currentPage === 1 }">
                    <a (click)="groupingTable(groupPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (groupingTable(groupPager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of groupPager.pages" [ngClass]="{ active: groupPager.currentPage === page }">
                    <a (click)="groupingTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (groupingTable(page))">{{ page }}</a>
                  </li>
                  <li [ngClass]="{ disabled: groupPager.currentPage === groupPager.totalPages }">
                    <a (click)="groupingTable(groupPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (groupingTable(groupPager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{ disabled: groupPager.currentPage === groupPager.totalPages }">
                    <a (click)="groupingTable(groupPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (groupingTable(groupPager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeGroupingState2">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="activityEdit" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditSupplierActivity">
          Edit Supplier Activity
          <button type="button" class="close" id="closeEditActivity" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div *ngIf="activityLoaded" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 section-scroll">
        <div class="row m-0 pt-5">
          <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
            <div class="pl-20 h-190">
              <ng-container *ngIf="optActivityA">
                <div class="pl-2" *ngFor="let valueA of optActivityA">
                  <input type="checkbox" value="{{ valueA.value }}" [ngModel]="valueA.checked"
                    (click)="activitySave($event, 'a')" (keydown.enter)="activitySave($event, 'a')"
                    (keydown.space)="activitySave($event, 'a')" tabindex="0" />
                  {{ valueA.value }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
            <div class="pl-20">
              <div class="mb-3">
                <ng-container *ngFor="let valueB of optActivityB">
                  <div *ngIf="valueB.value === 'BOP' || valueB.value === 'NBOP'"
                    [class.text-danger]="bothBopNbopConflict">
                    <input type="radio" name="activityBGroup" value="{{ valueB.value }}" [checked]="bothBopNbopConflict ? false : valueB.checked"
                      [class.border-danger]="bothBopNbopConflict"
                      (change)="activitySave($event, 'bRadio')" tabindex="0" />
                    {{ valueB.value }}
                  </div>
                </ng-container>
                <div *ngIf="bothBopNbopConflict" class="text-danger small mt-1">
                  Both BOP and NBOP are set. Please select only one.
                </div>
              </div>
              <ng-container *ngFor="let valueB of optActivityB">
                <div *ngIf="valueB.value !== 'BOP' && valueB.value !== 'NBOP'">
                  <input type="checkbox" value="{{ valueB.value }}" [checked]="valueB.checked"
                    (click)="activitySave($event, 'b')" (keydown.enter)="activitySave($event, 'b')"
                    (keydown.space)="activitySave($event, 'b')" tabindex="0" />
                  {{ valueB.value }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
            <div class="pl-20">
              <ng-container *ngIf="optActivityC">
                <div *ngFor="let valueC of optActivityC">
                  <input type="checkbox" value="{{ valueC.value }}" [checked]="valueC.checked"
                    (click)="activitySave($event, 'c')" (keydown.enter)="activitySave($event, 'c')"
                    (keydown.space)="activitySave($event, 'c')" tabindex="0" />
                  {{ valueC.value }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 pt-0">
            <div class="pl-20">
              <ng-container *ngIf="optActivityD">
                <div *ngFor="let valueD of optActivityD">
                  <input type="checkbox" value="{{ valueD.value }}" [checked]="valueD.checked"
                    (click)="activitySave($event, 'd')" (keydown.enter)="activitySave($event, 'd')"
                    (keydown.space)="activitySave($event, 'd')" tabindex="0" />
                  {{ valueD.value }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!activityLoaded" class="text-center">
        <img src="assets/images/loading.gif" alt="loading..." />
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="!isSingleBopOrNbopSelected()" (click)="actvity()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfArchiveTI" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelArchiveTaxIdentifier">
          Archive Tax Identifier by ADMIN
          <button type="button" class="close" id="closeEditTi" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Do you want to archive this Tax
            Identifier ?</div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            id="closeConfirmArchiveForTI">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="archiveTaxIdentifier()">Archive</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfUnArchiveTI" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelUnArchiveTaxIdentifier">
          UnArchive Tax Identifier by ADMIN
          <button type="button" class="close" id="closeUnEditTi" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Do you want to unarchive this Tax
            Identifier ?</div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            id="closeConfirmunArchiveForTI">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="unarchiveTaxIdentifier()">Unarchive</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="dispTaxState" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelTaxState">
          Tax State
          <button type="button" class="close" id="closeTaxState1" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-title font-weight-bold ml-4 mt-3 mb-2">
        <h6 class="font-weight-bold">
          Company name: <span class="text-978B7F">{{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
        </h6>
      </div>

      <div class="modal-body row m-0 p-0 table-responsive">
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline" (click)="sort('companyIdentifierKeyName')"
                (keydown.enter)="sort('companyIdentifierKeyName')" (keydown.space)="sort('companyIdentifierKeyName')"
                tabindex="0">
                Tax Type
              </th>
              <th class="sortDecorationunderline" (click)="sort('value')" (keydown.enter)="sort('value')"
                (keydown.space)="sort('value')" tabindex="0">
                Tax Value
              </th>
              <th class="sortDecorationunderline" (click)="sort('startDate')" (keydown.enter)="sort('startDate')"
                (keydown.space)="sort('startDate')" tabindex="0">
                Start Date
              </th>
              <th class="sortDecorationunderline" (click)="sort('endDate')" (keydown.enter)="sort('endDate')"
                (keydown.space)="sort('endDate')" tabindex="0">
                End Date
              </th>
            </tr>
          </thead>
          <tbody *ngIf="dataForTaxState.length > 0">
            <tr *ngFor="let das of dataForTaxState | orderBy: key : reverse; let i = index" class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{
                das.companyIdentifierKeyName }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ das.value }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{ das.startDate ? das.startDate : "-" }}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ das.endDate ?
                das.endDate : "-" }}</td>
            </tr>
          </tbody>
          <tbody *ngIf="dataForTaxState.length == 0">
            <tr>
              <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
            </tr>
          </tbody>

          <ng-container *ngIf="taxStateLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <tfoot [hidden]="this.taxing">
            <tr>
              <td colspan="8" class="bg-f5f5f5 p-0">
                <ul *ngIf="taxPager.pages && taxPager.pages.length" class="pagination">
                  <li [ngClass]="{ disabled: taxPager.currentPage === 1 }">
                    <a (click)="taxTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (taxTable(1))">First</a>
                  </li>
                  <li [ngClass]="{ disabled: taxPager.currentPage === 1 }">
                    <a (click)="taxTable(taxPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (taxTable(taxPager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of taxPager.pages" [ngClass]="{ active: taxPager.currentPage === page }">
                    <a (click)="taxTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (taxTable(page))">{{ page }}</a>
                  </li>
                  <li [ngClass]="{ disabled: taxPager.currentPage === taxPager.totalPages }">
                    <a (click)="taxTable(taxPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (taxTable(taxPager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{ disabled: taxPager.currentPage === taxPager.totalPages }">
                    <a (click)="taxTable(taxPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (taxTable(taxPager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="modal-footer border-0 row pt-0">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeTaxState2">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="dispCmpyAliasState" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelCompanyIdentifiersState">
          Company Identifiers State
          <button type="button" class="close" id="closeCompanyAliasState1" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-title font-weight-bold ml-4 mt-3 mb-2">
        <h6 class="font-weight-bold">
          Company name: <span class="text-978B7F">{{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
        </h6>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive">
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline" (click)="sort('companyIdentifierKeyName')"
                (keydown.enter)="sort('companyIdentifierKeyName')" (keydown.space)="sort('companyIdentifierKeyName')"
                tabindex="0">
                Company Identifiers Type
              </th>
              <th class="sortDecorationunderline" (click)="sort('value')" (keydown.enter)="sort('value')"
                (keydown.space)="sort('value')" tabindex="0">
                Company Identifiers Value
              </th>
              <th class="sortDecorationunderline" (click)="sort('startDate')" (keydown.enter)="sort('startDate')"
                (keydown.space)="sort('startDate')" tabindex="0">
                Start Date
              </th>
              <th class="sortDecorationunderline" (click)="sort('endDate')" (keydown.enter)="sort('endDate')"
                (keydown.space)="sort('endDate')" tabindex="0">
                End Date
              </th>
            </tr>
          </thead>
          <tbody *ngIf="dataForCmpyAlias.length > 0">
            <tr *ngFor="let dasd of dataForCmpyAlias | orderBy: key : reverse; let i = index" class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{
                dasd.companyIdentifierKeyName }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ dasd.value }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{ dasd.startDate ? dasd.startDate : "-" }}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ dasd.endDate ?
                dasd.endDate : "-" }}</td>
            </tr>
          </tbody>
          <tbody *ngIf="dataForCmpyAlias.length == 0">
            <tr>
              <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
            </tr>
          </tbody>

          <ng-container *ngIf="cpyAliasLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <tfoot [hidden]="this.identifying">
            <tr>
              <td colspan="8" class="bg-f5f5f5 p-0">
                <ul *ngIf="idenPager.pages && idenPager.pages.length" class="pagination">
                  <li [ngClass]="{ disabled: idenPager.currentPage === 1 }">
                    <a (click)="companyIdentifierTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyIdentifierTable(1))">First</a>
                  </li>
                  <li [ngClass]="{ disabled: idenPager.currentPage === 1 }">
                    <a (click)="companyIdentifierTable(idenPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyIdentifierTable(idenPager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of idenPager.pages" [ngClass]="{ active: idenPager.currentPage === page }">
                    <a (click)="companyIdentifierTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyIdentifierTable(page))">{{ page }}</a>
                  </li>
                  <li [ngClass]="{ disabled: idenPager.currentPage === idenPager.totalPages }">
                    <a (click)="companyIdentifierTable(idenPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyIdentifierTable(idenPager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{ disabled: idenPager.currentPage === idenPager.totalPages }">
                    <a (click)="companyIdentifierTable(idenPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyIdentifierTable(idenPager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeCompanyAliasState2">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="dispCatAuthState" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelSupplierCategoryState">
          Supplier Category State
          <button type="button" class="close" id="closeCatAuthState1" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-title font-weight-bold ml-4 mt-3 mb-2">
        <h6 class="font-weight-bold">
          Company name: <span class="text-978B7F">{{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }}</span>
        </h6>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive">
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline" (click)="sort('catAuthvalue')" (keydown.enter)="sort('catAuthvalue')"
                (keydown.space)="sort('catAuthvalue')" tabindex="0">
                Category & Authorization
              </th>
              <th class="sortDecorationunderline" (click)="sort('catAuthStartDate')"
                (keydown.enter)="sort('catAuthStartDate')" (keydown.space)="sort('catAuthStartDate')" tabindex="0">
                Start Date
              </th>
              <th class="sortDecorationunderline" (click)="sort('catAuthEndDate')"
                (keydown.enter)="sort('catAuthEndDate')" (keydown.space)="sort('catAuthEndDate')" tabindex="0">
                End Date
              </th>
            </tr>
          </thead>
          <tbody *ngIf="dataForCatAuth.length > 0">
            <tr *ngFor="let dats of dataForCatAuth | orderBy: key : reverse; let i = index" class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ dats.value }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{ dats.startDate ? dats.startDate : "-" }}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ dats.endDate ?
                dats.endDate : "-" }}</td>
            </tr>
          </tbody>
          <tbody *ngIf="dataForCatAuth.length == 0">
            <tr>
              <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
            </tr>
          </tbody>

          <ng-container *ngIf="catAuthLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <tfoot>
            <tr>
              <td colspan="8"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeCatAuthState2">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditCatAuth" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditSupplierCategory">
          Edit Supplier CATEGORY,AUTHORIZATION and TYPE
          <button type="button" class="close" id="closeEditCatAuth" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="label-control fontBold pb-2 sendSupRec"> CATEGORY <span
                  class="astricRed">*</span></div>
              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategory" id="AfterSales"
                [checked]="isAfterSales" />
              <label class="label-control m-0 px-24" for="AfterSales">After Sales only</label><br />

              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategory" id="OUtofProd"
                [checked]="isOutProd" />
              <label class="label-control m-0 px-24" for="OUtofProd">Out of Production only</label><br />

              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategory" id="MassProd"
                [checked]="isMassProd" />
              <label class="label-control m-0 px-24" for="MassProd">Mass Prod / Materials / After Sales</label><br />

              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategory" id="MassoutProd"
                [checked]="isoutMassProd" />
              <label class="label-control m-0 px-24" for="MassoutProd">Mass Prod / Materials / After Sales / Out of
                Production</label><br />

              <span class="text-cb4b32" *ngIf="EditCategoryError == true">Please Select Either One!!!</span>
            </div>

            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="label-control fontBold pb-2 sendSupRec"> AUTHORIZATION</div>
              <input id="editCatAuthPrototypeCheckbox" type="checkbox" class="form-check-input m-0 wh-1_2rem" [(ngModel)]="isPrototype" />
              <label class="label-control m-0 px-24" for="editCatAuthPrototypeCheckbox">Prototypes</label><br />
            </div>

            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="label-control fontBold pb-2 sendSupRec">TYPE</div>
              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategories" id="StandardSupplier"
                [checked]="isStandardSupplier" />
              <label class="label-control m-0 px-24" for="StandardSupplier">Standard Supplier</label><br />

              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategories"
                id="IndustrialPartner" [checked]="isIndustrialPartner" />
              <label class="label-control m-0 px-24" for="IndustrialPartner">Industrial Partner</label><br />

              <input type="radio" class="form-check-input m-0 wh-1_2rem" name="supplierCategories" id="B2BPartner"
                [checked]="isB2BPartner" />
              <label class="label-control m-0 px-24" for="B2BPartner">B2B Partner</label><br />
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 w-100p">
          <div class="float-right">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableCatAuthState == true"
              (click)="EditCatAuthState()">
              <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openShortNameEdit" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditCompanyShortName">
          Edit Company Short Name by ADMIN
          <button type="button" class="close" id="closeEditShortName" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="editCompanyShortNameInput"> Company Short Name </label>
            <input id="editCompanyShortNameInput" type="text" maxlength="10"
              class="form-control form-control-sm" [(ngModel)]="editShortName" (keyup)="
                checkvalidateCompanyNameField(editShortName, 'editShortName', 'EditShortNameValueError', 'EditShortNameValueRegExError')
              " (ngModelChange)="editShortName = $event.toUpperCase()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear"
                (click)="resetEditShortName()" (keydown.enter)="resetEditShortName()">×</button></span>
            <span class="text-cb4b32" *ngIf="EditShortNameValueError == true">Please enter the value.</span>
            <span class="text-cb4b32" *ngIf="EditShortNameValueRegExError == true">A-Z 0-9 space () . , - /</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 w-100p">
          <div class="float-right">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
              [disabled]="disableCpyShortNameUpdate == true" (click)="EditShortName()">
              <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showAliasAddModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelCompanyName">
          Company : {{ companyBasicInfo["legalName"] }}
          <button type="button" class="close" id="closeAliasEditModal" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span>&nbsp;<span [innerHtml]="aliasTextDisp"></span></span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal">{{ showCancelOk }}</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade overflow-y-auto" id="sendReqtoSupp1" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelLaunchWorkflow">
          Launch a workflow
          <button type="button" class="close" id="closesendReqtoSupp1" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold pb-2 sendSupRec" for="sendReqTypeSelect">Type of Request<span class="astricRed">*</span>
            </label>
            <mat-select id="sendReqTypeSelect" class="form-control form-control-sm" [(ngModel)]="selectedSendRequest"
              (selectionChange)="selectedRequestType($event)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option value="New Prospect" [ngClass]="{
                  fixcolor: alcorValueWithAposActive.length > 0 || companyBasicInfo.companyStatusCode?.toLowerCase() === 'prospect'
                }"
                [disabled]="alcorValueWithAposActive.length > 0 || companyBasicInfo.companyStatusCode?.toLowerCase() === 'prospect'">
                0 - New Supplier Prospect
              </mat-option>
              <mat-option value="New Company" [ngClass]="{ fixcolor: alcorValueWithAposActive.length > 0 }"
                [disabled]="alcorValueWithAposActive.length > 0">
                1 - New Supplier Referencing
              </mat-option>
              <mat-option value="Add site" [ngClass]="{ fixcolor: alcorValueWithAposActive.length == 0 }"
                [disabled]="alcorValueWithAposActive.length == 0">
                2 - Add Sites
              </mat-option>
              <mat-option value="site update" [ngClass]="{ fixcolor: alcorValueWithAposActive.length == 0 }"
                [disabled]="alcorValueWithAposActive.length == 0">
                3 - Update Sites
              </mat-option>
              <mat-option value="add paying company" [ngClass]="{ fixcolor: alcorValueWithAposActive.length == 0 }"
                [disabled]="alcorValueWithAposActive.length == 0">
                4 - Add Paying Company
              </mat-option>
              <mat-option value="Update bank details" [ngClass]="{ fixcolor: alcorValueWithAposActive.length == 0 }"
                [disabled]="alcorValueWithAposActive.length == 0">
                5 - Update Supplier
              </mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="sendRequestError == true">Please select Request!!!</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="accHomoRequestSelected == true || addPayCmpRequestSelected == true">
            <label class="label-control fontBold sendSupRec" for="sendReqPayingCompanyInput"> PAYING COMPANY NAME <span
                class="astricRed">*</span></label>
            <input id="sendReqPayingCompanyInput" type="text" class="form-control form-control-sm" (focus)="focusFunction('payingcompany')"
              [(ngModel)]="pComp_Name" (keyup)="checkvalidateField()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button *ngIf="senReqPayCompMOdel != ''" class="ng-clear cancel"
                (click)="resetSendReqToSupp('senReqPayCompMOdel')"
                (keydown.enter)="resetSendReqToSupp('senReqPayCompMOdel')" tabindex="0">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
              <button *ngIf="senReqPayCompMOdel == ''" data-toggle="modal" data-target="#payingCompanySelectPopup"
                class="ng-clear cancel" (click)="selectedPayingGrouping=''; loadPayingDatabase(1, 1, [], 'start', false)" (keydown.enter)="selectedPayingGrouping=''; loadPayingDatabase(1, 1, [], 'start', false)"
                tabindex="0">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
            </span>

            <span class="text-cb4b32" *ngIf="payingCompanyCodeModelvalerror == true">Please select valid company
              name</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="siteUpdatePayingComp == true">
            <table class="table table-sm m-0" *ngIf="siteUpdatePayingComp == true">
              <th></th>
              <tbody>
                <tr *ngFor="let sitepay of payingSiteData">
                  <td>
                    <input type="radio" class="edit wh-1_2rem" name="radioForPayingCpy1"
                      (change)="selectradio($event, sitepay.row_id)" [disabled]="sitepay.disableCheckBox == true" />
                  </td>
                  <td>
                    {{ sitepay.clientCompanyCode ? sitepay.clientCompanyCode : "" }}
                  </td>
                  <td>
                    {{ sitepay.clientCompanyLegalName ? sitepay.clientCompanyLegalName : "" }}
                  </td>
                  <td>
                    <span class="group-status" [ngStyle]="{
                        background: colorStatus[sitepay.approvalModificationStatus.toLowerCase()],
                        'min-width': '82px',
                        float: 'left'
                      }">{{
                      sitepay.approvalModificationStatus
                      ? sitepay.approvalModificationStatus == "VALIDATED"
                      ? sitepay.approvalModificationStatus.replace("VALIDATED", "ACTIVE")
                      : sitepay.approvalModificationStatus.replace("PENDING_VALIDATION", "PENDING")
                      : ""
                      }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="payingSiteData.length == 0" class="text-center">
              <p class="font-weight-bold">No Results Found</p>
            </div>
            <span class="text-cb4b32" *ngIf="senReqUpdatePayingModelError == true">Please Select atleast One Paying
              Company</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="accHomoRequestSelected == true || addPayCmpRequestSelected == true || siteUpdatePayingComp == true">
            <div class="label-control fontBold pb-2 sendSupRec"> CATEGORY </div>
            <div class="pl-2" *ngFor="let opt of categoryOption; let i = index">
              <input [id]="'sendReqCategory-' + i" type="checkbox" class="form-check-input m-0 wh-1_2rem"
                value="{{ opt }}" [ngModel]="opt.checked"
                (click)="onChange($event)" (keydown.enter)="onChange($event)" (keydown.space)="onChange($event)"
                tabindex="0" />
              <label class="label-control m-0 px-24" [attr.for]="'sendReqCategory-' + i">{{ opt }}</label><br />
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="accHomoRequestSelected == true || addPayCmpRequestSelected == true || siteUpdatePayingComp == true">
            <div class="label-control fontBold pb-2 sendSupRec"> AUTHORIZATION</div>
            <input id="sendReqAuthorizationPrototype" type="checkbox" class="form-check-input m-0 wh-1_2rem" (click)="onChange($event)"
              (keydown.enter)="onChange($event)" (keydown.space)="onChange($event)" tabindex="0"
              [checked]="isPrototypeEnabled" [disabled]="isPrototypeLocked" value="Prototype" />
            <label class="label-control m-0 px-24" for="sendReqAuthorizationPrototype">Prototype</label><br />
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="siteUpdRequestSelected == true">
            <div class="label-control fontBold pb-2 sendSupRec"> SITES <span
                class="astricRed">*</span></div>
            <div class="sitesHeightMaxFour" *ngIf="SitesInfo.length > 0"
              [ngClass]="{ sitesHeightMaxTwo: SitesInfo.length < 4 }">
              <table class="table table-sm tbl-custom m-0">
                <th></th>
                <tbody>
                  <tr *ngFor="let siteinf of updateSiteData" class="forColor">
                    <td>
                      <div class="container" *ngIf="siteinf.disableCheckBox == true">
                        <input [id]="'sendReqSiteDisabled-' + siteinf.rowId" type="checkbox"
                          checked="checked" (click)="returnNone()" (keydown.enter)="returnNone()"
                          (keydown.space)="returnNone()" tabindex="0" />
                        <span class="checkmark br-20p"></span>
                      </div>
                      <input type="checkbox" *ngIf="siteinf.disableCheckBox == false"
                        [id]="'sendReqSite-' + siteinf.rowId"
                        (change)="selectSiteSendReqSup($event, siteinf.rowId)" />
                    </td>
                    <td>
                      <label [attr.for]="'sendReqSite-' + siteinf.rowId">
                        {{ siteinf.identifier ? siteinf.identifier : "" }}
                      </label>
                    </td>
                    <td>
                      {{ siteinf.cityName ? siteinf.cityName : "" }}
                    </td>
                    <td>
                      <span class="fs-smaller">
                        {{
                        acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]]
                        ? acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]].wayNumber
                        ? acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]].wayNumber + ","
                        : ""
                        : ""
                        }}
                        {{
                        acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]]
                        ? acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]].streetName
                        ? acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]].streetName +
                        (acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]].additionalInformation ? "," : "")
                        : ""
                        : ""
                        }}
                        <div>
                          {{
                          acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]]
                          ? acpAddressDetOnRows[accessPointIdOnAddress[siteinf["rowId"]]].additionalInformation
                          : ""
                          }}
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="SitesInfo.length == 0">
              <span class="font-weight-bold label-darkblue text-center">No Sites</span>
            </div>
            <span class="text-cb4b32" *ngIf="senReqSiteModelError == true">Please Select atleast One Site</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="siteAddRequestSelected == true">
            <div class="addSitesHeightMaxFour font-weight-bold ml-2 position-relative"
              *ngIf="addSiteBvdIdData.length > 0 && showAddSiteLoading == false"
              [ngClass]="{ addSitesHeightMaxOne: addSiteBvdIdData.length < 2 }">
              <div *ngFor="let row of addSiteBvdIdData" class="form-group">
                <div class="container" *ngIf="row.disableCheck">
                    <input [id]="'sendReqAddSiteDisabled-' + row.BRANCH_BVD_ID_NUMBER" type="checkbox"
                    checked="checked" (click)="returnNone()" (keydown.enter)="returnNone()"
                    (keydown.space)="returnNone()" tabindex="0" />
                  <span class="checkmark br-20p"></span>
                </div>
                <input type="checkbox" class="mt-1 edit position-absolute"
                  [id]="'sendReqAddSite-' + row.BRANCH_BVD_ID_NUMBER"
                  (change)="selectCheckBox($event, row.BRANCH_BVD_ID_NUMBER)" *ngIf="!row.disableCheck"
                  [disabled]="disableCheckbox == true" />
                <label class="p-0 m-0 ml-3" [attr.for]="'sendReqAddSite-' + row.BRANCH_BVD_ID_NUMBER">
                  {{ row.BRANCH_NAME ? row.BRANCH_NAME : "" }}
                </label>
                <div class="ml-3">{{ row.BRANCH_BVD_ID_NUMBER ? row.BRANCH_BVD_ID_NUMBER : "" }}</div>
                <div class="ml-3">{{ row.BRANCH_ADDRESS_LINE1 ? row.BRANCH_ADDRESS_LINE1 : "" }}</div>
                <div class="ml-3">{{ row.BRANCH_POSTCODE ? row.BRANCH_POSTCODE : "" }}</div>
                <div class="ml-3">{{ row.BRANCH_CITY ? row.BRANCH_CITY : "" }}</div>
                <div class="ml-3">{{ row.BRANCH_COUNTRY_ISO_CODE ? row.BRANCH_COUNTRY_ISO_CODE : "" }}</div>
              </div>
            </div>
            <div *ngIf="addSiteBvdIdData.length == 0 && showAddSiteLoading == false" class="text-center">
              <p class="font-weight-bold">No Results Found</p>
            </div>
            <div class="text-center" *ngIf="showAddSiteLoading == true">
              <img src="assets/images/loading.gif" alt="loading..." />
            </div>
            <span class="text-cb4b32" *ngIf="senReqAddSiteModelError == true">Please Select atleast One Site</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="
              accHomoRequestSelected == true ||
              siteUpdRequestSelected == true ||
              addPayCmpRequestSelected == true ||
              siteAddRequestSelected == true ||
              siteUpdatePayingComp == true
            ">
            <div class="d-flex align-items-center justify-content-between">
              <label class="label-control fontBold sendSupRec" for="sendReqKamSalesSelect"> KAM / SALES CONTACT <span
                  class="astricRed">*</span></label>
              <button class="btn btn-custom btn-green btn-custom-md btn-blue position-relative bottom-5"
                *ngIf="selectedSendRequest == 'New Company'" data-toggle="modal" type="button"
                data-target="#AddnewCmpContacts" (click)="AddEditCmpContact('fromWorkflow', 'load')">
                <mat-icon svgIcon="add" class="img-btn" alt=""></mat-icon> <span class="float-right">Add Company
                  Contact</span>
              </button>
            </div>

            <mat-select id="sendReqKamSalesSelect" class="form-control form-control-sm" [(ngModel)]="senReqKamSaleContMOdel"
              (selectionChange)="SuppRoleChange($event)" [panelClass]="['dropdown-panel', 'send-req-contact-panel']" [disabled]>
              <mat-select-trigger>
                <span class="send-req-contact-trigger" *ngIf="senReqKamSaleContMOdel">
                  <ng-container *ngFor="let pRole of PersonDetailsCompSent2Req">
                    <ng-container *ngIf="pRole.personRowId == senReqKamSaleContMOdel">
                      <span class="send-req-contact-option__login">
                        {{
                        ipnOnPersonIds[pRole.personRowId]
                        ? ipnOnPersonIds[pRole.personRowId].loginId
                        ? ipnOnPersonIds[pRole.personRowId].loginId
                        : ""
                        : ""
                        }}
                      </span>
                      <span class="send-req-contact-option__name">{{ pRole.personFirstName || "" }} {{ pRole.personLastName || "" }}</span>
                      <span class="send-req-contact-option__role">{{ pRole.roleTypeLabel || "" }}</span>
                    </ng-container>
                  </ng-container>
                </span>
              </mat-select-trigger>
              <ng-container *ngIf="PersonDetailsCompSent2Req.length > 0">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let pRole of PersonDetailsCompSent2Req" value="{{ pRole.personRowId }}">
                  <span class="mat-option-text send-req-contact-option">
                    <span class="send-req-contact-option__login">
                      {{
                      ipnOnPersonIds[pRole.personRowId]
                      ? ipnOnPersonIds[pRole.personRowId].loginId
                      ? ipnOnPersonIds[pRole.personRowId].loginId
                      : ""
                      : ""
                      }}
                    </span>
                    <span class="send-req-contact-option__name">{{ pRole.personFirstName || "" }} {{ pRole.personLastName || "" }}</span>
                    <span class="send-req-contact-option__role">{{ pRole.roleTypeLabel || "" }}</span>
                  </span>
                </mat-option>
              </ng-container>
              <ng-container *ngIf="PersonDetailsCompSent2Req.length == 0">
                <mat-option value="noresults" disabled>No Results</mat-option>
              </ng-container>
            </mat-select>
            <span class="text-cb4b32" *ngIf="senReqKamSaleContMOdelError == true">Please Select the KAM/SALES
              Contacts</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="
              accHomoRequestSelected == true ||
              siteUpdRequestSelected == true ||
              addPayCmpRequestSelected == true ||
              siteAddRequestSelected == true ||
              siteUpdatePayingComp == true ||
              prospectSelected == true
            ">
            <label class="label-control fontBold sendSupRec" for="sendReqManagerInput"> MANAGER <span class="astricRed">*</span></label>
            <input id="sendReqManagerInput" type="text" class="form-control form-control-sm" (focus)="focusFunction('sam')"
              [(ngModel)]="senReqSamMOdel" (keyup)="checkvalidateField()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button *ngIf="senReqSamMOdel != ''" class="ng-clear cancel"
                (click)="resetSendReqToSupp('senReqSamMOdel')" (keydown.enter)="resetSendReqToSupp('senReqSamMOdel')"
                (keydown.space)="resetSendReqToSupp('senReqSamMOdel')" tabindex="0">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
              <button *ngIf="senReqSamMOdel == ''" data-toggle="modal" data-target="#ArcaPopup" class="ng-clear cancel"
                (click)="lookupArca('sam')" (keydown.enter)="lookupArca('sam')" (keydown.space)="lookupArca('sam')"
                tabindex="0">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
            </span>
            <span class="text-cb4b32" *ngIf="senReqSamMOdelError == true">Please enter the MANAGER</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="
              accHomoRequestSelected == true ||
              siteUpdRequestSelected == true ||
              addPayCmpRequestSelected == true ||
              siteAddRequestSelected == true ||
              siteUpdatePayingComp == true ||
              prospectSelected == true
            ">
            <label class="label-control fontBold sendSupRec" for="sendReqNotesTextArea"> NOTES </label>
            <textarea id="sendReqNotesTextArea" class="form-control form-control-sm" [(ngModel)]="senReqNotesMOdel"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
                (click)="resetSendReqToSupp('senReqNotesMOdel')"
                (keydown.enter)="resetSendReqToSupp('senReqNotesMOdel')"
                (keydown.space)="resetSendReqToSupp('senReqNotesMOdel')" tabindex="0">
                ×
              </button></span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <span>
            <button *ngIf="selectedSendRequest != 'New Prospect'"
              class="btn btn-custom btn-blue float-right mr-2 mb-4 br-r-025" [disabled]="disableSendReqBtn == true"
              (click)="sendRequestSupplier()">
              Send to Supplier
            </button>
            <button *ngIf="selectedSendRequest == 'New Prospect'"
              class="btn btn-custom btn-blue float-right mr-2 mb-4 br-r-025" [disabled]="disableSendReqBtn == true"
              (click)="sendRequestSupplier()">
              Send to MANAGER
            </button>
            <button class="btn btn-custom btn-blue float-right pr-0 br-lr-025 h-37"
              [disabled]="disableSendReqBtn == true" (click)="sendRequestSupplier()">
              <mat-icon svgIcon="mail" class="img-btn img-btn-lg" alt=""></mat-icon>
            </button>
          </span>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditBvdId" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditBvdId">
          Edit BVD ID
          <button type="button" class="close" id="closeBvdId" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="EditBvdIdInput"> BVD ID </label>
            <input type="text" id="EditBvdIdInput" class="form-control form-control-sm" [(ngModel)]="EditBvdIdModel" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button class="ng-clear cancel"
                (click)="resetBvdId()" (keydown.enter)="resetBvdId()" (keydown.space)="resetBvdId()" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="EditBvdIdValueError == true">Please enter the value.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow col m-0">
          <button type="button" class="btn btn-custom btn-custom-sm bg-ec051d" data-toggle="modal"
            data-target="#CnfArchiveBvdId">
            <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon><span class="float-right"> Archive </span>
          </button>
          <button type="button" class="btn btn-custom btn-link ml-210" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue position-fixed mt-3"
            (click)="EditSaveBvdIdVal('edit')">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<button class="btn" [hidden]="true" id="bvdIdAlreadyExists" data-target="#bvdIdAlreadyExistsmodal"
  data-toggle="modal">Hidden</button>

<div class="modal fade mt-4" id="bvdIdAlreadyExistsmodal" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddBvdId">
          Add BVD ID
          <button type="button" class="close" id="closeCnfArchiveBvdIdLater" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            {{ bvdIdTextHolder }}
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal">Cancel</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="CompanyPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelPayingCompany">
          <span class="label-darkblue">Paying Company</span>
          <button type="button" class="close" id="closeCPBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 fw-900">
        <div class="label-control">Name </div>

        <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
          <button class="ng-clear" (click)="resetCompanySearch('name')" (keydown.enter)="resetCompanySearch('name')"
            (keydown.space)="resetCompanySearch('name')" tabindex="0">
            ×
          </button></span>
      </span>
      <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 fw-900">
        <div class="label-control">Code </div>

        <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
            (click)="resetCompanySearch('code')" (keydown.enter)="resetCompanySearch('code')"
            (keydown.space)="resetCompanySearch('code')" tabindex="0">
            ×
          </button></span>
      </span>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="companySearch()">OK</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="payingCompanySelectPopup" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-720 ml-n22p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelPayingCompanySelect">
          <span class="label-darkblue">Paying Company</span>
          <button type="button" class="close" id="closepayingCompanySelectPopup" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body row m-0 p-0 table-responsive">
        <table class="table m-0">
          <thead class="bg-f5f5f5 border-bottom-yellow">
            <tr class="col p-0">
              <th class="thCustom2 w-1p"></th>
              <th class="sortDecorationunderline w-2p" (click)="sort('code')" (keydown.enter)="sort('code')"
                (keydown.space)="sort('code')" tabindex="0">
                Code
              </th>
              <th class="sortDecorationunderline" (click)="sort('legalName')" (keydown.enter)="sort('legalName')"
                (keydown.space)="sort('legalName')" tabindex="0">
                Name
              </th>
            </tr>
          </thead>

          <tbody *ngIf="payingCpyData.length > 0 && payingCpyLoading == false">
            <tr *ngFor="let cpyPay of payingCpyData | orderBy: key : reverse; let i = index" class="forColor p-0">
              <td class="tdCustom font-weight-bold w-1p">
                <input type="radio" class="edit" value="{{ cpyPay.code }}&&{{ cpyPay.legalName }}"
                  [disabled]="disable(cpyPay.code)" name="radioForPayingCpy" id="radioForPayingCpy" [(ngModel)]="selectedPayingCpyVal"
                  (click)="setPayingCpy(cpyPay.code, cpyPay.legalName)" />
              </td>
              <td class="tdCustom font-weight-bold edit w-2p" (click)="setPayingCpy(cpyPay.code, cpyPay.legalName)"
                (keydown.enter)="setPayingCpy(cpyPay.code, cpyPay.legalName)"
                (keydown.space)="setPayingCpy(cpyPay.code, cpyPay.legalName)" tabindex="0">
                {{ cpyPay.code ? cpyPay.code : "-" }}
              </td>
              <td class="tdCustom font-weight-bold edit" (click)="setPayingCpy(cpyPay.code, cpyPay.legalName)"
                (keydown.enter)="setPayingCpy(cpyPay.code, cpyPay.legalName)"
                (keydown.space)="setPayingCpy(cpyPay.code, cpyPay.legalName)" tabindex="0">
                {{ cpyPay.legalName ? cpyPay.legalName : "-" }}
              </td>
            </tr>
          </tbody>

          <tbody *ngIf="payingCpyData.length == 0 || payingCpyLoading == true">
            <tr>
              <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
            </tr>
          </tbody>

          <ng-container *ngIf="payingCpyLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <tfoot *ngIf="payingCpyLoading == false && payingCpyData.length > 0" [hidden]="this.loading">
            <tr>
              <td colspan="8" class="p-0 pr-2">
                <ul *ngIf="cmpPager.pages && cmpPager.pages.length" class="pagination">
                  <li [ngClass]="{ disabled: cmpPager.currentPage === 1 }">
                    <a (click)="companyTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyTable(1))">First</a>
                  </li>
                  <li [ngClass]="{ disabled: cmpPager.currentPage === 1 }">
                    <a (click)="companyTable(cmpPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyTable(cmpPager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of cmpPager.pages" [ngClass]="{ active: cmpPager.currentPage === page }">
                    <a (click)="companyTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyTable(page))">{{ page }}</a>
                  </li>
                  <li [ngClass]="{ disabled: cmpPager.currentPage === cmpPager.totalPages }">
                    <a (click)="companyTable(cmpPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyTable(cmpPager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{ disabled: cmpPager.currentPage === cmpPager.totalPages }">
                    <a (click)="companyTable(cmpPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (companyTable(cmpPager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="wfSelectPayingCompany()">
            OK
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal-above" id="ArcaPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelSearchUser">
          Search User
          <button type="button" class="close" id="closeGCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 fw-900">
        <label class="label-control" for="arcaIpnInput">IPN </label>
        <input id="arcaIpnInput" type="text" class="form-control form-control-sm" [(ngModel)]="ArcIpn"
          (ngModelChange)="ArcNameModelChange()" />
        <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
            (click)="resetArcaSearch('ArcIpn')" (keydown.enter)="resetArcaSearch('ArcIpn')"
            (keydown.space)="resetArcaSearch('ArcIpn')" tabindex="0">
            ×
          </button></span>
      </span>
      <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 fw-900">
        <div class="breakline"><span class="breakline2">OR</span> </div>
      </span>
      <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 fw-900">
        <label class="label-control" for="arcaFirstNameInput">First Name </label>
        <input id="arcaFirstNameInput" type="text" class="form-control form-control-sm" [(ngModel)]="ArcFirstName"
          (ngModelChange)="ArcNameModelChange()" />
        <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
            (click)="resetArcaSearch('ArcFirstName')" (keydown.enter)="resetArcaSearch('ArcFirstName')"
            (keydown.space)="resetArcaSearch('ArcFirstName')" tabindex="0">
            ×
          </button></span>
      </span>
      <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 fw-900">
        <label class="label-control" for="arcaLastNameInput">Last Name </label>
        <input id="arcaLastNameInput" type="text" class="form-control form-control-sm" [(ngModel)]="ArcLastName"
          (ngModelChange)="ArcNameModelChange()" />
        <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
            (click)="resetArcaSearch('ArcLastName')" (keydown.enter)="resetArcaSearch('ArcLastName')"
            (keydown.space)="resetArcaSearch('ArcLastName')" tabindex="0">
            ×
          </button></span>
      </span>
      <div class="text-center" *ngIf="arcaSrchWait == true">
        <img src="assets/images/loading.gif" alt="loading..." />
      </div>
      <div class="text-center" *ngIf="arcaSrchnoresults == true">
        <span> No search results</span>
      </div>
      <span class="table-responsive mt-3" *ngIf="resetArca == true">
        <table class="table table-sm m-0">
          <thead>
            <tr>
              <th class="ccwidth1" (click)="sort('code')" (keydown.enter)="sort('code')" (keydown.space)="sort('code')"
                tabindex="0">
                IPN
              </th>
              <th class="ccwidth1" (click)="sort('status')" (keydown.enter)="sort('status')"
                (keydown.space)="sort('status')" tabindex="0">
                First Name
              </th>
              <th class="ccwidth1" (click)="sort('label')" (keydown.enter)="sort('label')"
                (keydown.space)="sort('label')" tabindex="0">
                Last Name
              </th>
              <th class="ccwidth1" *ngIf="showUidDisable == false">MANAGER</th>
            </tr>
          </thead>
          <tbody #customLoadingTemplate>
            <tr *ngFor="let cmdData of data | orderBy: key : reverse; let i = index">
              <td class="font-weight-bold">
                <span
                  *ngIf="(isaRoleFor_Uid[cmdData.Uid] == 'manager' || showUidDisable == true) && cmdData.Uid !== Uid">
                  <a class="label-darkblue" href="javascript:void(0)"
                    (click)="PasteSam(cmdData.Uid, cmdData.FirstName, cmdData.LastName, cmdData.Mail)">
                    {{ cmdData ? cmdData.Uid : "" }}
                  </a>
                </span>
                <span *ngIf="cmdData.Uid === Uid" class="text-888 d-flex align-items-center">
                  {{ cmdData ? cmdData.Uid : "" }}
                </span>
                <span
                  *ngIf="isaRoleFor_Uid[cmdData.Uid] != 'manager' && showUidDisable == false && cmdData.Uid !== Uid">
                  {{ cmdData ? cmdData.Uid : "" }}
                </span>
              </td>
              <td class="font-weight-bold">{{ cmdData ? cmdData.FirstName : "" }}</td>
              <td class="font-weight-bold">{{ cmdData ? cmdData.LastName : "" }}</td>
              <td *ngIf="showUidDisable == false">
                <span *ngIf="isaRoleFor_Uid[cmdData.Uid] == 'manager' && cmdData.Uid !== Uid">
                  <img src="assets/images/greentick.png" alt="Available as  MANAGER" />
                </span>
                <span *ngIf="isaRoleFor_Uid[cmdData.Uid] != 'manager' && cmdData.Uid !== Uid">
                  <img class="closeImgStyle" src="assets/images/close.png" alt="Not available as  MANAGER" />
                </span>
                <span *ngIf="cmdData.Uid === Uid">
                  <img class="closeImgStyle" src="assets/images/close.png" alt="Cannot select yourself as  MANAGER" />
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4"></td>
            </tr>
          </tfoot>
        </table>
      </span>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="ArcSearch()">
            <mat-icon svgIcon="search" class="img-btn mr-2"></mat-icon> <span class="float-right"> Search </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="lookForSites" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-1000 ml-n47p">
      <div class="modal-header border-0">
        <h5 class="modal-title font-weight-bold text-center" id="exampleModalLabelLookForSites">
          Look for Sites
          <button type="button" class="close" id="closeRealEstateAlcor" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>
      </div>

      <section class="px-1">
        <div class="modal-body p-0 m-0 section-scroll text-center maxh-510 overflow-x-hidden">
          <div *ngIf="!lookForSiteLoading && alcorValueCpy.length > 0 && !noLookForSiteData">
            <ng-container *ngFor="let alcorVal of alcorValueCpy">
              <div *ngIf="realEstateAlcorData[alcorVal]">
                <div class="modal-title font-weight-bold mt-2 mb-1">
                  <div class="row">
                    <div class="col col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 text-left pt-2">
                      <span class="h4 font-weight-bold">
                        {{ alcorVal }}
                      </span>
                    </div>
                    <div class="col col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                      <span *ngIf="realEstateAlcorData[alcorVal].inputCount == 1">
                        <button class="btn btn-custom btn-blue" *ngIf="alcorAssignmentAval[alcorVal] == 'noexist'"
                          [disabled]="disableBtnInitiateLinkLook" data-dismiss="modal" data-toggle="modal"
                          data-target="#progressBarAlcorLook" (click)="checkForCpyLinks(alcorVal)">
                          Initiate Company Link
                        </button>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="border-bottom-custom col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"></div>

                <table class="table table-responsive m-0">
                  <thead class="bg-f5f5f5">
                    <tr class="col p-0">
                      <th class="thCustom3 h6">Site ID</th>
                      <th class="thCustom3 h6 w-30">Site Name</th>
                      <th class="thCustom3 h6">Company Name</th>
                      <th class="thCustom3 h6">ALCOR Name</th>
                      <th class="thCustom3 h6">Effective Date</th>
                      <th class="thCustom3 h6">End Date</th>
                      <th class=""></th>
                      <th class="w-97px"></th>
                    </tr>
                  </thead>

                  <tbody *ngIf="gotAlcorRealLookData">
                    <ng-container *ngFor="let subVal of lookForSitesLinkIdArr">
                      <tr *ngFor="let dasd of realEstateNewData[alcorVal][subVal]" class="col forColor p-0">
                        <td class="tdCustom text-632717">{{ dasd.realEstateAssetIdentifier ?
                          dasd.realEstateAssetIdentifier : "-" }}</td>
                        <td class="tdCustom text-632717">{{ dasd.realEstateAssetName ? dasd.realEstateAssetName : "-" }}
                        </td>
                        <td class="tdCustom">
                          <span *ngIf="siteAssignmentData">
                            {{
                            siteAssignmentData[dasd.realEstateAssetId]
                            ? siteAssignmentData[dasd.realEstateAssetId].businessEntityCompanyLegalName
                            : "-"
                            }}
                          </span>
                        </td>
                        <td class="tdCustom">{{ dasd.businessIdentifierName ? dasd.businessIdentifierName : "-" }}</td>
                        <td class="tdCustom">{{ dasd.effectiveDate ? dasd.effectiveDate : "-" }}</td>
                        <td class="tdCustom">{{ dasd.endDate ? dasd.endDate : "-" }}</td>
                        <td class="">
                          <span *ngIf="dasd.showInput">
                            <label for="checkedInput{{ alcorVal }}">
                              <input class="edit" [checked]="realEstateAlcorData[alcorVal].inputCount == 1"
                                id="checkedInput{{ alcorVal }}" type="radio" name="{{ alcorVal }}"
                                value="{{ alcorVal }}&&{{ dasd.businessIdentifierName }}&&{{ dasd.effectiveDate }}&&{{ dasd.endDate }}"
                                (click)="
                                  showUpdateBtnLookForSites(
                                    alcorVal,
                                    alcorVal + '&&' + dasd.businessIdentifierName + '&&' + dasd.effectiveDate + '&&' + dasd.endDate,
                                    dasd,
                                    subVal
                                  )
                                " (keydown.enter)="
                                  showUpdateBtnLookForSites(
                                    alcorVal,
                                    alcorVal + '&&' + dasd.businessIdentifierName + '&&' + dasd.effectiveDate + '&&' + dasd.endDate,
                                    dasd,
                                    subVal
                                  )
                                " (keydown.space)="
                                  showUpdateBtnLookForSites(
                                    alcorVal,
                                    alcorVal + '&&' + dasd.businessIdentifierName + '&&' + dasd.effectiveDate + '&&' + dasd.endDate,
                                    dasd,
                                    subVal
                                  )
                                " tabindex="0" />
                            </label>
                          </span>
                        </td>
                        <td class="w-97px">
                          <span *ngIf="dasd.showInput && dasd.showBtnUpdate">
                            <button
                              id="{{ alcorVal }}&&{{ dasd.businessIdentifierName }}&&{{ dasd.effectiveDate }}&&{{ dasd.endDate }}"
                              class="btn btn-custom btn-blue" (click)="
                                updateAlcorAsRaft(
                                  alcorVal,
                                  dasd,
                                  alcorVal + '&&' + dasd.businessIdentifierName + '&&' + dasd.effectiveDate + '&&' + dasd.endDate,
                                  subVal
                                )
                              ">
                              Update
                            </button>
                          </span>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
          <div *ngIf="alcorValueCpy.length == 0 || noLookForSiteData" class="w-100p">
            <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <h6 class="font-weight-bold text-center pt-1">No Results Found</h6>
            </div>
          </div>
        </div>

        <div>
          <ng-container *ngIf="lookForSiteLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>
        </div>
      </section>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeLookForSites">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="progressBarAlcorLook" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelInitiateCompanyLink">
          Initiate Company link
          <button type="button" class="close" id="closeProgressBarLook" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">
              &nbsp;
              <span *ngIf="progressForInitiateLink != 100">
                <img src="assets/images/loading.gif" alt="loading..." />
              </span>
            </div>

            <div>
              <mat-progress-bar mode="determinate" class="bg-grey" [value]="progressForInitiateLink"></mat-progress-bar>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" [disabled]="progressForInitiateLink != 100"
            (click)="reloadCurrentPage()" data-dismiss="modal">
            Reload
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningNoArchiveAlcor" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelWarningNoArchiveAlcor">
          Warning
          <button type="button" class="close" id="closeNoArchiveAlcor" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">Prior to archive an ALCOR code, please archive the associated
              RAFT codes</p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningForArchiveCpy" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelWarningForArchiveCpy">
          Warning
          <button type="button" class="close" id="closeArchiveCpy1" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              {{ warningForArchiveCpyText }}
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="reloadPage ? reloadCurrentPage() : returnNone()">
            OK
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openPreviewDocModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelDocumentPreview">
          Document Preview
          <button type="button" class="close" id="closeArchiveCpy2" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="showPreview == true"></div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Download</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-3" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningForMoreHQ" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelWarningForMoreHQ">
          Warning
          <button type="button" class="close" id="closeArchiveCpy3" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              {{ warningForHQ }}
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openAddDocumentModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddDocument">
          Add Document
          <button type="button" class="close" id="closeAddDocModal" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="addDocTypeSelect"> Document Type <span class="element_astrick">*</span> </label>
            <mat-select id="addDocTypeSelect" class="form-control form-control-sm"
              [(ngModel)]="documentTypeModel" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option selected="selected" value="Blank Invoice">Blank Invoice</mat-option>
              <mat-option value="Bank account details">Bank account details</mat-option>
              <mat-option value="Confirmation Letter concerning the bank details">Confirmation Letter concerning the
                bank details</mat-option>
              <mat-option value="Loan for use of Renault specific Tooling (CPUO)">Loan for use of Renault specific
                Tooling (CPUO)</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="uploadDocTypeError == true">Please enter Document name!!!</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label for="file">Upload PDF file only (max. 20 MB) <span class="element_astrick">*</span></label>
            <input type="file" #inputUpload id="file" (change)="changeListener($event)"
              class="form-control form-control-sm border-0" accept=".pdf" />
            <span class="text-cb4b32" *ngIf="selectFileError == true">Please select a File!!!</span>
            <span class="text-cb4b32" *ngIf="uploadDocError == true">{{ uploadDocMessage }}</span>
            <span class="text-cb4b32" *ngIf="DocTypeError == true">Only PDF files are accepted. Please print your
              document into a PDF file before uploading it.</span>
            <span class="text-cb4b32" *ngIf="fileSizeError == true">This file exceeds the limit of 20 MB.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="addDocPayingCompanySelect"> Paying Company </label>
            <mat-select id="addDocPayingCompanySelect" class="form-control form-control-sm"
              [(ngModel)]="addDocPayingCpy" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option value="" *ngIf="boolForPayingCpySelect == false"></mat-option>
              <div *ngFor="let cpy of PayingInfo">
                <ng-container *ngIf="cpy.approvalModificationStatus != 'ARCHIVED'">
                  <mat-option value="{{ cpy.clientCompanyLegalName }}">
                    {{ cpy.clientCompanyLegalName ? cpy.clientCompanyLegalName : "" }}
                  </mat-option>
                </ng-container>
              </div>
            </mat-select>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableUploadBtn == true"
            (click)="uploadDocToSP()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> Save </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openAddGenDocumentModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddGenDocument">
          Add Document
          <button type="button" class="close" id="closeAddGenDocModal" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="addGenDocTypeSelect"> Document Type <span class="element_astrick">*</span> </label>
            <mat-select id="addGenDocTypeSelect" class="form-control form-control-sm"
              [(ngModel)]="documentTypeModel" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option  class="option-width" value="A-RENAULT General Terms and Conditions of Purchasing">A-RENAULT General Terms and
                Conditions of Purchasing</mat-option>
              <mat-option value="E-INFOSITE">E-INFOSITE</mat-option>
              <mat-option value="J-RENAULT CLAIM COMPENSATION PROCEDURE">J-RENAULT CLAIM COMPENSATION
                PROCEDURE</mat-option>
              <mat-option value="K-RENAULT GROUP Supplier Code of Conduct">K-RENAULT GROUP Supplier Code of
                Conduct</mat-option>
              <mat-option value="K-RENAULT GROUP Global Framework Agreement">K-RENAULT GROUP Global Framework
                Agreement</mat-option>
              <mat-option value="K-RENAULT GROUP CSR Guidelines">K-RENAULT GROUP CSR Guidelines</mat-option>
              <mat-option value="M-CYBERSECURITY APPENDIX - ECU">M-CYBERSECURITY APPENDIX - ECU</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="uploadDocTypeError == true">Please enter Document name!!!</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label for="file1">Upload PDF file only (max. 20 MB)<span class="element_astrick">*</span></label>
            <input type="file" #inputGenUpload id="file1" (change)="changeGenListener($event)"
              class="form-control form-control-sm border-0" accept=".pdf" />
            <span class="text-cb4b32" *ngIf="selectFileError == true">Please select a File!!!</span>
            <span class="text-cb4b32" *ngIf="uploadDocError == true">{{ uploadDocMessage }}</span>
            <span class="text-cb4b32" *ngIf="DocTypeError == true">Only PDF files are accepted. Please print your
              document into a PDF file before uploading it.</span>
            <span class="text-cb4b32" *ngIf="fileSizeError == true">This file exceeds the limit of 20 MB.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableUploadBtn == true"
            (click)="uploadGenDoc()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> Save </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditDocStatus" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelEditDocStatus">
          Edit Company Document Status
          <button type="button" class="close" id="closeEditDocStatus" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="editDocStatusSelect">Status </label>
            <mat-select id="editDocStatusSelect" class="form-control form-control-sm" [(ngModel)]="documentStatusModel"
              panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="Pending">Pending</mat-option>
              <mat-option value="Active" *ngIf="showForSupplier == true">Active</mat-option>
              <mat-option value="Archived">Archived</mat-option>
            </mat-select>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateDocumentStatus()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> Save </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showAddSitesSteps" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddSite">
          Add Site
          <button type="button" class="close" id="closeSiteAddSteps" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <ul class="row m-0 nav list-view p-0 pt-1">
              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> Field Validation - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="!validationSuccess" />
                  <span class="text-success" *ngIf="validationSuccess == true">Success</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> Get Site Assignment - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="siteAssignmentGet == 'loading'" />
                  <span class="text-success" *ngIf="siteAssignmentGet == 'success'">Success</span>
                  <span class="text-danger" *ngIf="siteAssignmentGet == 'error'">Error</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> Access Point - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="acpCreation == 'loading'" />
                  <span class="text-success" *ngIf="acpCreation == 'success'">Success</span>
                  <span class="text-danger" *ngIf="acpCreation == 'error'">Error</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> Business Entity - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="businessECreation == 'loading'" />
                  <span class="text-success" *ngIf="businessECreation == 'success'">Success</span>
                  <span class="text-danger" *ngIf="businessECreation == 'error'">Error</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> BvD Associated - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="bvdAssoCreation == 'loading'" />
                  <span class="text-success" *ngIf="bvdAssoCreation == 'success'">Success</span>
                  <span class="text-danger" *ngIf="bvdAssoCreation == 'error'">Error</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> Site Assignment - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="siteAssignCreation == 'loading'" />
                  <span class="text-success" *ngIf="siteAssignCreation == 'success'">Success</span>
                  <span class="text-danger" *ngIf="siteAssignCreation == 'error'">Error</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> Site Name update - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="siteNameUCreation == 'loading'" />
                  <span class="text-success" *ngIf="siteNameUCreation == 'success'">Success</span>
                  <span class="text-danger" *ngIf="siteNameUCreation == 'error'">Error</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold"> New Site Link Created - </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="finalSiteCreation == 'loading'" />
                  <span class="text-success" *ngIf="finalSiteCreation == 'success'">Success</span>
                  <span class="text-danger" *ngIf="finalSiteCreation == 'error'">Error</span>
                </span>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showPayingStatusUpdate" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel1">
          Edit Paying Company Status
          <button type="button" class="close" id="closeshowPayingStatusUpdate" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="payingCompanyStatusSelect">Status </label>
            <mat-select id="payingCompanyStatusSelect" class="form-control form-control-sm"
              [(ngModel)]="payingCpyStatus" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <mat-option *ngFor="let status of payingCpyOptions" [value]="status">{{ status }}</mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="payingCpyStatusError == true">Please select status!!!</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updatePayingCompanyStatus()"
            [disabled]="disablePayingStatusBtn == true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">Save</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="sendReqtoSuppModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel2">
          Launch a workflow
          <button type="button" class="close" id="closesendReqtoSupp" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold sendSupRec" for="sendRequestTypeSelect"> Type of Request<span class="astricRed">*</span>
            </label>
            <mat-select id="sendRequestTypeSelect" class="form-control form-control-sm" [(ngModel)]="selectedSendRequest"
              panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="acc_homologation"> 1- Accounting homologation </mat-option>
            </mat-select>
            <span class="text-cb4b32" *ngIf="sendRequestError == true">Please select Request!!!</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="checkSelectedReuqest()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">Save</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWarningSendReq" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel3">
          Warning
          <button type="button" class="close" id="closeshowWarningSendReq" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              {{ warningForSendReq }}
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showAddSiteHq" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel4">
          Add Site
          <button type="button" class="close" id="closeshowAddSiteHq" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0">
        <section class="row m-0 bg-white no-shadow maxh-420 overflow-y-scroll">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="showAddSiteLoading == false">
            <div class="font-weight-bold ml-5" *ngIf="addSiteBvdIdData.length > 0">
              <div *ngFor="let row of addSiteBvdIdData" class="form-group">
                <label class="container" for="checkbox-disabled-{{ row.BRANCH_BVD_ID_NUMBER }}" *ngIf="row.disableCheck">
                  <input type="checkbox" id="checkbox-disabled-{{ row.BRANCH_BVD_ID_NUMBER }}" checked="checked" (click)="returnNone()" (keydown.enter)="returnNone()"
                    (keydown.space)="returnNone()" tabindex="0" />
                  <span class="checkmark br-20p"></span>
                </label>
                <label class="p-0 m-0 ml-3 d-flex align-items-start" *ngIf="!row.disableCheck">
                  <input type="checkbox" id="checkbox-{{ row.BRANCH_BVD_ID_NUMBER }}" class="mt-1 edit pos-abs"
                    (change)="selectCheckBox($event, row.BRANCH_BVD_ID_NUMBER)" [disabled]="disableCheckbox == true" />
                  <span class="ml-3">{{ row.BRANCH_NAME ? row.BRANCH_NAME : "" }}</span>
                </label>
                <p class="p-0 m-0 ml-3" *ngIf="row.disableCheck">
                  {{ row.BRANCH_NAME ? row.BRANCH_NAME : "" }}
                </p>
                <div class="ml-3 pt-1">{{ row.BRANCH_BVD_ID_NUMBER ? row.BRANCH_BVD_ID_NUMBER : "" }}</div>
                <div class="ml-3 pt-1">{{ row.BRANCH_ADDRESS_LINE1 ? row.BRANCH_ADDRESS_LINE1 : "" }}</div>
                <div class="ml-3 pt-1">{{ row.BRANCH_POSTCODE ? row.BRANCH_POSTCODE : "" }}</div>
                <div class="ml-3 pt-1">{{ row.BRANCH_CITY ? row.BRANCH_CITY : "" }}</div>
                <div class="ml-3 pt-1">{{ row.BRANCH_COUNTRY_ISO_CODE ? row.BRANCH_COUNTRY_ISO_CODE : "" }}</div>
              </div>
            </div>
            <div *ngIf="addSiteBvdIdData.length == 0 && showAddSiteLoading == false" class="text-center">
              <p class="font-weight-bold">No Results Found</p>
            </div>
          </div>

          <ng-container *ngIf="showAddSiteProcessing">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="showAddSiteLoading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-1"
            [disabled]="disableImportSite == true" (click)="importSelectedSites()">
            <mat-icon svgIcon="upload" class="img-btn h-18 w-20"></mat-icon><span class="float-right"> Import </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showAddSiteHqSteps" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel5">
          Add Site
          <button type="button" class="close" id="closeshowAddSiteHqSteps" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0">
        <section class="row m-0 bg-white no-shadow maxh-420 overflow-y-scroll">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="showAddSiteLoading == false">
            <div *ngIf="showAddSiteProcessing == true">
              <span *ngIf="showAddSiteProcessing == true"><img src="assets/images/loading.gif"
                  alt="loading..." /></span>
              <span class="pl-2 font-weight-bold text-5cba63"
                *ngIf="addSiteCurrentStatus != 'BvD interface API error (Timeout)'">
                {{ addSiteCurrentStatus }}
              </span>
              <span class="pl-2 font-weight-bold text-cb4b32"
                *ngIf="addSiteCurrentStatus == 'BvD interface API error (Timeout)'">
                {{ addSiteCurrentStatus }}
              </span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showSelectCountryId" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-9p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel6">
          Select Country
          <button type="button" class="close" id="closeshowSelectCountryId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-select class="form-control" name="countrySelect" id="" [(ngModel)]="selectedCustomCountry"
              panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="{{ coun }}" *ngFor="let coun of countrySelList">{{ coun }}</mat-option>
            </mat-select>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="checkSelRunSite()">OK</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="sentToBuyer" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-9p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddSiteHq">
          Successful
          <button type="button" class="close" id="closeSentToBuyer" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">The form has been sent back to the Buyer!</p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="reloadCurrentPage()">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningForRoleUpdate" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelAddSiteHqSteps">
          Warning
          <button type="button" class="close" id="closeArchiveCpy4" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">The Role selected already exists for the person.</p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmDeleteDocumentModal" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelShowSelectCountryId">
          Warning
          <button type="button" class="close" id="closeDelSharepointDoc" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fs-14 fw-bold"> Do you confirm the deletion of the document ? </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue bg-cb4b32" (click)="delSPfile()">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmDeletepayingCompany" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold" id="exampleModalLabelSentToBuyer" style="margin-left:14px;">
          Warning
          <button type="button" class="close" id="closeconfirmDeletepayingCompany" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fs-14">
              Do you confirm the removal of the Paying Company assignment <br />
              <strong>{{ payingCmpName }} ({{ payingCmpCode }})</strong><br />
              from this Company?
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm bg-9e8b7a text-white b-none" (click)="deletepayingCmp()">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Remove </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWorkflowValidation" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-9p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelWarningForRoleUpdate">
          Workflow Validation
          <button type="button" class="close" id="closeWorkflowValidation" #closeBtn data-dismiss="modal"
            aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="!validatingWorkflow && checkboxSelect">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="confirmationOption"
                id="confirmationCheckbox" />
              <label class="form-check-label fontBold" for="confirmationCheckbox">
                I confirm that the supplier has been approved through a RPC (Renault Panel Committee) within the past 3
                years or a NSQV (New
                Supplier Quick Validation) within the past 6 months, and has received a favorable TIM assessment, along
                with financial and
                GREF quotations.
              </label>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="!validatingWorkflow && checkboxSelect">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="documentsReviewOption"
                id="documentsReviewCheckbox" />
              <label class="form-check-label fontBold" for="documentsReviewCheckbox">
                Documents to be reviewed by the validator:<br />
                -TIM result<br />
                -Financial quotation<br />
                -GREF quotation<br />
                -Strategy: RPC minutes or SDC document in case of New Supplier Quick Validation (NSQV) process
              </label>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="wkfValidationNotesInput"> NOTES :</label>
            <textarea id="wkfValidationNotesInput" class="form-control form-control-sm"
              [(ngModel)]="wkfValNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
                (click)="resetWkfValNotesModel()" (keyup.enter)="resetWkfValNotesModel()" tabindex="0">
                ×
              </button></span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div *ngIf="validatingWorkflow" class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0" *ngIf="reqType">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            [disabled]="validatingWorkflow">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="validateWkfNoteRoute()"
            [disabled]="workflowValidationLoading == true || !isValidationFormComplete()">
            <div class="icon-text-container">
              <mat-icon svgIcon="confirm" alt="greentick" class="rounded-circle svg-icon pr-2"> </mat-icon>
              <span>Validate</span>
            </div>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWorkflowRejection" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-9p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelConfirmDeleteDocument">
          Reject The Request
          <button type="button" class="close" id="closeWorkflowRejection" #closeBtn data-dismiss="modal"
            aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="wkfRejectionNotesInput"> NOTES :<span class="element_astrick">*</span></label>
            <textarea id="wkfRejectionNotesInput" class="form-control form-control-sm"
              [(ngModel)]="wkfRejNotesModel" (keyup)="checkCommentsField()"
              maxlength="1000">
            </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
                (click)="resetWkfRejNotesModel()" (keyup.enter)="resetWkfRejNotesModel()" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="rejectWorkflowNotesError == true">Please Enter Notes inorder to reject a
              workflow!!!</span>
          </div>
          <div *ngIf="validatingWorkflow" class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            [disabled]="validatingWorkflow == true">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-red bg-cb4b32" (click)="rejectWkfNoteRoute()"
            [disabled]="workflowValidationLoading == true">
            <mat-icon class="h-18 mr-2" svgIcon="cancel"></mat-icon><span class="float-right"> Reject </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWorkflowInfoRequest" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-9p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelConfirmDeletePayingCompany">
          More Information Request
          <button type="button" class="close" id="closeWorkflowInfoRequest" #closeBtn data-dismiss="modal"
            aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="wkfInfoNotesInput"> NOTES :</label>
            <textarea id="wkfInfoNotesInput" class="form-control form-control-sm"
              [(ngModel)]="wkfInfoNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear cancel"
                (click)="resetWkfInfoNotesModel()" (keyup.enter)="resetWkfInfoNotesModel()" tabindex="0">
                ×
              </button></span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div *ngIf="validatingWorkflow" class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            [disabled]="validatingWorkflow">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="infoWkfNoteRoute()"
            [disabled]="workflowValidationLoading == true">
            <mat-icon svgIcon="info" class="w-19 h-21" alt="edit"></mat-icon><span
              class="float-right pl-2">Request</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openEditModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabelShowWorkflowValidation">
          Edit <span *ngIf="TypePopup == 'BVD'">BVD ID</span>
          <span *ngIf="TypePopup == 'DUNS'">DUNS</span>
          <span *ngIf="TypePopup == 'BPN'">BPN</span> by <span class="label-darkblue">ADMIN</span>
          <button type="button" class="close" id="closemodal" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="editCompanyIdentifierInput">
              <span *ngIf="TypePopup == 'BVD'">BVD ID</span>
              <span *ngIf="TypePopup == 'DUNS'">DUNS</span>
              <span *ngIf="TypePopup == 'BPN'">BPN</span>
            </label>
            <input id="editCompanyIdentifierInput" class="pr-2" class="form-control form-control-sm form-control-paddings"
              [(ngModel)]="editIdValueModel" [type]="TypePopup === 'DUNS' ? 'text' : 'text'"
              [max]="TypePopup === 'DUNS' ? 999999999 : 524288"
              (input)="TypePopup === 'DUNS' ? restrictDunsInput($event) : restrictInput($event)"
              (keyup)="checkForIds(editIdValueModel, 'editIdValueModel', 'editIdModelError')"
              (ngModelChange)="editIdValueModel = $event.toUpperCase()"
              (ngModelChange)="validateLength($event, TypePopup)" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                class="ng-clear bg-white cancel" (click)="resetId('bvdid', TypePopup)"
                (keyup.enter)="resetId('bvdid', TypePopup)" tabindex="0">
                ×
              </button></span>
            <span class="text-cb4b32" *ngIf="editIdModelError == true && TypePopup == 'BVD'">Please Enter Bvd
              Id!!!</span>
            <span class="text-cb4b32" *ngIf="editIdModelError == true && TypePopup == 'DUNS'">Please Enter
              DUNS!!!</span>
            <span class="text-cb4b32" *ngIf="editIdModelError == true && TypePopup == 'BPN'">Please Enter BPN!!!</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 w-100">
          <div *ngIf="requestButton && TypePopup == 'BPN'" class="pl-5">
            <button type="button" class="btn btn-custom btn-blue mt-n14 mb-13 ml-n4" data-toggle="modal">BPN-L
              Request</button>
          </div>
          <button type="button" class="btn btn-custom btn-custom-sm mr-1 bg-ec051d"
            (click)="openCnfArchiveModal('delete')">
            <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon><span class="float-right"> Delete </span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="c('archive')"
            *ngIf="showArchivedId == false">
            Archive
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveModal('unarchive')"
            *ngIf="showArchivedId == true">
            Unarchive
          </button>
          <article class="float-right">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableSaveBtn == true"
              (click)="saveIds()">
              <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> Save </span>
            </button>
          </article>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfArchiveBvdId" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel7">
          <span *ngIf="this.TypePopup == 'BVD'">Archive BVD ID</span>
          <span *ngIf="this.TypePopup == 'DUNS'">Archive DUNS</span>
          <span *ngIf="this.TypePopup == 'BPN'">Archive BPN</span>
          <button type="button" class="close" id="closeCnfArchiveBvdId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span *ngIf="this.TypePopup == 'BVD'">Do you want to archive this BVD ID ? </span>
            <span *ngIf="this.TypePopup == 'DUNS'">Do you want to archive this DUNS ?</span>
            <span *ngIf="this.TypePopup == 'BPN'">Do you want to archive this BPN ?</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="archiveIds(this.TypePopup)">Archive</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfDeleteBvdId" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel8">
          <span *ngIf="this.TypePopup == 'BVD'">Delete BVD ID</span>
          <span *ngIf="this.TypePopup == 'DUNS'">Delete DUNS</span>
          <span *ngIf="this.TypePopup == 'BPN'">Delete BPN</span>
          <button type="button" class="close" id="closeCnfDeleteBvdId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span *ngIf="this.TypePopup == 'BVD'">Do you want to Delete this BVD ID ?</span>
            <span *ngIf="this.TypePopup == 'DUNS'">Do you want to Delete this DUNS ?</span>
            <span *ngIf="this.TypePopup == 'BPN'">Do you want to Delete this BPN ?</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="DeleteIds(this.TypePopup)">Delete</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfUnArchiveBvdId" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel9">
          <span *ngIf="this.TypePopup == 'BVD'">Unarchive BVD ID</span>
          <span *ngIf="this.TypePopup == 'DUNS'">Unarchive DUNS</span>
          <span *ngIf="this.TypePopup == 'BPN'">Unarchive BPN</span>
          <button type="button" class="close" id="closeCnfUnArchiveBvdId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span *ngIf="this.TypePopup == 'BVD'">Do you want to unarchive this BVD ID ?</span>
            <span *ngIf="this.TypePopup == 'DUNS'">Do you want to unarchive this DUNS ?</span>
            <span *ngIf="this.TypePopup == 'BPN'">Do you want to unarchive this BPN ?</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="UnarchiveIds(this.TypePopup)">Unarchive</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showIdStatus" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel10">
          Warning
          <button type="button" class="close" id="closeNoShortNameOrCity" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              <span>{{ statusText }}</span>
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="notesHistory" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-800 ml-n30p">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel11">
          Workflow History
          <button type="button" class="close" id="closeNotesHistory" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div *ngIf="historyLoading">
        <div class="text-center">
          <img src="assets/images/loading.gif" alt="loading..." />
        </div>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive" *ngIf="requestForNotesHistory && !historyLoading">
        <div class="info-container mx-4 mb-2">
          <div class="info-row">
            <div class="label">Request Id:</div>
            <div class="value">
              <span class="text-60504A">{{ requestForNotesHistory?.requestId }}</span>&nbsp;
              <span>({{ requestForNotesHistory?.strRequestType }})</span>
            </div>
          </div>

          <div class="info-row">
            <div class="label">Company:</div>
            <div class="value">{{ requestForNotesHistory?.allianceId }} {{ requestForNotesHistory?.supplierName }}</div>
          </div>

          <div class="info-row" *ngIf="requestForNotesHistory?.requestor">
            <div class="label">Requestor:</div>
            <div class="value">
              <a href="mailto:{{ requestForNotesHistory?.RequestorMailId }}?subject=ISA - {{ requestForNotesHistory?.requestId }} / {{
                  requestForNotesHistory?.supplierName
                }}" class="underline-pointer color-47525E">
                {{ requestForNotesHistory?.requestor?.displayName }}
              </a>
            </div>
          </div>

          <div class="info-row" *ngIf="requestForNotesHistory?.approver">
            <div class="label">Approver:</div>
            <div class="value" [ngStyle]="approverColor(requestForNotesHistory?.workflowOwnerWithRole)">
              {{ requestForNotesHistory?.approver }}
              <button class="edit ml-2 cancel" *ngIf="
                  requestForNotesHistory['status'] == 'In progress' &&
                  requestForNotesHistory['workflowOwnerWithRole'] != '' &&
                  (roleVariableHide || superUserShow)
                " (click)="toggleApproverEdit()" (keyup.enter)="toggleApproverEdit()" tabindex="0">
                <mat-icon class="editIconStyle" svgIcon="edit" alt="edit" data-toggle="modal"></mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="info-row mx-4 mt-3">
          <div class="label">Status:</div>
          <div class="value">
            <span class="group-status px-3 mr-1 nowrap" [ngStyle]="{
                background: colorForWorkflow[requestForNotesHistory?.status],
                'min-width': '82px'
              }">
              {{ requestForNotesHistory?.status }}
            </span>
          </div>
        </div>
        <br />
        <div *ngIf="!approverEdit">
          <table class="table m-0">
            <thead class="bg-f5f5f5">
              <tr class="col p-0">
                <th class="sortDecorationunderline" (click)="sort('requestor')"
                  (keydown)="onHeaderKeyDown($event, 'requestor')" tabindex="0">
                  User
                </th>
                <th class="sortDecorationunderline" (click)="sort('role')" (keydown)="onHeaderKeyDown($event, 'role')"
                  tabindex="0">
                  Role
                </th>
                <th class="sortDecorationunderline" (click)="sort('validation')"
                  (keydown)="onHeaderKeyDown($event, 'validation')" tabindex="0">
                  Validation
                </th>
                <th class="sortDecorationunderline w-20p" (click)="sort('notes')"
                  (keydown)="onHeaderKeyDown($event, 'notes')" tabindex="0">
                  Notes
                </th>
                <th class="sortDecorationunderline" (click)="sort('date')" (keydown)="onHeaderKeyDown($event, 'date')"
                  tabindex="0">
                  Date
                </th>
              </tr>
            </thead>
            <tbody *ngIf="requestForNotesHistory">
              <ng-container
                *ngFor="let detail of requestForNotesHistory['historys'] | orderBy: key : reverse; let i = index">
                <tr class="col forColor p-0">
                  <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{ detail.requestor
                    }}</td>
                  <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                    {{ detail.role ? detail.role : "-" }}
                  </td>
                  <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                    <mat-icon *ngIf="detail.route == 'OK'" svgIcon="confirm" alt="greentick"
                      class="rounded-circle svg-icon green pr-2"></mat-icon>
                    <mat-icon *ngIf="detail.route == 'KO'" svgIcon="less" alt="redClose"
                      class="rounded-circle red pr-2"></mat-icon>
                    <mat-icon *ngIf="detail.route == 'More info needed'" svgIcon="information"
                      class="info-color pr-2"></mat-icon>
                    <img src="assets/images/Submitted.png" alt="Submitted" class="rounded-circle"
                      *ngIf="detail.route == 'Submitted'" />
                  </td>
                  <td
                    class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-left line-break-anywhere">
                    {{ detail.comment ? detail.comment : "-" }}
                  </td>
                  <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                    {{ detail.date ? (detail.date | date: "yyyy-MM-dd") : "-" }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
            <tbody *ngIf="requestForNotesHistory.length == 0">
              <tr>
                <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
              </tr>
            </tbody>

            <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
          </table>
        </div>
        <div *ngIf="approverEdit">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold sendSupRec" for="newApproverInput"> New Approver <span
                class="astricRed">*</span></label>
            <input id="newApproverInput" type="text" class="form-control form-control-sm" (focus)="focusFunction('sam')"
              [(ngModel)]="senReqSamMOdel" (keyup)="checkvalidateField()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button *ngIf="senReqSamMOdel != ''" class="ng-clear cancel"
                (click)="resetSendReqToSupp('senReqSamMOdel')" (keyup.enter)="resetSendReqToSupp('senReqSamMOdel')"
                tabindex="0">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
              <button *ngIf="senReqSamMOdel == ''" data-toggle="modal" data-target="#ArcaPopup" class="ng-clear cancel"
                (click)="lookupArca('sam')" (keyup.enter)="lookupArca('sam')" tabindex="0">
                <mat-icon class="pos-rel right-6 bottom-3" svgIcon="search"></mat-icon>
              </button>
            </span>
            <span class="text-cb4b32" *ngIf="senReqSamMOdelError == true">Please enter the MANAGER</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold sendSupRec" for="transferNotesInput"> Transfer NOTES </label>
            <textarea id="transferNotesInput" class="form-control form-control-sm" [(ngModel)]="senReqNotesMOdel"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="pos-rel right-11"
                class="ng-clear cancel" (click)="resetSendReqToSupp('senReqNotesMOdel')"
                (keyup.enter)="resetSendReqToSupp('senReqNotesMOdel')" tabindex="0">
                ×
              </button></span>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button *ngIf="!approverEdit" type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeCatAuthState3">
            Close
          </button>
          <button *ngIf="approverEdit" [disabled]="senReqSamMOdel == ''" type="button"
            class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeCatAuthState4"
            (click)="sendToNewApprover(requestForNotesHistory, senReqSamMOdel, senReqNotesMOdel)">
            Send to New Approver
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningBvdportfolio" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel12">
          Warning
          <button type="button" class="close" id="closeupdateaddbvdid1" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              {{ companyBasicInfo ? companyBasicInfo["legalName"] : "" }} seems to have its BvD ID {{ sitebvidid }}
              changed to
              {{ bvdidNumber }}. Do you want to update it before adding it into the Portfolio ?
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
            (click)="UpdateaddBvDID()">Update/add</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningbvdnotpresentinOrbis" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content ml-n4px">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel13">
          Warning
          <button type="button" class="close" id="closeupdateaddbvdid2" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              This BvD ID {{ sitebvidid }} does not exist in Orbis Database. Please check it before retrying again.
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Ok</button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="ChangeGuo" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content w-900 ml-n34p">
      <div class="modal-header border-0">
        <h5 class="modal-title font-weight-bold text-center" id="exampleModalLabel14">
          Check GUO
          <button type="button" class="close" id="closeCheckBvdModal" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>
      </div>

      <div class="modal-body px-0 pb-0">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
            <div class="modal-body row m-0 p-0 table-responsive">
              <table class="table m-0">
                <thead class="bg-f5f5f5">
                  <tr class="col p-0">
                    <th class="text-center w-1p">ISA database</th>
                    <th class="text-center w-1p">ORBIS database</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td *ngIf="show == false" class="w-1p">
                      <div class="ml-10p">
                        <h4 class="title ml-8 mt-4 mb-3">Group</h4>
                        <p class="mb-2">
                          <span class="pl-1">
                            {{ groupAssignToCpy ? groupAssignToCpy : "-" }}
                          </span>
                        </p>
                        <p class="mb-2" *ngIf="ISAdata.length > 0">
                          <span class="pl-1 font-weight-bold">BvD ID : </span>
                          <span class="pl-1" id="bold1-1">{{ IsaBvD ? IsaBvD : "--" }}</span>
                        </p>
                        <p class="pl-1 mb-2" *ngIf="
                            ISAdata.length > 0 &&
                            ((ISAdata[0].wayNumber != '' && ISAdata[0].wayNumber != undefined) ||
                              (ISAdata[0].streetName != '' && ISAdata[0].streetName != undefined))
                          ">
                          {{ ISAdata[0].wayNumber }} {{ ISAdata[0].streetName }}
                        </p>
                        <p class="pl-1 mb-2" *ngIf="
                            ISAdata.length > 0 &&
                            ISAdata[0].additionalInformation != '' &&
                              ISAdata[0].additionalInformation != undefined &&
                              (orbisBvdData ? (orbisBvdData['ADDRESS_LINE3'] != null ? true : false) : false)
                          ">
                          {{ ISAdata[0].additionalInformation }}
                        </p>
                        <p class="pl-1 mb-2"
                          *ngIf="ISAdata.length > 0 && ISAdata[0].postalCode != '' && ISAdata[0].postalCode != undefined">
                          {{ ISAdata[0].postalCode }} &nbsp; {{ ISAdata[0].cityName }}
                        </p>
                        <p class="pl-1 mb-2"
                          *ngIf="ISAdata.length > 0 && ISAdata[0].territorialDivision != '' && ISAdata[0].territorialDivision != undefined">
                          {{ ISAdata[0].territorialDivision }}
                        </p>
                        <p class="pl-1 mb-2"
                          *ngIf="ISAdata.length > 0 && ISAdata[0].countryName != '' && ISAdata[0].countryName != undefined">
                          {{ ISAdata[0].countryName }}
                        </p>
                      </div>
                    </td>
                    <td *ngIf="show == true" class="w-1p">
                      <div class="text-center">
                        <h6>No group linked to the company</h6>
                      </div>
                    </td>
                    <td *ngIf="orbisBvdDataLoading == false && noGuo == false" class="w-1p">
                      <div class="ml-2p">
                        <h4 class="title ml-8 mt-4 mb-3">Group</h4>

                        <div *ngIf="companyBvdIdNotFound">
                          <p class="mb-2">The BVD ID of the company does not exist anymore in the ORBIS database</p>
                        </div>

                        <div *ngIf="guoBvdIdNotFound && !companyBvdIdNotFound">
                          <p class="mb-2">The BVD ID of the GUO of the company does not exist anymore in the ORBIS
                            database</p>
                        </div>
                        <div *ngIf="orbisBvdData && !companyBvdIdNotFound && !guoBvdIdNotFound">
                          <p class="mb-2">
                            <span class="pl-1" id="bold1-2">{{
                              orbisBvdData["GUO_NAME"]
                              ? orbisBvdData["GUO_NAME"][0]
                              ? orbisBvdData["GUO_NAME"][0]
                              : ""
                              : orbisBvdData.NAME
                              }}</span>
                          </p>
                          <p class="mb-2" *ngIf="orbisBvdData['BVD_ID_NUMBER']">
                            <span class="pl-1 font-weight-bold">BvD ID : </span>
                            <span class="pl-1" id="bold1-3">{{
                              orbisBvdData["BVD_ID_NUMBER"] ? (orbisBvdData["BVD_ID_NUMBER"] ?
                              orbisBvdData["BVD_ID_NUMBER"] : "") : ""
                              }}</span>
                          </p>
                          <p class="mb-2" *ngIf="orbisBvdData['ADDRESS_LINE1']">
                            <span class="pl-1" id="bold1-4">{{ orbisBvdData["ADDRESS_LINE1"] ?
                              orbisBvdData["ADDRESS_LINE1"] : "" }}</span>
                          </p>
                          <p class="mb-2" *ngIf="orbisBvdData['ADDRESS_LINE2']">
                            <span class="pl-1" id="bold1-5" *ngIf="orbisBvdData['ADDRESS_LINE2']">
                              {{ orbisBvdData["ADDRESS_LINE2"] ? orbisBvdData["ADDRESS_LINE2"] : "" }}</span>
                          </p>
                          <p class="mb-2" *ngIf="orbisBvdData['ADDRESS_LINE3']">
                            <span class="pl-1" id="bold1-6" *ngIf="orbisBvdData['ADDRESS_LINE3']">
                              {{ orbisBvdData["ADDRESS_LINE3"] ? orbisBvdData["ADDRESS_LINE3"] : "" }}</span>
                          </p>

                          <p class="mb-2" *ngIf="orbisBvdData['POSTCODE'] || orbisBvdData['CITY_STANDARDIZED']">
                            <span class="pl-1" id="bold1-7">
                              {{ orbisBvdData["POSTCODE"] ? orbisBvdData["POSTCODE"] : "" }} &nbsp;{{
                              this.commonService.hasNoSpecialCharacters(orbisBvdData["CITY_STANDARDIZED"],
                              orbisBvdData["CITY"])
                              }}
                            </span>
                          </p>
                          <p class="mb-2" *ngIf="orbisBvdData['COUNTRY']">
                            <span class="pl-1" id="bold1-8">
                              {{ orbisBvdData["COUNTRY"] ? orbisBvdData["COUNTRY"] : "" }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td *ngIf="noGuo == true">
                      <div class="text-center">
                        <h6>No GUO BvD in Orbis database</h6>
                      </div>
                    </td>
                    <div *ngIf="dataloading == true" class="loading-container">
                      <img src="assets/images/loading.gif" alt="loading..." />
                    </div>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 pt-0 pr-3">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">Close</button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- Edit Company Workflow Status Modal -->
<div class="modal fade" id="editCompanyWorkflowStatusModal" tabindex="-1" aria-modal="true"
  aria-labelledby="editCompanyWorkflowStatusModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="editCompanyWorkflowStatusModalLabel">
          Edit Workflow Status
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            id="closeCompanyWorkflowStatusModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <div class="form-group col-12">
          <label class="font-weight-bold" for="companyWorkflowStatusSelect">Workflow Status</label>
          <mat-select id="companyWorkflowStatusSelect" class="form-control form-control-sm dropdown-select"
            [(ngModel)]="companyWorkflowStatusModel"
            panelClass="dropdown-panel" [disableOptionCentering]="true" placeholder="-- Select --">
            <mat-option *ngFor="let opt of companyWorkflowStatusOptions" [value]="opt">{{ opt }}</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateCompanyWorkflowStatus()"
            [disabled]="disableCompanyWorkflowStatusBtn || companyWorkflowStatusModel === ''">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{ saveDatas }}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="d-none">
  <button id="btnForWarningNoArchiveAlcor" data-target="#openWarningNoArchiveAlcor" data-toggle="modal"></button>
  <button id="btnForWarningArchiveCpy" data-target="#openWarningForArchiveCpy" data-toggle="modal"></button>
  <button id="btnForMoreHQ" data-target="#openWarningForMoreHQ" data-toggle="modal"></button>
  <button id="btnSiteStepsLog" data-target="#showAddSitesSteps" data-toggle="modal"></button>
  <button id="btnSiteHqStepsLog" data-target="#showAddSiteHqSteps" data-toggle="modal"></button>
  <button id="btnForOpenSendReqToSupp" data-target="#sendReqtoSupp1" data-toggle="modal"></button>
  <button id="btnForOpenWarningSendReq" data-target="#showWarningSendReq" data-toggle="modal"></button>
  <button id="btnForSelectCountryId" data-target="#showSelectCountryId" data-toggle="modal"></button>
  <button id="btnForOpenRoleExistsWarning" data-target="#openWarningForRoleUpdate" data-toggle="modal"></button>
  <button id="btnForArcaPopup" data-target="#ArcaPopup" data-toggle="modal"></button>
  <button id="btnForPayingCompanyPopUp" data-target="#payingCompanySelectPopup" data-toggle="modal"></button>
  <button id="btnForCnfArchive" data-target="#CnfArchiveBvdId" data-toggle="modal"></button>
  <button id="btnForCnfUnArchive" data-target="#CnfUnArchiveBvdId" data-toggle="modal"></button>
  <button id="btnForDeleteBvd" data-target="#CnfDeleteBvdId" data-toggle="modal"></button>
  <button id="btnForStatus" data-target="#showIdStatus" data-toggle="modal"></button>
  <button id="btnForSentToBuyer" data-target="#sentToBuyer" data-toggle="modal"></button>
  <button id="btnForWarningBvdportfolio" data-target="#openWarningBvdportfolio" data-toggle="modal"></button>
  <button id="btnForbvdnotpresentinOrbis" data-target="#openWarningbvdnotpresentinOrbis" data-toggle="modal"></button>
  <button id="btnForblankupdate" data-target="#showBlankUpdateProcess" data-toggle="modal"></button>
  <button id="btnForDocumentValidation" data-target="#documentValidationModal" data-toggle="modal"></button>
  <button id="btnForQualifierValidation" data-target="#qualifierValidationModal" data-toggle="modal"></button>
</div>

<!-- Document Validation Modal -->
<div id="documentValidationModal" class="modal fade" tabindex="-1" aria-modal="true"
  aria-labelledby="documentValidationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-f0eeeb text-333">
        <h5 class="modal-title font-weight-bold text-center" id="documentValidationModalLabel">ACCOUNTING Document
          Required</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body bg-white text-333">
        <div class="p-12 br-4 bg-white text-333" role="alert">
          <strong>Missing ACCOUNTING Documents!</strong>
          <p class="mb-2">Please upload your documents to proceed with sending to buyer.</p>
          <p class="mb-0">At least one non-archived document is required in the documents section of the company.</p>
        </div>
        <div class="text-center">
          <a href="https://suppliers-new.renault.com/isa-information-page"
            target="_blank" class="btn bg-9e8b7a text-white b-none p-8-20 br-4">
            <i class="label"></i> User Guide
          </a>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn bg-9e8b7a text-white b-none p-6-20 br-4" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Qualifier Validation Modal -->
<div id="qualifierValidationModal" class="modal fade" tabindex="-1" aria-modal="true"
  aria-labelledby="qualifierValidationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-f0eeeb text-333">
        <h5 class="modal-title font-weight-bold text-center" id="qualifierValidationModalLabel">
          <i class="label"></i> Qualifier Validation Required
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body bg-white text-333">
        <div class="alert" role="alert">
          <p class="mb-2">At least one qualifier (other than Main Entrance) must be present on at least one site of the
            company.</p>
          <p class="mb-0"><em>Note: Main Entrance qualifier alone is not sufficient for validation.</em></p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn bg-9e8b7a text-white b-none p-6-20 br-4" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>